export const enpointCervinoWeb = {
  accountingSystem: {
    GetAllAccountingSystem: 'api/AccountingSystem/GetAllAccountingSystemsAsync',
  },
  accountingInterface: {
    ExportGeneralConsultation: 'api/AccountingInterface/ExportGeneralConsultation',
    GetColumnsForGeneralConsultationAsync: 'api/AccountingInterface/GetColumnsForGeneralConsultationAsync',
    GetAccountInterfacesForGeneralConsultation: 'api/AccountingInterface/GetAccountInterfacesForGeneralConsultation',
    GetAllBussinessDocumentsTypesForSelectAsync: 'api/AccountingInterface/GetAllBussinessDocumentsTypesForSelectAsync',
    GetFirstBussinessDocumentsTypeAsync: 'api/AccountingInterface/GetFirstBussinessDocumentsTypeAsync',
    GetAccountingInterfaceById: 'api/AccountingInterface/GetByIdAsync',
    CreateAccountingInterface: 'api/AccountingInterface/CreateAsync',
    UpdateAccountingInterface: 'api/AccountingInterface/UpdateAsync',
    SetActiveAccountingInterface: 'api/AccountingInterface/SetActiveAsync',
    DeleteAccountingInterface: 'api/AccountingInterface/DeleteAsync',
    GetAccountingInterfaceByKeys: 'api/AccountingInterface/GetAccountingInterfaceByKeysAsync',
    GetFirstAccountingInterfaceByKeys: 'api/AccountingInterface/GetFirstAccountingInterfaceByKeysAsync',
    GetLastAccountingInterfaceByKeys: 'api/AccountingInterface/GetLastAccountingInterfaceByKeysAsync',
    GetPreviusAccountingInterfaceByKeys: 'api/AccountingInterface/GetPreviusAccountingInterfaceByKeysAsync',
    GetNextAccountingInterfaceByKeys: 'api/AccountingInterface/GetNextAccountingInterfaceByKeysAsync',
    ExportCxc: 'api/AccountingInterface/ExportCxc',
    ExportAccounting: 'api/AccountingInterface/ExportAccounting',
    SendCountableMovement: 'api/AccountingInterface/SendCountableMovementAsync',
    //Servicios del detalle
    ExportDetailConsultation: 'api/AccountingInterface/ExportDetailConsultation',
    GetColumnsForDetailConsultationAsync: 'api/AccountingInterface/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailCaptureAsync: 'api/AccountingInterface/GetColumnsForDetailCaptureAsync',
    GetAccountingInterfaceDetailsForDetailConsultation: 'api/AccountingInterface/GetAccountingInterfaceDetailsForDetailConsultation',
    GetAccountingInterfaceDetailForSelection: 'api/AccountingInterface/GetAccountingInterfaceDetailForSelectionAsync',
    AddAccountingInterfaceDetails: 'api/AccountingInterface/AddAccountingInterfaceDetailsAsync',
    GetAccountingInterfaceDetailById: 'api/AccountingInterface/GetAccountingInterfaceDetailByIdAsync',
    RemoveAccountingInterfaceDetails: 'api/AccountingInterface/RemoveAccountingInterfaceDetailsAsync',
  },
  accountingModel: {
    CreateAccountingModel: 'api/AccountingModel/CreateAsync',
    DeleteAccountingModel: 'api/AccountingModel/DeleteAsync',
    GetAccountingModelByConsecutive: 'api/AccountingModel/GetAccountingModelByConsecutiveAsync',
    GetAccountingModelById: 'api/AccountingModel/GetByIdAsync',
    GetAllAccountingModelsForSelectAsync: 'api/AccountingModel/GetAllAccountingModelsForSelectAsync',
    GetFirstAccountingModelByKeysAsync: 'api/AccountingModel/GetFirstAccountingModelAsync',
    GetLastAccountingModelByKeysAsync: 'api/AccountingModel/GetLastAccountingModelAsync',
    GetNextAccountingModelByKeysAsync: 'api/AccountingModel/GetNextAccountingModelAsync',
    GetPreviusAccountingModelByKeysAsync: 'api/AccountingModel/GetPreviusAccountingModelByKeysAsync',
    UpdateAccountingModel: 'api/AccountingModel/UpdateAsync',
  },
  accountingModelDetail: {
    CreateAccountingModelDetail: 'api/AccountingModelDetail/CreateAsync',
    DeleteSomeDetails: 'api/AccountingModelDetail/DeleteSomeDetailsAsync',
    GetAccountingModelDetailById: 'api/AccountingModelDetail/GetByIdAsync',
    GetAccountingModelDetailsForCaptureTableAsync: 'api/AccountingModelDetail/GetAccountingModelDetailsForCaptureTableAsync',
    GetColumnsForCaptureTableAsync: 'api/AccountingModelDetail/GetColumnsForCaptureTableAsync',
    UpdateAccountingModelDetail: 'api/AccountingModelDetail/UpdateAsync',
  },
  advanceInvoice: {
    ExportGeneralConsultation: 'api/AdvanceInvoice/ExportGeneralConsultation',
    GetAdvanceInvoiceByKeys: 'api/AdvanceInvoice/GetAdvanceInvoiceByKeysAsync',
    GetAllAdvanceInvoicesWithPaginationAsync: 'api/AdvanceInvoice/GetAllAdvanceInvoicesWithPaginationAsync',
    GetByIdAsync: 'api/AdvanceInvoice/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/AdvanceInvoice/GetColumnsForGeneralConsultationAsync',
    GetFirstAdvanceInvoiceByKeys: 'api/AdvanceInvoice/GetFirstAdvanceInvoiceByKeysAsync',
    GetLastAdvanceInvoiceByKeys: 'api/AdvanceInvoice/GetLastAdvanceInvoiceByKeysAsync',
    GetPreviusAdvanceInvoiceByKeys: 'api/AdvanceInvoice/GetPreviusAdvanceInvoiceByKeysAsync',
    GetNextAdvanceInvoiceByKeys: 'api/AdvanceInvoice/GetNextAdvanceInvoiceByKeysAsync',
    SetAdvanceInvoiceStateAsync: 'api/AdvanceInvoice/SetAdvanceInvoiceStateAsync',
    UpdateAsync: 'api/AdvanceInvoice/UpdateAsync',
  },
  advanceInvoiceConcept: {
    GetAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination: 'api/AdvanceInvoiceConcept/GetAdvanceInvoiceConceptsByAdvanceInvoiceIdWithPagination',
    GetByIdAsync: 'api/AdvanceInvoiceConcept/GetByIdAsync',
    GetColumnsForConceptsAdvanceInvoiceAsync: 'api/AdvanceInvoiceConcept/GetColumnsForConceptsAdvanceInvoiceAsync',
    UpdateAsync: 'api/AdvanceInvoiceConcept/UpdateAsync',
  },
  advancePaymentApplied: {
    CreateAdvancePaymentApplied: 'api/AdvancePaymentApplied/CreateAsync',
    CreateSomeAdvancePaymentApplied: 'api/AdvancePaymentApplied/CreateSomeAsync',
    DeleteAdvancePaymentApplied: 'api/AdvancePaymentApplied/DeleteAsync',
    GetAdvancesAvailable: 'api/AdvancePaymentApplied/GetAdvancesAvailableAsync',
    GetAdvancePaymentAppliedById: 'api/AdvancePaymentApplied/GetByIdAsync',
    GetAppliedAdvancesByCashReceiptIdAsync: 'api/AdvancePaymentApplied/GetAppliedAdvancesByCashReceiptIdAsync',
    GetAppliedAdvances: 'api/AdvancePaymentApplied/GetAppliedAdvancesAsync',
    GetColumnsForAdvancePaymentsModalAsync: 'api/AdvancePaymentApplied/GetColumnsForAdvancePaymentsModalAsync',
    GetColumnsForCaptureTableAsync: 'api/AdvancePaymentApplied/GetColumnsForCaptureTableAsync',
    GetListAdvancePaymentsForSelectionAsync: 'api/AdvancePaymentApplied/GetListAdvancePaymentsForSelectionAsync',
    UpdateAdvancePaymentApplied: 'api/AdvancePaymentApplied/UpdateAsync',
  },
  article: {
    AttachImagesAsync: 'api/Article/AttachImagesAsync',
    AttachFilesToArticle: 'api/Article/AttachFilesToArticleAsync',
    CreateArticle: 'api/Article/CreateAsync',
    DeleteArticle: 'api/Article/DeleteAsync',
    DeleteImagesAsync: 'api/Article/DeleteImagesAsync',
    DownloadGuideImport: 'api/Article/DownloadGuideImport',
    ExportImportErrors: 'api/Article/ExportImportErrors',
    ExportGeneralConsultation: 'api/Article/ExportGeneralConsultation',
    ExportGeneralConsultationGeneric: 'api/Article/ExportGeneralConsultationGeneric',
    GetAllArticlesForSelectAsync: 'api/Article/GetAllArticlesForSelectAsync',
    GetAllArticlesByCompanyForSelectAsync: 'api/Article/GetAllArticlesByCompanyForSelectAsync',
    GetArticlesEquipmentLogbookForSelectAsync: 'api/Article/GetArticlesEquipmentLogbookForSelectAsync',
    GetAllArticlesGenericForSelectAsync: 'api/Article/GetAllArticlesGenericForSelectAsync',
    GetAllArticlesWithPagination: 'api/Article/GetAllArticlesWithPaginationAsync',
    GetAllArticleGenericsWithPaginationAsync: 'api/Article/GetAllArticleGenericsWithPaginationAsync',
    GetAllFamiliesForSelectAsync: 'api/Article/GetAllFamiliesForSelectAsync',
    GetAllInventoryUnitsForSelectAsync: 'api/Article/GetAllInventoryUnitsForSelectAsync',
    GetAllGroupsForSelectAsync: 'api/Article/GetAllGroupsForSelectAsync',
    GetAllRentalUnitsForSelectAsync: 'api/Article/GetAllRentalUnitsForSelectAsync',
    GetAllSubgroupsForSelectAsync: 'api/Article/GetAllSubgroupsForSelectAsync',
    GetAllSuppliesForSelectAsync: 'api/Article/GetAllSuppliesForSelectAsync',
    GetAllSuppliesDevolutionForSelectAsync: 'api/Article/GetAllSuppliesDevolutionForSelectAsync',
    GetAllTypeInventoriesForSelectAsync: 'api/Article/GetAllTypeInventoriesForSelectAsync',
    GetAllTypeArticlesForSelectAsync: 'api/Article/GetAllTypeArticlesForSelectAsync',
    GetArticleByCode: 'api/Article/GetArticleByCodeAsync',
    GetArticleById: 'api/Article/GetByIdAsync',
    GetArticleByName: 'api/Article/GetArticleByNameAsync',
    GetArticlesForSubrentalOutputs: 'api/Article/GetArticlesForSubrentalOutputsAsync',
    GetArticlesForInternalOrder: 'api/Article/GetArticlesForInternalOrderAsync',
    GetArticlesByTypes: 'api/Article/GetArticlesByTypesAsync',
    GetCleaningValueByArticleId: 'api/Article/GetCleaningValueByArticleId',
    GetColumnsForGeneralConsultation: 'api/Article/GetColumnsForGeneralConsultationAsync',
    GetColumnsForGeneralConsultationGenericAsync: 'api/Article/GetColumnsForGeneralConsultationGenericAsync',
    GetColumnsForArticlesByTypes: 'api/Article/GetColumnsForArticlesByTypesAsync',
    GetFilesToArticle: 'api/Article/GetFilesToArticleAsync',
    GetFirstArticleByKeys: 'api/Article/GetFirstArticleByKeysAsync',
    GetImagesAsync: 'api/Article/GetImagesAsync',
    GetLastArticleByKeys: 'api/Article/GetLastArticleByKeysAsync',
    GetNextArticleByKeys: 'api/Article/GetNextArticleByKeysAsync',
    GetPreviusArticleByKeys: 'api/Article/GetPreviusArticleByKeysAsync',
    GetRepairValueByArticleId: 'api/Article/GetRepairValueByArticleId',
    GetReplacementValueByArticleId: 'api/Article/GetReplacementValueByArticleId',
    ImportArticles: 'api/Article/ImportArticlesAsync',
    SetActiveArticle: 'api/Article/SetActive',
    SelectMainImageAsync: 'api/Article/SelectMainImageAsync',
    UpdateArticle: 'api/Article/UpdateAsync',
    ValidateBalances: 'api/Article/ValidateBalances',
    ValidateBalancesByEquipmentLogbook: 'api/Article/ValidateBalancesByEquipmentLogbook',
  },
  articleTask: {
    CloseTaskAsync: 'api/ArticleTask/CloseTaskAsync',
    CreateAsync: 'api/ArticleTask/CreateAsync',
    DeleteAsync: 'api/ArticleTask/DeleteAsync',
    ExecuteTaskAsync: 'api/ArticleTask/ExecuteTaskAsync',
    ExportGeneralConsultation: 'api/ArticleTask/ExportGeneralConsultation',
    GetAllArticlesAsync: 'api/ArticleTask/GetAllArticlesAsync',
    GetAllArticlesForSelectAsync: 'api/ArticleTask/GetAllArticlesForSelectAsync',
    GetAllArticleTasksWithPaginationAsync: 'api/ArticleTask/GetAllArticleTasksWithPaginationAsync',
    GetArticleTaskByKeys: 'api/ArticleTask/GetArticleTaskByKeysAsync',
    GetArticleTaskPendingAsync: 'api/ArticleTask/GetArticleTaskPendingAsync',
    GetByIdAsync: 'api/ArticleTask/GetByIdAsync',
    GetColumnsForArticlesAsync: 'api/ArticleTask/GetColumnsForArticlesAsync',
    GetColumnsForGeneralConsultationAsync: 'api/ArticleTask/GetColumnsForGeneralConsultationAsync',
    GetFirstArticleTaskByKeys: 'api/ArticleTask/GetFirstArticleTaskByKeysAsync',
    GetLastArticleTaskByKeys: 'api/ArticleTask/GetLastArticleTaskByKeysAsync',
    GetNextArticleTaskByKeys: 'api/ArticleTask/GetNextArticleTaskByKeysAsync',
    GetPreviusArticleTaskByKeys: 'api/ArticleTask/GetPreviusArticleTaskByKeysAsync',
    GetTotalArticleTaskPendingAsync: 'api/ArticleTask/GetTotalArticleTaskPendingAsync',
    UpdateAsync: 'api/ArticleTask/UpdateAsync',
  },
  audit: {
    AuditRentalBalance: 'api/Audit/AuditRentalBalance',
    ExportAuditRentalBalance: 'api/Audit/ExportAuditRentalBalance',
  },
  branch: {
    AttachConditionsAsync: 'api/Branch/AttachConditionsAsync',
    CreateBranch: 'api/Branch/CreateAsync',
    DeleteBranch: 'api/Branch/DeleteAsync',
    DeleteAttachConditionsAsync: 'api/Branch/DeleteAttachConditionsAsync',
    DownloadConditionsAsync: 'api/Branch/DownloadConditionsAsync',
    GetAllBranchByCompanyId: 'api/Branch/GetAllBranchByCompanyIdAsync',
    GetAllBranchesByCompanyIdForSelectAsync: 'api/Branch/GetAllBranchesByCompanyIdForSelectAsync',
    GetAllBranchesForSelectAsync: 'api/Branch/GetAllBranchesForSelectAsync',
    GetAllBranchesWithPaginationAsync: 'api/Branch/GetAllBranchesWithPaginationAsync',
    GetAllStoreForSelectAsync: 'api/Branch/GetAllStoreForSelectAsync',
    GetBranchByCode: 'api/Branch/GetBranchByCodeAsync',
    GetByIdAsync: 'api/Branch/GetByIdBranch',
    GetConditionsFilesAsync: 'api/Branch/GetConditionsFilesAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Branch/GetColumnsForGeneralConsultationAsync',
    GetFirstBranchByCompanyId: 'api/Branch/GetFirstBranchByCompanyIdAsync',
    GetFirstBranchByKeysAsync: 'api/Branch/GetFirstBranchByKeysAsync',
    GetFirstBranchByUserAuthenticatedAsync: 'api/Branch/GetFirstBranchByUserAuthenticatedAsync',
    GetLastBranchByKeysAsync: 'api/Branch/GetLastBranchByKeysAsync',
    GetNextBranchByKeysAsync: 'api/Branch/GetNextBranchByKeysAsync',
    GetPreviusBranchByKeysAsync: 'api/Branch/GetPreviusBranchByKeysAsync',
    UpdateBranch: 'api/Branch/UpdateAsync',
  },
  breakdown: {
    CreateBreakdownFromMasterSolution: 'api/Breakdown/CreateBreakdownFromMasterSolutionAsync',
    GetBreakdownById: 'api/Breakdown/GetByIdAsync',
    CreateBreakdown: 'api/Breakdown/CreateAsync',
    CreateMultipleBreakdowns: 'api/Breakdown/CreateMultipleBreakdownsAsync',
    UpdateBreakdown: 'api/Breakdown/UpdateAsync',
    DeleteBreakdown: 'api/Breakdown/DeleteAsync',
    DeleteSomeDetails: 'api/Breakdown/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/Breakdown/ExportDetailConsultation',
    ExportImportErrors: 'api/Breakdown/ExportImportErrors',
    ExportSolution: 'api/Breakdown/ExportSolution',
    GetAllBreakdownsWithPagination: 'api/Breakdown/GetAllBreakdownsWithPaginationAsync',
    GetAllBreakdownsByQuotationForCapture: 'api/Breakdown/GetAllBreakdownsByQuotationForCaptureAsync',
    GetBreakdownByQuotationDetailId: 'api/Breakdown/GetBreakdownByQuotationDetailIdAsync',
    GetColumnsForDetailConsultation: 'api/Breakdown/GetColumnsForDetailConsultationAsync',
    GetColumnsForBreakdownCapture: 'api/Breakdown/GetColumnsForBreakdownCaptureAsync',
    GetTotalBreakdownByQuotationDetailId: 'api/Breakdown/GetTotalBreakdownByQuotationDetailIdAsync',
    ApplyDiscount: 'api/Breakdown/ApplyDiscountAsync',
    TotalValueDistribute: 'api/Breakdown/TotalValueDistributeAsync',
    DownloadGuideImport: 'api/Breakdown/DownloadGuideImport',
    ImportBreakdownAsync: 'api/Breakdown/ImportBreakdownAsync',
    GetBreakdownByQuotationDetailToExportAsync: 'api/Breakdown/GetBreakdownByQuotationDetailToExportAsync',
    GetBreakdownByDetail: 'api/Breakdown/GetBreakdownByDetail',
    GetColumnsBreakdownByDetailIdAsync: 'api/Breakdown/GetColumnsBreakdownByDetailIdAsync',
    GetBreakdownByDetailIdAsync: 'api/Breakdown/GetBreakdownByDetailIdAsync',
  },
  bussinessDocumentsType: {
    CreateBussinessDocumentsType: 'api/BussinessDocumentsType/CreateAsync',
    DeleteBussinessDocumentsType: 'api/BussinessDocumentsType/DeleteAsync',
    ExportGeneralConsultation: 'api/BussinessDocumentsType/ExportGeneralConsultation',
    GetAllBussinessDocumentsClasssForSelectAsync: 'api/BussinessDocumentsType/GetAllBussinessDocumentsClasssForSelectAsync',
    GetAllBussinessDocumentsDianTypesForSelectAsync: 'api/BussinessDocumentsType/GetAllBussinessDocumentsDianTypesForSelectAsync',
    GetAllBussinessDocumentsTypesWithPaginationAsync: 'api/BussinessDocumentsType/GetAllBussinessDocumentsTypesWithPaginationAsync',
    GetBussinessDocumentsTypeById: 'api/BussinessDocumentsType/GetByIdAsync',
    GetBussinessDocumentsTypeByKeys: 'api/BussinessDocumentsType/GetBussinessDocumentsTypeByKeysAsync',
    GetBussinessDocumentsTypesByClassByBranchByEnterprise: 'api/BussinessDocumentsType/GetBussinessDocumentsTypesByClassByBranchByEnterpriseAsync',
    GetBussinessDocumentsTypesForSelectionAsync: 'api/BussinessDocumentsType/GetBussinessDocumentsTypesForSelectionAsync',
    GetColumnsForGeneralConsultationAsync: 'api/BussinessDocumentsType/GetColumnsForGeneralConsultationAsync',
    GetColumnsForSelectionAsync: 'api/BussinessDocumentsType/GetColumnsForSelectionAsync',
    GetFirstBussinessDocumentsType: 'api/BussinessDocumentsType/GetFirstBussinessDocumentsTypeAsync',
    GetFirstBussinessDocumentsTypeByKeysAsync: 'api/BussinessDocumentsType/GetFirstBussinessDocumentsTypeByKeysAsync',
    GetLastBussinessDocumentsTypeByKeysAsync: 'api/BussinessDocumentsType/GetLastBussinessDocumentsTypeByKeysAsync',
    GetNextBussinessDocumentsTypeByKeysAsync: 'api/BussinessDocumentsType/GetNextBussinessDocumentsTypeByKeysAsync',
    GetPreviusBussinessDocumentsTypeByKeysAsync: 'api/BussinessDocumentsType/GetPreviusBussinessDocumentsTypeByKeysAsync',
    SetActiveBussinessDocumentsType: 'api/BussinessDocumentsType/SetActiveAsync',
    UpdateBussinessDocumentsType: 'api/BussinessDocumentsType/UpdateAsync',
    GetBussinessDocumentsTypeAsync: 'api/BussinessDocumentsType/GetBussinessDocumentsTypeAsync',
  },
  bussinessDocumentsResolution: {
    CreateBussinessDocumentsResolution: 'api/BussinessDocumentsResolution/CreateAsync',
    DeleteBussinessDocumentsResolution: 'api/BussinessDocumentsResolution/DeleteAsync',
    ExportGeneralConsultation: 'api/BussinessDocumentsResolution/ExportGeneralConsultation',
    GetAllBussinessDocumentsResolutionsWithPaginationAsync: 'api/BussinessDocumentsResolution/GetAllBussinessDocumentsResolutionsWithPaginationAsync',
    GetBussinessDocumentsResolutionById: 'api/BussinessDocumentsResolution/GetByIdAsync',
    GetBussinessDocumentsResolutionByKeys: 'api/BussinessDocumentsResolution/GetBussinessDocumentsResolutionByKeysAsync',
    GetColumnsForGeneralConsultationAsync: 'api/BussinessDocumentsResolution/GetColumnsForGeneralConsultationAsync',
    GetFirstBussinessDocumentsResolutionByKeysAsync: 'api/BussinessDocumentsResolution/GetFirstBussinessDocumentsResolutionByKeysAsync',
    GetLastBussinessDocumentsResolutionByKeysAsync: 'api/BussinessDocumentsResolution/GetLastBussinessDocumentsResolutionByKeysAsync',
    GetNextBussinessDocumentsResolutionByKeysAsync: 'api/BussinessDocumentsResolution/GetNextBussinessDocumentsResolutionByKeysAsync',
    GetPreviusBussinessDocumentsResolutionByKeysAsync: 'api/BussinessDocumentsResolution/GetPreviusBussinessDocumentsResolutionByKeysAsync',
    GetResolutionExpirationStatusAsync: 'api/BussinessDocumentsResolution/GetResolutionExpirationStatusAsync',
    UpdateBussinessDocumentsResolution: 'api/BussinessDocumentsResolution/UpdateAsync',
  },
  cashReceipt: {
    AnnulCashReceipt: 'api/CashReceipt/AnnulCashReceiptAsync',
    CreateCashReceipt: 'api/CashReceipt/CreateAsync',
    DeleteCashReceipt: 'api/CashReceipt/DeleteAsync',
    DownloadGuideImport: 'api/CashReceipt/DownloadGuideImport',
    DownloadGuideImportWayToPay: 'api/CashReceipt/DownloadGuideImportWayToPay',
    DownloadGuideImportRetentions: 'api/CashReceipt/DownloadGuideImportRetentions',
    ExportGeneralConsultation: 'api/CashReceipt/ExportGeneralConsultation',
    ExportImportErrors: 'api/CashReceipt/ExportImportErrors',
    ImportChasReceipts: 'api/CashReceipt/ImportCashReceiptsAsync',
    ImportRetentions: 'api/CashReceipt/ImportRetentionsAsync',
    ImportWayToPay: 'api/CashReceipt/ImportWayToPayAsync',
    GetAllCashReceiptsWithPaginationAsync: 'api/CashReceipt/GetAllCashReceiptsWithPaginationAsync',
    GetAllClientsForSelectAsync: 'api/CashReceipt/GetAllClientsForSelectAsync',
    GetAllIncomeConceptsForSelectAsync: 'api/CashReceipt/GetAllIncomeConceptsForSelectAsync',
    GetCashReceiptById: 'api/CashReceipt/GetByIdAsync',
    GetCashReceiptByKeys: 'api/CashReceipt/GetCashReceiptByKeysAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CashReceipt/GetColumnsForGeneralConsultationAsync',
    GetEmptyCashReceiptPrint: 'api/CashReceipt/GetEmptyCashReceiptPrint',
    GetFirstCashReceiptByKeys: 'api/CashReceipt/GetFirstCashReceiptByKeysAsync',
    GetLastCashReceiptByKeys: 'api/CashReceipt/GetLastCashReceiptByKeysAsync',
    GetNextCashReceiptByKeys: 'api/CashReceipt/GetNextCashReceiptByKeysAsync',
    GetPermissionPrint: 'api/CashReceipt/GetPermissionPrintAsync',
    GetPreviusCashReceiptByKeys: 'api/CashReceipt/GetPreviusCashReceiptByKeysAsync',
    GetCashReceiptsByKeysByPrintAsync: 'api/CashReceipt/GetCashReceiptsByKeysByPrintAsync',
    SetCashReceiptState: 'api/CashReceipt/SetCashReceiptStateAsync',
    UpdateCashReceipt: 'api/CashReceipt/UpdateAsync',
    ValidateCountCashReceiptsOpen: 'api/CashReceipt/ValidateCountCashReceiptsOpenAsync',
  },
  cashReceiptPayment: {
    CreateCashReceiptPayment: 'api/CashReceiptPayment/CreateAsync',
    DeleteCashReceiptPayment: 'api/CashReceiptPayment/DeleteAsync',
    ExportCashReceiptPaymentsConsultation: 'api/CashReceiptPayment/ExportCashReceiptPaymentsConsultation',
    GetAdvancePaymentsByCashReceiptId: 'api/CashReceiptPayment/GetAdvancePaymentsByCashReceiptIdAsync',
    GetAdvancePaymentsAppliedByCashReceiptId: 'api/CashReceiptPayment/GetAdvancePaymentsAppliedByCashReceiptIdAsync',
    GetAllCashReceiptPaymentsWithPaginationAsync: 'api/CashReceiptPayment/GetAllCashReceiptPaymentsWithPaginationAsync',
    GetAllWayToPaysForSelectAsync: 'api/CashReceiptPayment/GetAllWayToPaysForSelectAsync',
    GetCashReceiptPaymentById: 'api/CashReceiptPayment/GetByIdAsync',
    GetCashReceiptPaymentByKeys: 'api/CashReceiptPayment/GetCashReceiptPaymentByKeysAsync',
    GetCashReceiptPaymentsByCashReceiptId: 'api/CashReceiptPayment/GetCashReceiptPaymentsByCashReceiptIdAsync',
    GetColumnsForCaptureTableAsync: 'api/CashReceiptPayment/GetColumnsForCaptureTableAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CashReceiptPayment/GetColumnsForGeneralConsultationAsync',
    UpdateCashReceiptPayment: 'api/CashReceiptPayment/UpdateAsync',
  },
  chargeAccount: {
    GetAllChargeAccountsWithPagination: 'api/ChargeAccount/GetAllChargeAccountsWithPaginationAsync',
    GetColumnsForGeneralConsultation: 'api/ChargeAccount/GetColumnsForGeneralConsultationAsync',
    GetChargeAccountById: 'api/ChargeAccount/GetByIdAsync',
    CreateChargeAccount: 'api/ChargeAccount/CreateAsync',
    UpdateChargeAccount: 'api/ChargeAccount/UpdateAsync',
    DeleteChargeAccount: 'api/ChargeAccount/DeleteAsync',
    SetChargeAccountState: 'api/ChargeAccount/SetChargeAccountStateAsync',
    ExportGeneralConsultation: 'api/ChargeAccount/ExportGeneralConsultation',
    BlockChargeAccount: 'api/ChargeAccount/BlockChargeAccountAsync',
    GetPermissionPrint: 'api/ChargeAccount/GetPermissionPrintAsync',
    PrintChargeAccounts: 'api/ChargeAccount/PrintChargeAccountsAsync',
    PrintsChargeAccounts: 'api/ChargeAccount/ChargeAccounts',
    GetAllBussinessDocumentsTypesForSelectAsync: 'api/ChargeAccount/GetAllBussinessDocumentsTypesForSelectAsync',
    GetAllConceptForSelectAsync: 'api/ChargeAccount/GetAllConceptForSelectAsync',
    GetCostCentersForSelectAsync: 'api/ChargeAccount/GetCostCentersForSelectAsync',
    GetPrintChargeAccountForFormat: 'api/ChargeAccount/GetPrintChargeAccountForFormatAsync',
    GetChargeAccountByKeys: 'api/ChargeAccount/GetChargeAccountByKeysAsync',
    GetFirstChargeAccountByKeys: 'api/ChargeAccount/GetFirstChargeAccountByKeysAsync',
    GetLastChargeAccountByKeys: 'api/ChargeAccount/GetLastChargeAccountByKeysAsync',
    GetPreviusChargeAccountByKeys: 'api/ChargeAccount/GetPreviusChargeAccountByKeysAsync',
    GetNextChargeAccountByKeys: 'api/ChargeAccount/GetNextChargeAccountByKeysAsync',
    CopyChargeAccount: 'api/ChargeAccount/CopyChargeAccount',
    AttachFilesToChargeAccount: 'api/ChargeAccount/AttachFilesToChargeAccountAsync',
    GetFilesToChargeAccount: 'api/ChargeAccount/GetFilesToChargeAccountAsync',
    DownloadFileToChargeAccount: 'api/ChargeAccount/DownloadFileToChargeAccountAsync',
    DeleteFilesToChargeAccount: 'api/ChargeAccount/DeleteFileToChargeAccountAsync',
    GetPermissionAnnulChargeAccount: 'api/ChargeAccount/GetPermissionAnnulChargeAccountAsync',
    AnnulChargeAccount: 'api/ChargeAccount/AnnulChargeAccountAsync',
  },
  chargeAccountDetail: {
    CreateChargeAccountDetail: 'api/ChargeAccountDetail/CreateAsync',
    DeleteChargeAccountDetail: 'api/ChargeAccountDetail/DeleteAsync',
    DeleteSomeDetails: 'api/ChargeAccountDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/ChargeAccountDetail/ExportDetailConsultation',
    ExportChargeAccountDetailsAsync: 'api/ChargeAccountDetail/ExportChargeAccountDetailsAsync',
    GetAllChargeAccountDetailsWithPagination: 'api/ChargeAccountDetail/GetAllChargeAccountDetailsWithPaginationAsync',
    GetChargeAccountDetailById: 'api/ChargeAccountDetail/GetByIdAsync',
    GetChargeAccountDetailByKeys: 'api/ChargeAccountDetail/GetChargeAccountDetailByKeysAsync',
    GetChargeAccountDetailsByChargeAccountId: 'api/ChargeAccountDetail/GetChargeAccountDetailsByChargeAccountIdAsync',
    GetChargeAccountsDetailsByChargeAccountsIdWithPagination: 'api/ChargeAccountDetail/GetChargeAccountsDetailsByChargeAccountIdWithPagination',
    GetColumnsForDetailConsultation: 'api/ChargeAccountDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailsChargeAccountAsync: 'api/ChargeAccountDetail/GetColumnsForDetailsChargeAccountAsync',
    UpdateChargeAccountDetail: 'api/ChargeAccountDetail/UpdateAsync',
  },
  chargeAccountConcept: {
    GetChargeAccountConceptById: 'api/ChargeAccountConcept/GetByIdAsync',
    GetChargeAccountConceptsByChargeAccountId: 'api/ChargeAccountConcept/GetChargeAccountConceptsByChargeAccountIdAsync',
    SaveGeneralDiscount: 'api/ChargeAccountConcept/SaveGeneralDiscountAsync',
    GetColumnsForConceptConsultation: 'api/ChargeAccountConcept/GetColumnsForConceptConsultationAsync',
    GetAllChargeAccountConceptsWithPagination: 'api/ChargeAccountConcept/GetAllChargeAccountConceptsWithPaginationAsync',
    ExportConceptConsultation: 'api/ChargeAccountConcept/ExportConceptConsultation',
    GetChargeAccountConceptsByChargeAccountIdWithPagination: 'api/ChargeAccountConcept/GetChargeAccountConceptsByChargeAccountIdWithPagination',
    GetColumnsForChargeAccountDiscountConceptAsync: 'api/ChargeAccountConcept/GetColumnsForChargeAccountDiscountConceptAsync',
  },
  city: {
    CreateCity: 'api/City/CreateAsync',
    DeleteCity: 'api/City/DeleteAsync',
    GetAllCitiesByCountry: 'api/City/GetAllCitiesByCountryAsync',
    GetByDepartmentId: 'api/City/GetByDepartmentIdAsync',
    GetByIdAsync: 'api/City/GetByIdAsync',
    GetCitiesForSelection: 'api/City/GetCitiesForSelection',
    GetCityByCode: 'api/City/GetCityByCodeAsync',
    GetCityDepartmentAsync: 'api/City/GetCityDepartmentAsync',
    GetAllCitiesByDepartmentIdForSelectAsync: 'api/City/GetAllCitiesByDepartmentIdForSelectAsync',
    GetAllCitiesByCountryIdForSelectAsync: 'api/City/GetAllCitiesByCountryIdForSelectAsync',
    GetColumnsForCitySelection: 'api/City/GetColumnsForCitySelection',
    UpdateAsync: 'api/City/UpdateAsync',
  },
  client: {
    CreateClient: 'api/Client/CreateAsync',
    CreateConstructionSite: 'api/Client/CreateConstructionSiteAsync',
    DeleteClient: 'api/Client/DeleteAsync',
    DownloadGuideImport: 'api/Client/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Client/ExportGeneralConsultation',
    ExportImportErrors: 'api/Client/ExportImportErrors',
    GetAllClientStatesForSelectAsync: 'api/Client/GetAllClientStatesForSelectAsync',
    GetAllClientsForSelectAsync: 'api/Client/GetAllClientsForSelectAsync',
    GetAllClientsWithPaginationAsync: 'api/Client/GetAllClientsWithPaginationAsync',
    GetAllCurrenciesForSelectAsync: 'api/Client/GetAllCurrenciesForSelectAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/Client/GetAllTypeDocumentsForSelectAsync',
    GetAllTypePersonsForSelectAsync: 'api/Client/GetAllTypePersonsForSelectAsync',
    GetCitiesAsync: 'api/Client/GetCitiesAsync',
    GetCityDepartment: 'api/Client/GetCityDepartment',
    GetClientByDocument: 'api/Client/GetClientByDocumentAsync',
    GetClientById: 'api/Client/GetByIdAsync',
    GetColumnsForCitiesAsync: 'api/Client/GetColumnsForCitiesAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Client/GetColumnsForGeneralConsultationAsync',
    GetDigitVerification: 'api/Client/GetDigitVerificationAsync',
    ImportClients: 'api/Client/ImportClientsAsync',
    UpdateClient: 'api/Client/UpdateAsync',
    UpdateClientAndConstructionSite: 'api/Client/UpdateClientAndConstructionSite',
    UpdateClientDocument: 'api/Client/UpdateClientDocumentAsync',
    ValidateStates: 'api/Client/ValidateStates',
  },
  clientContact: {
    CreateClientContact: 'api/ClientContact/CreateAsync',
    DeleteClientContact: 'api/ClientContact/DeleteAsync',
    UpdateClientContact: 'api/ClientContact/UpdateAsync',
    GetClientContactsByClientId: 'api/ClientContact/GetClientContactsByClientIdAsync',
    GetClientContactById: 'api/ClientContact/GetByIdAsync',
  },
  compositeArticle: {
    ChangeStateAsync: 'api/CompositeArticle/ChangeStateAsync',
    CreateArticle: 'api/CompositeArticle/CreateAsync',
    DeleteArticle: 'api/CompositeArticle/DeleteAsync',
    DownloadGuideImport: 'api/CompositeArticle/DownloadGuideImport',
    ExportGeneralConsultation: 'api/CompositeArticle/ExportGeneralConsultation',
    ExportImportErrors: 'api/CompositeArticle/ExportImportErrors',
    GetAllCompositeArticlesWithPagination: 'api/CompositeArticle/GetAllCompositeArticlesWithPaginationAsync',
    GetByIdAsync: 'api/CompositeArticle/GetByIdAsync',
    GetColumnsForGeneralConsultation: 'api/CompositeArticle/GetColumnsForGeneralConsultationAsync',
    GetColumnsCompositeArticleSelectionAsync: 'api/CompositeArticle/GetColumnsCompositeArticleSelectionAsync',
    GetCompositeArticleByKeysAsync: 'api/CompositeArticle/GetCompositeArticleByKeysAsync',
    GetCompositeArticlesForSelectionAsync: 'api/CompositeArticle/GetCompositeArticlesForSelectionAsync',
    GetFirstCompositeArticleByKeysAsync: 'api/CompositeArticle/GetFirstCompositeArticleByKeysAsync',
    GetLastCompositeArticleByKeysAsync: 'api/CompositeArticle/GetLastCompositeArticleByKeysAsync',
    GetNextCompositeArticleByKeysAsync: 'api/CompositeArticle/GetNextCompositeArticleByKeysAsync',
    GetPreviusCompositeArticleByKeysAsync: 'api/CompositeArticle/GetPreviusCompositeArticleByKeysAsync',
    ImportCompositesArticlesAsync: 'api/CompositeArticle/ImportCompositesArticlesAsync',
    UpdateArticle: 'api/CompositeArticle/UpdateAsync',
  },
  company: {
    CreateCompany: 'api/Company/CreateAsync',
    DeleteCompany: 'api/Company/DeleteAsync',
    GetAllAccountingSystemsForSelectAsync: 'api/Company/GetAllAccountingSystemsForSelectAsync',
    GetAllArticlesByCompanyIdForSelectAsync: 'api/Company/GetAllArticlesByCompanyIdForSelectAsync',
    GetAllCompaniesForSelectAsync: 'api/Company/GetAllCompaniesForSelectAsync',
    GetAllCompaniesWithPaginationAsync: 'api/Company/GetAllCompaniesWithPaginationAsync',
    GetAllConceptInvoicingsForSelectAsync: 'api/Company/GetAllConceptInvoicingsForSelectAsync',
    GetAllCountriesForSelectAsync: 'api/Company/GetAllCountriesForSelectAsync',
    GetAllCurrenciesForSelectAsync: 'api/Company/GetAllCurrenciesForSelectAsync',
    GetAllTypeAccountingSystemsForSelectAsync: 'api/Company/GetAllTypeAccountingSystemsForSelectAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/Company/GetAllTypeDocumentsForSelectAsync',
    GetByIdAsync: 'api/Company/GetByIdAsync',
    GetCompanyByCode: 'api/Company/GetCompanyByCodeAsync',
    GetCompanyByUserAutheticated: 'api/Company/GetCompanyByUserAutheticatedAsync',
    GetColumnsForArticles: 'api/Company/GetColumnsForArticlesAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Company/GetColumnsForGeneralConsultationAsync',
    GetDigitVerification: 'api/Company/GetDigitVerificationAsync',
    GetFirstCompanyByKeysAsync: 'api/Company/GetFirstCompanyByKeysAsync',
    GetLastCompanyByKeysAsync: 'api/Company/GetLastCompanyByKeysAsync',
    GetNextCompanyByKeysAsync: 'api/Company/GetNextCompanyByKeysAsync',
    GetPreviusCompanyByKeysAsync: 'api/Company/GetPreviusCompanyByKeysAsync',
    SetActiveCompany: 'api/Company/SetActive',
    UpdateCompany: 'api/Company/UpdateAsync',
    ValidateDeleteCompanyCredentials: 'api/Company/ValidateDeleteCompanyCredentials',
  },
  companyCity: {
    CreateCompanyCity: 'api/CompanyCity/CreateAsync',
    DeleteCompanyCity: 'api/CompanyCity/DeleteAsync',
    ExportGeneralConsultation: 'api/CompanyCity/ExportGeneralConsultation',
    GetAllCompanyCity: 'api/CompanyCity/GetAllCompanyCitiesAsync',
    GetAllCompanyCitiesWithPaginationAsync: 'api/CompanyCity/GetAllCompanyCitiesWithPaginationAsync',
    GetByIdAsync: 'api/CompanyCity/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CompanyCity/GetColumnsForGeneralConsultationAsync',
    GetCompanyCityByCityId: 'api/CompanyCity/GetCompanyCityByCityIdAsync',
    UpdateAsync: 'api/CompanyCity/UpdateAsync',
  },
  concept: {
    CreateConcept: 'api/Concept/CreateAsync',
    DeleteConcept: 'api/Concept/DeleteAsync',
    GetAllConceptNoteStagesForSelectAsync: 'api/Concept/GetAllConceptNoteStagesForSelectAsync',
    GetAllConceptsForRegisterInvoiceAsync: 'api/Concept/GetAllConceptsForRegisterInvoiceAsync',
    GetAllConceptsWithPaginationAsync: 'api/Concept/GetAllConceptsWithPaginationAsync',
    GetAllTypeConceptsForSelectAsync: 'api/Concept/GetAllTypeConceptsForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Concept/GetColumnsForGeneralConsultationAsync',
    GetConceptByCode: 'api/Concept/GetConceptByCodeAsync',
    GetConceptById: 'api/Concept/GetByIdAsync',
    GetConceptEntry: 'api/Concept/GetConceptsEntryAsync',
    GetConceptOutput: 'api/Concept/GetConceptsOutputAsync',
    GetConceptsAnnul: 'api/Concept/GetConceptsAnnulAsync',
    GetConceptsBussinesType: 'api/Concept/GetConceptsBussinesTypeAsync',
    GetConceptsBussinesType2: 'api/Concept/GetConceptsBussinesType2Async',
    GetConceptsCreditNote: 'api/Concept/GetConceptsCreditNoteAsync',
    GetConceptsDebitNote: 'api/Concept/GetConceptsDebitNoteAsync',
    GetConceptsTypeEquipment: 'api/Concept/GetConceptsTypeEquipmentAsync',
    GetConceptsVehicleType: 'api/Concept/GetConceptsVehicleTypeAsync',
    GetFirstConceptByKeysAsync: 'api/Concept/GetFirstConceptByKeysAsync',
    GetLastConceptByKeysAsync: 'api/Concept/GetLastConceptByKeysAsync',
    GetNextConceptByKeysAsync: 'api/Concept/GetNextConceptByKeysAsync',
    GetPreviusConceptByKeysAsync: 'api/Concept/GetPreviusConceptByKeysAsync',
    UpdateConcept: 'api/Concept/UpdateAsync',
  },
  conceptFamily: {
    CreateConceptFamily: 'api/ConceptFamily/CreateAsync',
    CreateSomeAsync: 'api/ConceptFamily/CreateSomeAsync',
    DeleteConceptFamily: 'api/ConceptFamily/DeleteAsync',
    DeleteSomeAsync: 'api/ConceptFamily/DeleteSomeAsync',
    ExportGeneralConsultation: 'api/ConceptFamily/ExportGeneralConsultation',
    GetAllConceptFamiliesForAccountingModelWithPaginationAsync: 'api/ConceptFamily/GetAllConceptFamiliesForAccountingModelWithPaginationAsync',
    GetArticlesByFamilyIdForSelectAsync: 'api/ConceptFamily/GetArticlesByFamilyIdForSelectAsync',
    GetColumnsForFamiliesModalAsync: 'api/ConceptFamily/GetColumnsForFamiliesModalAsync',
    GetColumnsForGeneralConsultationForAccountingModelAsync: 'api/ConceptFamily/GetColumnsForGeneralConsultationForAccountingModelAsync',
    GetConceptFamiliesByConceptInvoicingIdAsync: 'api/ConceptFamily/GetConceptFamiliesByConceptInvoicingIdAsync',
    GetConceptFamiliesByConceptInvoicingIdForSelectAsync: 'api/ConceptFamily/GetConceptFamiliesByConceptInvoicingIdForSelectAsync',
    GetConceptFamily: 'api/ConceptFamily/GetConceptFamilyAsync',
    GetFamiliesForConceptInvoicingAsync: 'api/ConceptFamily/GetFamiliesForConceptInvoicingAsync',
    UpdateAsync: 'api/ConceptFamily/UpdateAsync',
  },
  conceptInvoicing: {
    CreateConceptInvoicing: 'api/ConceptInvoicing/CreateAsync',
    CreatePurchaseConcept: 'api/PurchaseConcept/CreateAsync',
    DeleteConceptInvoicing: 'api/ConceptInvoicing/DeleteAsync',
    DeletePurchaseConcept: 'api/PurchaseConcept/DeleteAsync',
    DownloadGuideImport: 'api/ConceptInvoicing/DownloadGuideImport',
    DownloadPurchaseGuideImport: 'api/PurchaseConcept/DownloadGuideImport',
    ExportImportErrors: 'api/ConceptInvoicing/ExportImportErrors',
    ExportGeneralConsultation: 'api/ConceptInvoicing/ExportGeneralConsultation',
    ExportPurchaseGeneralConsultation: 'api/PurchaseConcept/ExportGeneralConsultation',
    ExportGeneralConsultationForAccountingModel: 'api/ConceptInvoicing/ExportGeneralConsultationForAccountingModel',
    GetAllConceptInvoicingPriceOfsForSelectAsync: 'api/ConceptInvoicing/GetAllConceptInvoicingPriceOfsForSelectAsync',
    GetAllConceptInvoicingsWithPaginationAsync: 'api/ConceptInvoicing/GetAllConceptInvoicingsWithPaginationAsync',
    GetAllPurchaseConceptInvoicingsWithPaginationAsync: 'api/PurchaseConcept/GetAllPurchaseConceptWithPaginationAsync',
    GetAllConceptInvoicingsForAccountingModelWithPaginationAsync: 'api/ConceptInvoicing/GetAllConceptInvoicingsForAccountingModelWithPaginationAsync',
    GetAllConceptsInvoicingForSelectAsync: 'api/ConceptInvoicing/GetAllConceptsInvoicingForSelectAsync',
    GetAllConceptInvoicingByCompanyForSelectAsync: 'api/ConceptInvoicing/GetAllConceptInvoicingByCompanyForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/ConceptInvoicing/GetColumnsForGeneralConsultationAsync',
    GetColumnsForPurchaseConceptGeneralConsultationAsync: 'api/PurchaseConcept/GetColumnsForGeneralConsultationAsync',
    GetAllPurchaseConceptsForSelectAsync: 'api/PurchaseConcept/GetAllPurchaseConceptsForSelectAsync',
    GetColumnsForGeneralConsultationForAccountingModelAsync: 'api/ConceptInvoicing/GetColumnsForGeneralConsultationForAccountingModelAsync',
    GetConceptInvoicing: 'api/ConceptInvoicing/GetConceptInvoicingAsync',
    GetConceptInvoicingAlquiler: 'api/ConceptInvoicing/GetConceptInvoicingAlquilerAsync',
    GetConceptInvoicingByCode: 'api/ConceptInvoicing/GetConceptInvoicingByCodeAsync',
    GetConceptInvoicingByCompanyId: 'api/ConceptInvoicing/GetConceptInvoicingByCompanyIdAsync',
    GetConceptInvoicingById: 'api/ConceptInvoicing/GetByIdAsync',
    GetConceptInvoicingForNote: 'api/ConceptInvoicing/GetConceptInvoicingForNoteAsync',
    GetFirstConceptsInvoicingByKeysAsync: 'api/ConceptInvoicing/GetFirstConceptsInvoicingByKeysAsync',
    GetFirstPurchaseConceptByKeysAsync: 'api/PurchaseConcept/GetFirstPurchaseConceptsByKeysAsync',
    GetLastConceptsInvoicingByKeysAsync: 'api/ConceptInvoicing/GetLastConceptsInvoicingByKeysAsync',
    GetLastPurchaseConceptByKeysAsync: 'api/PurchaseConcept/GetLastPurchaseConceptsByKeysAsync',
    GetNextConceptsInvoicingByKeysAsync: 'api/ConceptInvoicing/GetNextConceptsInvoicingByKeysAsync',
    GetNextPurchaseConceptByKeysAsync: 'api/PurchaseConcept/GetNextPurchaseConceptsByKeysAsync',
    GetPreviusConceptsInvoicingByKeysAsync: 'api/ConceptInvoicing/GetPreviusConceptsInvoicingByKeysAsync',
    GetPreviusPurchaseConceptByKeysAsync: 'api/PurchaseConcept/GetPreviusPurchaseConceptsByKeysAsync',
    ImportConceptInvoicing: 'api/ConceptInvoicing/ImportConceptInvoicingAsync',
    UpdateConceptInvoicing: 'api/ConceptInvoicing/UpdateAsync',
    UpdatePurchaseConcept: 'api/PurchaseConcept/UpdateAsync',
  },
  concurrence: {
    CloseConcurrence: 'api/Concurrence/CloseConcurrenceAsync',
  },
  consolidatedPendingsOrders: {
    GetColumnsForGeneralConsultationConsolidatedAsync: 'api/ConsolidatedPendingsOrders/GetColumnsForGeneralConsultationConsolidatedAsync/',
    GetAllConsolidatedPendingsOrdersAsync: 'api/ConsolidatedPendingsOrders/GetAllConsolidatedPendingsOrdersAsync/',
    ExportGeneralConsolidated: 'api/ConsolidatedPendingsOrders/ExportGeneralConsolidated/',
  },
  constructionSite: {
    CreateConstructionSite: 'api/ConstructionSite/CreateAsync',
    DeactivateConstructionSitesAsync: 'api/ConstructionSite/DeactivateConstructionSitesAsync',
    DeleteConstructionSite: 'api/ConstructionSite/DeleteAsync',
    UpdateConstructionSite: 'api/ConstructionSite/UpdateAsync',
    GetAllConstructionSitesByClientIdForSelectAsync: 'api/ConstructionSite/GetAllConstructionSitesByClientIdForSelectAsync',
    GetAllConstructionSitesByKeysForSelectAsync: 'api/ConstructionSite/GetAllConstructionSitesByKeysForSelectAsync',
    GetConstructionSiteById: 'api/ConstructionSite/GetByIdAsync',
    GetConstructionSiteByCode: 'api/ConstructionSite/GetConstructionSiteByCodeAsync',
    GetConstructionSiteByBranchId: 'api/ConstructionSite/GetConstructionSiteByBranchIdAsync',
    GetConstructionSiteByClientId: 'api/ConstructionSite/GetConstructionSiteByClientIdAsync',
    CreateCostCenter: 'api/ConstructionSite/CreateCostCenterAsync',
    DownloadGuideImport: 'api/ConstructionSite/DownloadGuideImport',
    ImportConstructionSites: 'api/ConstructionSite/ImportConstructionSitesAsync',
    GetColumnsForGeneralConsultation: 'api/ConstructionSite/GetColumnsForGeneralConsultationAsync',
    GetColumnsForSelectionAsync: 'api/ConstructionSite/GetColumnsForSelectionAsync',
    ExportGeneralConsultation: 'api/ConstructionSite/ExportGeneralConsultation',
    ExportImportErrors: 'api/ConstructionSite/ExportImportErrors',
    GetAllConstructionSitesWithPagination: 'api/ConstructionSite/GetAllConstructionSitesWithPaginationAsync',
    GetConstructionSitesForSelectionAsync: 'api/ConstructionSite/GetConstructionSitesForSelectionAsync',
    GetAllZonesForSelect: 'api/ConstructionSite/GetAllZonesForSelectAsync',
    GetAllConceptsForSelect: 'api/ConstructionSite/GetAllConceptsForSelectAsync',
    GetAllSellersForSelect: 'api/ConstructionSite/GetAllSellersForSelectAsync',
    GetAllConstructionSitesForSelectAsync: 'api/ConstructionSite/GetAllConstructionSitesForSelectAsync',
    GetAllClientsForSelect: 'api/ConstructionSite/GetAllClientsForSelectAsync',
    GetSectorsByCityForSelect: 'api/ConstructionSite/GetSectorsByCityForSelectAsync',
    GetFirstConstructionSiteByKeys: 'api/ConstructionSite/GetFirstConstructionSiteByKeysAsync',
    GetLastConstructionSiteByKeys: 'api/ConstructionSite/GetLastConstructionSiteByKeysAsync',
    GetNextConstructionSiteByKeys: 'api/ConstructionSite/GetNextConstructionSiteByKeysAsync',
    GetPreviusConstructionSiteByKeys: 'api/ConstructionSite/GetPreviusConstructionSiteByKeysAsync',
    GetClientByIdForRegisterAsync: 'api/ConstructionSite/GetClientByIdForRegisterAsync',
  },
  costAdjustment: {
    CreateCostAdjustment: 'api/CostAdjustment/CreateAsync',
    DeleteCostAdjustment: 'api/CostAdjustment/DeleteAsync',
    ExportGeneralConsultation: 'api/CostAdjustment/ExportGeneralConsultation',
    GetAllInventoriesForSelectAsync: 'api/CostAdjustment/GetAllInventoriesForSelectAsync',
    GetCostAdjustmentById: 'api/CostAdjustment/GetByIdAsync',
    GetAllInventoryEntriesForSelectAsync: 'api/CostAdjustment/GetAllInventoryEntriesForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CostAdjustment/GetColumnsForGeneralConsultationAsync',
    GetFirstCostAdjustmentByKeysAsync: 'api/CostAdjustment/GetFirstCostAdjustmentByKeysAsync',
    GetEmptyCostAdjustmentPrint: 'api/CostAdjustment/GetEmptyCostAdjustmentPrint',
    GetAllCostAdjustmentsWithPaginationAsync: 'api/CostAdjustment/GetAllCostAdjustmentsWithPaginationAsync',
    GetCostAdjustmentByKeysAsync: 'api/CostAdjustment/GetCostAdjustmentByKeysAsync',
    GetLastCostAdjustmentByKeysAsync: 'api/CostAdjustment/GetLastCostAdjustmentByKeysAsync',
    GetNextCostAdjustmentByKeysAsync: 'api/CostAdjustment/GetNextCostAdjustmentByKeysAsync',
    GetPermissionPrint: 'api/CostAdjustment/GetPermissionPrintAsync',
    GetCostAdjustmentByKeysByPrintAsync: 'api/CostAdjustment/GetCostAdjustmentByKeysByPrintAsync',
    GetPreviusCostAdjustmentByKeysAsync: 'api/CostAdjustment/GetPreviusCostAdjustmentByKeysAsync',
    SetStateCostAdjustment: 'api/CostAdjustment/SetCostAdjustmentStateAsync',
    UpdateCostAdjustment: 'api/CostAdjustment/UpdateAsync',
  },
  costAdjustmentDetail: {
    CreateCostAdjustmentDetailAsync: 'api/CostAdjustmentDetail/CreateAsync',
    CreateDetailsAsync: 'api/CostAdjustmentDetail/CreateDetailsAsync',
    DeleteCostAdjustmentDetailAsync: 'api/CostAdjustmentDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/CostAdjustmentDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/CostAdjustmentDetail/ExportDetailConsultation',
    GetArticlesByEntryAsync: 'api/CostAdjustmentDetail/GetArticlesByEntryAsync',
    GetCostAdjustmentDetailByIdAsync: 'api/CostAdjustmentDetail/GetByIdAsync',
    GetColumnsForArticleAsync: 'api/CostAdjustmentDetail/GetColumnsForArticleAsync',
    GetColumnsForCaptureTableAsync: 'api/CostAdjustmentDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultationAsync: 'api/CostAdjustmentDetail/GetColumnsForDetailConsultationAsync',
    GetCostAdjustmentDetailByKeysAsync: 'api/CostAdjustmentDetail/GetCostAdjustmentDetailByKeysAsync',
    GetCostAdjustmentDetailsForCaptureTableAsync: 'api/CostAdjustmentDetail/GetCostAdjustmentDetailsForCaptureTableAsync',
    GetAllCostAdjustmentDetailsWithPaginationAsync: 'api/CostAdjustmentDetail/GetAllCostAdjustmentDetailsWithPaginationAsync',
    UpdateCostAdjustmentDetailAsync: 'api/CostAdjustmentDetail/UpdateAsync',
  },
  costCenter: {
    GetAllCostCentersForSelectAsync: 'api/CostCenter/GetAllCostCentersForSelectAsync',
    GetAllCostCentersByKeysForSelectAsync: 'api/CostCenter/GetAllCostCentersByKeysForSelectAsync',
    GetAllCostCentersForSelectByClientAsync: 'api/CostCenter/GetAllCostCentersForSelectByClientAsync',
    GetAllCostCentersWorkshop: 'api/CostCenter/GetAllCostCentersWorkshopAsync',
    CreateCostCenter: 'api/CostCenter/CreateAsync',
    DeleteCostCenter: 'api/CostCenter/DeleteAsync',
    UpdateCostCenter: 'api/CostCenter/UpdateAsync',
    GetCostCenterById: 'api/CostCenter/GetByIdAsync',
    GetCostCenterByCode: 'api/CostCenter/GetCostCenterByCodeAsync',
    GetCostCenterByBranchId: 'api/CostCenter/GetCostCenterByBranchIdAsync',
    GetCostCenterByBranchByEnterpriseByClient: 'api/CostCenter/GetCostCenterByBranchByEnterpriseByClientIdAsync',
    GetCostCenterByClientId: 'api/CostCenter/GetCostCenterByClientIdAsync',
    GetCostCentersForInvoicingCutoff: 'api/CostCenter/GetCostCentersForInvoicingCutoffAsync',
    DownloadGuideImport: 'api/CostCenter/DownloadGuideImport',
    ImportCostCenters: 'api/CostCenter/ImportCostCentersAsync',
    GetColumnsForGeneralConsultation: 'api/CostCenter/GetColumnsForGeneralConsultationAsync',
    GetAllCostCentersWithPagination: 'api/CostCenter/GetAllCostCentersWithPaginationAsync',
    ExportGeneralConsultation: 'api/CostCenter/ExportGeneralConsultation',
    ExportImportErrors: 'api/CostCenter/ExportImportErrors',
    GetFirstCostCenterByKeys: 'api/CostCenter/GetFirstCostCenterByKeysAsync',
    GetLastCostCenterByKeys: 'api/CostCenter/GetLastCostCenterByKeysAsync',
    GetNextCostCenterByKeys: 'api/CostCenter/GetNextCostCenterByKeysAsync',
    GetPreviusCostCenterByKeys: 'api/CostCenter/GetPreviusCostCenterByKeysAsync',
    GetCostCenterTypesForSelect: 'api/CostCenter/GetCostCenterTypesForSelectAsync',
    GetPriceListsForSelect: 'api/CostCenter/GetPriceListsForSelectAsync',
    GetConstructionSitesForSelect: 'api/CostCenter/GetConstructionSitesForSelectAsync',
    GetInvoicingModelsForSelect: 'api/CostCenter/GetInvoicingModelsForSelectAsync',
    GetIvaTypesForSelect: 'api/CostCenter/GetIvaTypesForSelectAsync',
    GetConceptInvoicingsForSelect: 'api/CostCenter/GetConceptInvoicingsForSelectAsync',
    GetEnterpriseAndClientByConstructionSiteIdAsync: 'api/CostCenter/GetEnterpriseAndClientByConstructionSiteIdAsync',
    GetArticlesForCostCenters: 'api/CostCenter/GetArticlesForCostCentersAsync',
    GetColumnsForArticles: 'api/CostCenter/GetColumnsForArticlesAsync',
    GetArticlesForSelect: 'api/CostCenter/GetArticleForSelectAsync',
  },
  costCenterPrice: {
    CreateCostCenterPrice: 'api/CostCenterPrice/CreateAsync',
    DeleteCostCenterPrice: 'api/CostCenterPrice/DeleteAsync',
    UpdateCostCenterPrice: 'api/CostCenterPrice/UpdateAsync',
    GetCostCenterPriceById: 'api/CostCenterPrice/GetByIdAsync',
    GetCostCenterPriceByKeys: 'api/CostCenterPrice/GetCostCenterPriceByKeysAsync',
    GetBaseUnitValueByKeys: 'api/CostCenterPrice/GetBaseUnitValueByKeysAsync',
    GetSwFacturacionEspecial: 'api/CostCenterPrice/GetSwFacturacionEspecialAsync',
    DownloadGuideImport: 'api/CostCenterPrice/DownloadGuideImport',
    ImportCostCenterPrices: 'api/CostCenterPrice/ImportCostCenterPricesAsync',
    GetAllCostCenterPricesWithPaginationAsync: 'api/CostCenterPrice/GetAllCostCenterPricesWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CostCenterPrice/GetColumnsForGeneralConsultationAsync',
    ExportGeneralConsultation: 'api/CostCenterPrice/ExportGeneralConsultation',
    ExportImportErrors: 'api/CostCenterPrice/ExportImportErrors',
    GetCostCenterByIdAsync: 'api/CostCenterPrice/GetCostCenterByIdAsync',
    GetAllConceptInvoicingsAsync: 'api/CostCenterPrice/GetAllConceptInvoicingsAsync',
    GetAllUnitsAsync: 'api/CostCenterPrice/GetAllUnitsAsync',
    GetArticlesForCostCenterPriceAsync: 'api/CostCenterPrice/GetArticlesForCostCenterPriceAsync',
    GetColumnsForArticleAsync: 'api/CostCenterPrice/GetColumnsForArticleAsync',
    GetAllCostCentersForSelect: 'api/CostCenterPrice/GetAllCostCentersForSelectAsync',
  },
  costCenterUser: {
    GetCostCenterUsersWithPaginationAsync: 'api/CostCenterUser/GetCostCenterUsersWithPaginationAsync',
    GetColumnsCostCenterUserAsync: 'api/CostCenterUser/GetColumnsCostCenterUserAsync',
    SaveCostCenterUserAsync: 'api/CostCenterUser/SaveCostCenterUserAsync',
  },
  component: {
    CreateAsync: 'api/Component/CreateAsync',
    DeleteAsync: 'api/Component/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/Component/DeleteSomeDetailsAsync',
    GetComponentsByRoutineAsync: 'api/Component/GetComponentsByRoutineAsync',
    GetAllComponentWithPaginationAsync: 'api/Component/GetAllComponentWithPaginationAsync',
    GetByCodeAsync: 'api/Component/GetByCodeAsync',
    GetByIdAsync: 'api/Component/GetByIdAsync',
    GetColumnsAsync: 'api/Component/GetColumnsAsync',
    UpdateAsync: 'api/Component/UpdateAsync',
  },
  contact: {
    CreateContact: 'api/Contact/CreateAsync',
    DeleteContact: 'api/Contact/DeleteAsync',
    UpdateContact: 'api/Contact/UpdateAsync',
    ExportGeneralConsultation: 'api/Contact/ExportGeneralConsultation',
    GetAllContactsWithPaginationAsync: 'api/Contact/GetAllContactsWithPaginationAsync',
    GetContactById: 'api/Contact/GetByIdAsync',
    GetClientContactsByClientId: 'api/Contact/GetClientContactsByClientIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Contact/GetColumnsForGeneralConsultationAsync',
  },
  country: {
    GetAllCountries: 'api/Country/GetAllCountriesAsync',
    CreateCountry: 'api/Country/CreateAsync',
    UpdateCountry: 'api/Country/UpdateAsync',
    GetCountryById: 'api/Country/GetByIdAsync',
    DeleteCountry: 'api/Country/DeleteAsync',
    GetCountryByCode: 'api/Country/GetCountryByCodeAsync',
    GetCountryByUserAuthenticatedAsync: 'api/Country/GetCountryByUserAuthenticatedAsync',
    GetAllCountriesForSelectAsync: 'api/Country/GetAllCountriesForSelectAsync',
  },
  currency: {
    CreateCurrency: 'api/Currency/CreateAsync',
    DeleteCurrency: 'api/Currency/DeleteAsync',
    ExportGeneralConsultation: 'api/Currency/ExportGeneralConsultation',
    GetAllCurrenciesWithPaginationAsync: 'api/Currency/GetAllCurrenciesWithPaginationAsync',
    GetCurrencyById: 'api/Currency/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Currency/GetColumnsForGeneralConsultationAsync',
    GetCurrencyByCode: 'api/Currency/GetCurrencyByCodeAsync',
    UpdateCurrency: 'api/Currency/UpdateAsync',
  },
  currencyExchange: {
    CreateCurrencyExchange: 'api/CurrencyExchange/CreateAsync',
    DeleteCurrencyExchange: 'api/CurrencyExchange/DeleteAsync',
    ExportGeneralConsultation: 'api/CurrencyExchange/ExportGeneralConsultation',
    GetAllCurrencyExchangesWithPaginationAsync: 'api/CurrencyExchange/GetAllCurrencyExchangesWithPaginationAsync',
    GetAllCurrenciesForSelectAsync: 'api/CurrencyExchange/GetAllCurrenciesForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/CurrencyExchange/GetColumnsForGeneralConsultationAsync',
    GetCurrencyExchangeById: 'api/CurrencyExchange/GetByIdAsync',
    GetCurrencyExchangeByCode: 'api/CurrencyExchange/GetCurrencyExchangeByCodeAsync',
    UpdateCurrencyExchange: 'api/CurrencyExchange/UpdateAsync',
  },
  department: {
    CreateDepartment: 'api/Department/CreateAsync',
    DeleteDepartment: 'api/Department/DeleteAsync',
    GetAllDepartment: 'api/Department/GetAllDepartmentsAsync',
    GetAllDepartmentsWithPaginationAsync: 'api/Department/GetAllDepartmentsWithPaginationAsync',
    GetColumnsForConsultationAsync: 'api/Department/GetColumnsForConsultationAsync',
    GetDepartmentById: 'api/Department/GetByIdAsync',
    GetDepartmentByKeys: 'api/Department/GetDepartmentByKeysAsync',
    UpdateDepartment: 'api/Department/UpdateAsync',
    GetAllDepartmentsForSelectAsync: 'api/Department/GetAllDepartmentsForSelectAsync',
    GetAllDepartmentsByCountryIdForSelectAsync: 'api/Department/GetAllDepartmentsByCountryIdForSelectAsync',
  },

  devolution: {
    AnnulDevolution: 'api/Devolution/AnnulDevolutionAsync',
    AttachFilesToDevolution: 'api/Devolution/AttachFilesToDevolutionAsync',
    BlockDevolution: 'api/Devolution/BlockDevolutionAsync',
    CreateDevolution: 'api/Devolution/CreateAsync',
    DeleteDevolution: 'api/Devolution/DeleteAsync',
    DeleteFilesToDevolution: 'api/Devolution/DeleteFileToDevolutionAsync',
    DownloadFileToDevolution: 'api/Devolution/DownloadFileToDevolutionAsync',
    ExportGeneralConsultation: 'api/Devolution/ExportGeneralConsultation',
    ExportInvoiceForDevolutionConsultation: 'api/Devolution/ExportInvoiceForDevolutionConsultation',
    GetFilesToDevolution: 'api/Devolution/GetFilesToDevolutionAsync',
    GetAllCostCentersForSelectAsync: 'api/Devolution/GetAllCostCentersForSelectAsync',
    GetAllDevolutionsWithPaginationAsync: 'api/Devolution/GetAllDevolutionsWithPaginationAsync',
    GetAllInvoiceForDevolutionsWithPaginationAsync: 'api/Devolution/GetAllInvoiceForDevolutionsWithPaginationAsync',
    GetAllTransportersForSelectAsync: 'api/Devolution/GetAllTransportersForSelectAsync',
    GetAllVehiclesForSelectAsync: 'api/Devolution/GetAllVehiclesForSelectAsync',
    GetAllConceptsRequirementTypeForSelectAsync: 'api/Devolution/GetAllConceptsRequirementTypeForSelectAsync',
    GetAllConceptsDelayReasonForSelectAsync: 'api/Devolution/GetAllConceptsDelayReasonForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Devolution/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoiceConsultationAsync: 'api/Devolution/GetColumnsForInvoiceConsultationAsync',
    GetCostCenterByIdAsync: 'api/Devolution/GetCostCenterByIdAsync',
    GetDevolutionById: 'api/Devolution/GetByIdAsync',
    GetDevolutionByKeys: 'api/Devolution/GetDevolutionByKeysAsync',
    GetDevolutionByKeysByPrintAsync: 'api/Devolution/GetDevolutionByKeysByPrintAsync',
    GetDevolutionConsecutiveByIdAsync: 'api/Devolution/GetDevolutionConsecutiveByIdAsync',
    GetEmptyDevolutionPrint: 'api/Devolution/GetEmptyDevolutionPrint',
    GetFirstDevolutionByKeys: 'api/Devolution/GetFirstDevolutionByKeysAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/Devolution/GetIndicatorsForGeneralConsultationAsync',
    GetLastDevolutionByKeys: 'api/Devolution/GetLastDevolutionByKeysAsync',
    GetNextDevolutionByKeys: 'api/Devolution/GetNextDevolutionByKeysAsync',
    GetPermissionPrint: 'api/Devolution/GetPermissionPrintAsync',
    GetPredevolutionByKeys: 'api/Devolution/GetPredevolutionByKeysAsync',
    GetPreviusDevolutionByKeys: 'api/Devolution/GetPreviusDevolutionByKeysAsync',
    HasExistingDevolutionAsync: 'api/Devolution/HasExistingDevolutionAsync',
    PrintDevolution: 'api/Devolution/PrintDevolutionAsync',
    SetDevolutionState: 'api/Devolution/SetDevolutionStateAsync',
    UpdateDevolution: 'api/Devolution/UpdateAsync',
    validateStocksInCostCenter: 'api/Devolution/ValidateStocksInCostCenterAsync',
  },
  devolutionDetail: {
    AreThereBalancesInCostCenter: 'api/DevolutionDetail/AreThereBalancesInCostCenter',
    ConvertToDevolution: 'api/DevolutionDetail/ConvertToDevolutionAsync',
    CreateDevolutionDetail: 'api/DevolutionDetail/CreateAsync',
    CreateSomeDetails: 'api/DevolutionDetail/CreateSomeDetailsAsync',
    DeleteDevolutionDetail: 'api/DevolutionDetail/DeleteAsync',
    DeleteDevolutionDetailsInZero: 'api/DevolutionDetail/DeleteDevolutionDetailsInZero',
    DeleteSomeDetails: 'api/DevolutionDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/DevolutionDetail/ExportDetailConsultation',
    GetAllDevolutionDetailsWithPaginationAsync: 'api/DevolutionDetail/GetAllDevolutionDetailsWithPaginationAsync',
    GetArticlesForDetailsAsync: 'api/DevolutionDetail/GetArticlesForDetailsAsync',
    GetColumnsForArticles: 'api/DevolutionDetail/GetColumnsForArticlesAsync',
    GetColumnsForCaptureTableAsync: 'api/DevolutionDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForGeneralConsultationAsync: 'api/DevolutionDetail/GetColumnsForGeneralConsultationAsync',
    GetDevolutionDetailById: 'api/DevolutionDetail/GetByIdAsync',
    GetDevolutionDetailByKeys: 'api/DevolutionDetail/GetDevolutionDetailByKeysAsync',
    GetDevolutionDetailsBySwIncludeStore: 'api/DevolutionDetail/GetDevolutionDetailsBySwIncludeStoreAsync',
    GetDevolutionDetailsForCaptureTableAsync: 'api/DevolutionDetail/GetDevolutionDetailsForCaptureTableAsync',
    GetPredevolutionDetail: 'api/DevolutionDetail/GetPredevolutionDetailAsync',
    SavePredevolutionDetails: 'api/DevolutionDetail/SavePredevolutionDetailsAsync',
    UpdateDevolutionDetail: 'api/DevolutionDetail/UpdateAsync',
  },
  devolutionProjection: {
    CreateAsync: 'api/DevolutionProjection/CreateAsync',
    DeleteAsync: 'api/DevolutionProjection/DeleteAsync',
    ExportGeneralConsultation: 'api/DevolutionProjection/ExportGeneralConsultation',
    GetAllDevolutionProjectionsWithPaginationAsync: 'api/DevolutionProjection/GetAllDevolutionProjectionsWithPaginationAsync',
    GetByIdAsync: 'api/DevolutionProjection/GetByIdAsync',
    GetClientsForSelectAsync: 'api/DevolutionProjection/GetClientsForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/DevolutionProjection/GetColumnsForGeneralConsultationAsync',
    GetCostCentersByBranchForSelectAsync: 'api/DevolutionProjection/GetCostCentersByBranchForSelectAsync',
    GetDevolutionProjectionByKeysAsync: 'api/DevolutionProjection/GetDevolutionProjectionByKeysAsync',
    GetFirstDevolutionProjectionByKeysAsync: 'api/DevolutionProjection/GetFirstDevolutionProjectionByKeysAsync',
    GetLastDevolutionProjectionByKeysAsync: 'api/DevolutionProjection/GetLastDevolutionProjectionByKeysAsync',
    GetNextDevolutionProjectionByKeysAsync: 'api/DevolutionProjection/GetNextDevolutionProjectionByKeysAsync',
    GetPreviusDevolutionProjectionByKeysAsync: 'api/DevolutionProjection/GetPreviusDevolutionProjectionByKeysAsync',
    UpdateAsync: 'api/DevolutionProjection/UpdateAsync',
  },
  devolutionProjectionDetail: {
    CreateAsync: 'api/DevolutionProjectionDetail/CreateAsync',
    CreateDetailsAsync: 'api/DevolutionProjectionDetail/CreateDetailsAsync',
    DeleteAsync: 'api/DevolutionProjectionDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/DevolutionProjectionDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/DevolutionProjectionDetail/ExportDetailConsultation',
    GetAllDevolutionProjectionDetailsWithPaginationAsync: 'api/DevolutionProjectionDetail/GetAllDevolutionProjectionDetailsWithPaginationAsync',
    GetArticleAndStoreNamesAsync: 'api/DevolutionProjectionDetail/GetArticleAndStoreNamesAsync',
    GetArticlesForDetailsAsync: 'api/DevolutionProjectionDetail/GetArticlesForDetailsAsync',
    GetByIdAsync: 'api/DevolutionProjectionDetail/GetByIdAsync',
    GetColumnsForArticlesAsync: 'api/DevolutionProjectionDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailCaptureAsync: 'api/DevolutionProjectionDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForDetailConsultationAsync: 'api/DevolutionProjectionDetail/GetColumnsForDetailConsultationAsync',
    GetDetailsForCaptureAsync: 'api/DevolutionProjectionDetail/GetDetailsForCaptureAsync',
    GetDevolutionProjectionDetailByKeysAsync: 'api/DevolutionProjectionDetail/GetDevolutionProjectionDetailByKeysAsync',
    UpdateAsync: 'api/DevolutionProjectionDetail/UpdateAsync',
  },
  documentSupport: {
    AttachFilesToDocumentSupport: 'api/DocumentSupport/AttachFilesToDocumentSupportAsync',
    CopyDocumentSupport: 'api/DocumentSupport/CopyDocumentSupport',
    CreateDocumentSupport: 'api/DocumentSupport/CreateAsync',
    DeleteDocumentSupport: 'api/DocumentSupport/DeleteAsync',
    DeleteFileToDocumentSupport: 'api/DocumentSupport/DeleteFileToDocumentSupportAsync',
    DownloadFileToDocumentSupport: 'api/DocumentSupport/DownloadFileToDocumentSupportAsync',
    DownloadGuideImport: 'api/DocumentSupport/DownloadGuideImport',
    ExportGeneralConsultation: 'api/DocumentSupport/ExportGeneralConsultation',
    ExportImportErrors: 'api/DocumentSupport/ExportImportErrors',
    GetAccountingInterfaceCodeAsync: 'api/DocumentSupport/GetAccountingInterfaceCodeAsync',
    GetAllBussinessDocumentsTypesForSelectAsync: 'api/DocumentSupport/GetAllBussinessDocumentsTypesForSelectAsync',
    GetAllDocumentsSupportWithPagination: 'api/DocumentSupport/GetAllDocumentsSupportWithPaginationAsync',
    GetAllProvidersForSelectAsync: 'api/DocumentSupport/GetAllProvidersForSelectAsync',
    GetColumnsForAttachFiles: 'api/DocumentSupport/GetColumnsForAttachFilesAsync',
    GetColumnsForGeneralConsultation: 'api/DocumentSupport/GetColumnsForGeneralConsultationAsync',
    GetDocumentSupportByConsecutiveAsync: 'api/DocumentSupport/GetDocumentSupportByConsecutiveAsync',
    GetDocumentSupportById: 'api/DocumentSupport/GetByIdAsync',
    GetDocumentSupportByKeys: 'api/DocumentSupport/GetDocumentSupportByKeysAsync',
    GetElectronicInvoiceInterfaceCodeByIdAsync: 'api/DocumentSupport/GetElectronicInvoiceInterfaceCodeByIdAsync',
    GetFilesToDocumentSupport: 'api/DocumentSupport/GetFilesToDocumentSupportAsync',
    GetFirstDocumentSupportByKeys: 'api/DocumentSupport/GetFirstDocumentSupportByKeysAsync',
    GetLastDocumentSupportByKeys: 'api/DocumentSupport/GetLastDocumentSupportByKeysAsync',
    GetNextDocumentSupportByKeys: 'api/DocumentSupport/GetNextDocumentSupportByKeysAsync',
    GetPreviusDocumentSupportByKeys: 'api/DocumentSupport/GetPreviusDocumentSupportByKeysAsync',
    ImportDocumentSupportsAsync: 'api/DocumentSupport/ImportDocumentSupportsAsync',
    PrintDocumentSupport: 'api/DocumentSupport/PrintDocumentsSupport',
    SetActiveDocumentSupport: 'api/DocumentSupport/SetActiveDocumentSupport',
    UpdateDocumentSupport: 'api/DocumentSupport/UpdateAsync',
  },
  documentSupportDetail: {
    GetAllDocumentSupportDetailWithPagination: 'api/DocumentSupportDetail/GetAllDocumentSupportDetailsWithPaginationAsync',
    GetArticlesForDocumentSupport: 'api/DocumentSupportDetail/GetArticlesForDocumentSupportAsync',
    GetColumnsForDetailConsultation: 'api/DocumentSupportDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailCapture: 'api/DocumentSupportDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForArticleCaptureDocumentSupport: 'api/DocumentSupportDetail/GetColumnsForArticleCaptureDocumentSupportAsync',
    GetDocumentSupportDetailById: 'api/DocumentSupportDetail/GetByIdAsync',
    CreateDocumentSupportDetail: 'api/DocumentSupportDetail/CreateAsync',
    CreateDetails: 'api/DocumentSupportDetail/CreateDetailsAsync',
    UpdateDocumentSupportDetail: 'api/DocumentSupportDetail/UpdateAsync',
    DeleteDocumentSupportDetail: 'api/DocumentSupportDetail/DeleteAsync',
    DeleteSomeDetails: 'api/DocumentSupportDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/DocumentSupportDetail/ExportDetailConsultation',
    GetDocumentSupportDetailsByDocumentSupport: 'api/DocumentSupportDetail/GetDocumentSupportDetailsByDocumentSupport',
    GetDocumentSupportDetailByKeys: 'api/DocumentSupportDetail/GetDocumentSupportDetailByKeysAsync',
  },
  electronicDocument: {
    CheckElectronicDocumentAsync: 'api/ElectronicDocument/CheckElectronicDocumentAsync',
    CheckStatusDIAN: 'api/ElectronicDocument/CheckStatusDIAN',
    DownloadPdfAsync: 'api/ElectronicDocument/DownloadPdfAsync',
    ExportPendingSyncDocumentsAsync: 'api/ElectronicDocument/ExportPendingSyncDocumentsAsync',
    GetColumnsForPendingSyncDocumentAsync: 'api/ElectronicDocument/GetColumnsForPendingSyncDocumentAsync',
    GetElectronicDocuments: 'api/ElectronicDocument/GetElectronicDocumentsAsync',
    GetPendingSyncDocumentsWithPaginationAsync: 'api/ElectronicDocument/GetPendingSyncDocumentsWithPaginationAsync',
    GetSendMailAsync: 'api/ElectronicDocument/GetSendMailAsync',
    ResendEmailInvoice: 'api/ElectronicDocument/ResendEmailInvoice',
    ResendEmailNote: 'api/ElectronicDocument/ResendEmailNote',
    SendElectronicDocuments: 'api/ElectronicDocument/SendElectronicDocumentsAsync',
    SendMail: 'api/ElectronicDocument/SendMail',
  },
  electronicInvoiceInterface: {
    ExportGeneralConsultation: 'api/ElectronicInvoiceInterface/ExportGeneralConsultation',
    GetColumnsForGeneralConsultationAsync: 'api/ElectronicInvoiceInterface/GetColumnsForGeneralConsultationAsync',
    GetElectronicInvoiceInterfacesForGeneralConsultation: 'api/ElectronicInvoiceInterface/GetElectronicInvoiceInterfacesForGeneralConsultation',
    GetElectronicInvoiceInterfaceById: 'api/ElectronicInvoiceInterface/GetByIdAsync',
    GetElectronicInvoiceInterfaceByKeys: 'api/ElectronicInvoiceInterface/GetElectronicInvoiceInterfaceByKeysAsync',
    GetFirstElectronicInvoiceInterfaceByKeys: 'api/ElectronicInvoiceInterface/GetFirstElectronicInvoiceInterfaceByKeysAsync',
    GetIndicatorsForDetailConsultation: 'api/ElectronicInvoiceInterface/GetIndicatorsForDetailConsultationAsync',
    GetLastElectronicInvoiceInterfaceByKeys: 'api/ElectronicInvoiceInterface/GetLastElectronicInvoiceInterfaceByKeysAsync',
    GetPreviusElectronicInvoiceInterfaceByKeys: 'api/ElectronicInvoiceInterface/GetPreviusElectronicInvoiceInterfaceByKeysAsync',
    GetNextElectronicInvoiceInterfaceByKeys: 'api/ElectronicInvoiceInterface/GetNextElectronicInvoiceInterfaceByKeysAsync',
    AttachGraphicRepresentationFiles: 'api/ElectronicInvoiceInterface/AttachGraphicRepresentationFilesAsync',
    //Servicios del detalle
    ExportDetailConsultation: 'api/ElectronicInvoiceInterface/ExportDetailConsultation',
    GetColumnsForDetailConsultationAsync: 'api/ElectronicInvoiceInterface/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailCaptureAsync: 'api/ElectronicInvoiceInterface/GetColumnsForDetailCaptureAsync',
    GetElectronicInvoiceInterfaceDetailsForDetailConsultation: 'api/ElectronicInvoiceInterface/GetElectronicInvoiceInterfaceDetailsForDetailConsultation',
    GetElectronicInvoiceInterfaceDetailByIdAsync: 'api/ElectronicInvoiceInterface/GetElectronicInvoiceInterfaceDetailByIdAsync',
    GetDocumentsForGeneratePdfAsync: 'api/ElectronicInvoiceInterface/GetDocumentsForGeneratePdfAsync',
  },
  element: {
    CreateAsync: 'api/Element/CreateAsync',
    DeleteAsync: 'api/Element/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/Element/DeleteSomeDetailsAsync',
    GetAllElementWithPaginationAsync: 'api/Element/GetAllElementWithPaginationAsync',
    GetByCodeAsync: 'api/Element/GetByCodeAsync',
    GetByIdAsync: 'api/Element/GetByIdAsync',
    GetColumnsAsync: 'api/Element/GetColumnsAsync',
    GetElementsByComponentIdAsync: 'api/Element/GetElementsByComponentIdAsync',
    UpdateAsync: 'api/Element/UpdateAsync',
  },
  enterprise: {
    AttachImagesAsync: 'api/Enterprise/AttachImagesAsync',
    CreateEnterprise: 'api/Enterprise/CreateAsync',
    DeleteEnterprise: 'api/Enterprise/DeleteAsync',
    DeleteImagesAsync: 'api/Enterprise/DeleteImagesAsync',
    GetAllEnterprisesForSelectAsync: 'api/Enterprise/GetAllEnterprisesForSelectAsync',
    GetAllEnterprisesWithPaginationAsync: 'api/Enterprise/GetAllEnterprisesWithPaginationAsync',
    GetAllTecnologyProvidersForSelectAsync: 'api/Enterprise/GetAllTecnologyProvidersForSelectAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/Enterprise/GetAllTypeDocumentsForSelectAsync',
    GetAllTypePersonsForSelectAsync: 'api/Enterprise/GetAllTypePersonsForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Enterprise/GetColumnsForGeneralConsultationAsync',
    GetDigitVerification: 'api/Enterprise/GetDigitVerificationAsync',
    GetEnterpriseByBranchId: 'api/Enterprise/GetEnterpriseByBranchIdAsync',
    GetEnterprisesByBranchIdForSelect: 'api/Enterprise/GetEnterprisesByBranchIdForSelectAsync',
    GetEnterpriseByCode: 'api/Enterprise/GetEnterpriseByCodeAsync',
    GetEnterpriseById: 'api/Enterprise/GetByIdAsync',
    GetEnterpriseLogoAsync: 'api/Enterprise/GetEnterpriseLogoAsync',
    GetImagesAsync: 'api/Enterprise/GetImagesAsync',
    GetFirstEnterpriseByBranch: 'api/Enterprise/GetFirstEnterpriseByBranchAsync',
    GetFirstEnterpriseByKeysAsync: 'api/Enterprise/GetFirstEnterpriseByKeysAsync',
    GetLastEnterpriseByKeysAsync: 'api/Enterprise/GetLastEnterpriseByKeysAsync',
    GetNextEnterpriseByKeysAsync: 'api/Enterprise/GetNextEnterpriseByKeysAsync',
    GetPreviusEnterpriseByKeysAsync: 'api/Enterprise/GetPreviusEnterpriseByKeysAsync',
    GetLogo: 'api/Enterprise/GetLogoAsync',
    GetLogoFooter: 'api/Enterprise/GetLogoFooterAsync',
    GetSignature: 'api/Enterprise/GetSignatureAsync',
    SetActiveEnterprise: 'api/Enterprise/SetActiveAsync',
    UpdateEnterprise: 'api/Enterprise/UpdateAsync',
  },
  enterpriseCity: {
    GetAllEnterpriseCities: 'api/EnterpriseCity/GetAllEnterpriseCitiesAsync',
    GetAllEnterpriseCitiesWithPagination: 'api/EnterpriseCity/GetAllEnterpriseCitiesWithPaginationAsync',
    GetColumnsForConsultation: 'api/EnterpriseCity/GetColumnsForConsultationAsync',
    GetEnterpriseCityById: 'api/EnterpriseCity/GetByIdAsync',
    CreateEnterpriseCity: 'api/EnterpriseCity/CreateAsync',
    UpdateEnterpriseCity: 'api/EnterpriseCity/UpdateAsync',
    DeleteEnterpriseCity: 'api/EnterpriseCity/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/EnterpriseCity/DeleteSomeDetailsAsync',
    ExportEnterpriseCitiesConsultation: 'api/EnterpriseCity/ExportEnterpriseCitiesConsultation',
    GetEnterpriseCityByKeys: 'api/EnterpriseCity/GetEnterpriseCityByKeysAsync',
    GetEnterpriseCityByEnterpriseId: 'api/EnterpriseCity/GetEnterpriseCityByEnterpriseIdAsync',
  },
  equipmentLogbook: {
    AttachFileToInvoiceAsync: 'api/EquipmentLogbook/AttachFileToInvoiceAsync',
    CreateAsync: 'api/EquipmentLogbook/CreateAsync',
    DeleteFileToInvoice: 'api/EquipmentLogbook/DeleteFileToInvoiceAsync',
    DownloadGuideImport: 'api/EquipmentLogbook/DownloadGuideImport',
    DownloadFileToInvoice: 'api/EquipmentLogbook/DownloadFileToInvoiceAsync',
    ExportGeneralConsultation: 'api/EquipmentLogbook/ExportGeneralConsultation',
    ExportImportErrors: 'api/EquipmentLogbook/ExportImportErrors',
    GetAllEquipmentLogbooksWithPagination: 'api/EquipmentLogbook/GetAllEquipmentLogbooksWithPaginationAsync',
    GetAllProvidersForSelectAsync: 'api/EquipmentLogbook/GetAllProvidersForSelectAsync',
    GetByIdAsync: 'api/EquipmentLogbook/GetByIdAsync',
    GetColumnsForGeneralConsultation: 'api/EquipmentLogbook/GetColumnsForGeneralConsultationAsync',
    GetEquipmentLogbookByArticleIdAsync: 'api/EquipmentLogbook/GetEquipmentLogbookByArticleIdAsync',
    GetEquipmentLogbookByKeysByPrintAsync: 'api/EquipmentLogbook/GetEquipmentLogbookByKeysByPrintAsync',
    GetEmptyEquipmentLogbookPrint: 'api/EquipmentLogbook/GetEmptyEquipmentLogbookPrint',
    ImportEquipmentLogbooksAsync: 'api/EquipmentLogbook/ImportEquipmentLogbooksAsync',
    UpdateAsync: 'api/EquipmentLogbook/UpdateAsync',
  },
  family: {
    CreateFamily: 'api/Family/CreateAsync',
    DeleteFamily: 'api/Family/DeleteAsync',
    DownloadGuideImport: 'api/Family/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Family/ExportGeneralConsultation',
    ExportImportErrors: 'api/Family/ExportImportErrors',
    GetAllFamiliesWithPaginationAsync: 'api/Family/GetAllFamiliesWithPaginationAsync',
    GetByIdAsync: 'api/Family/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Family/GetColumnsForGeneralConsultationAsync',
    GetFamilyByCode: 'api/Family/GetFamilyByCodeAsync',
    ImportFamilies: 'api/Family/ImportFamiliesAsync',
    UpdateAsync: 'api/Family/UpdateAsync',
  },
  format: {
    CreateFormat: 'api/Format/CreateAsync',
    DeleteFormat: 'api/Format/DeleteAsync',
    DownloadPreviewPdfAsync: 'api/Format/DownloadPreviewPdfAsync',
    ExportGeneralConsultation: 'api/Format/ExportGeneralConsultation',
    GetAllFormat: 'api/Format/GetAllFormatsAsync',
    GetAllFormatsForSelectAsync: 'api/Format/GetAllFormatsForSelectAsync',
    GetAllFormatsWithPaginationAsync: 'api/Format/GetAllFormatsWithPaginationAsync',
    GetAllPaperSizesForSelectAsync: 'api/Format/GetAllPaperSizesForSelectAsync',
    GetByIdAsync: 'api/Format/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Format/GetColumnsForGeneralConsultationAsync',
    GetFirstBranchEnterpriseByCompanyIdAsync: 'api/Format/GetFirstBranchEnterpriseByCompanyIdAsync',
    GetFormatByCode: 'api/Format/GetFormatByCodeAsync',
    GetFormatByCompanyAndCode: 'api/Format/GetFormatByCompanyAndCodeAsync',
    GetFormatByMainCompany: 'api/Format/GetFormatByMainCompanyAsync',
    GetFirstFormatByKeys: 'api/Format/GetFirstFormatByKeysAsync',
    GetLastFormatByKeys: 'api/Format/GetLastFormatByKeysAsync',
    GetNextFormatByKeys: 'api/Format/GetNextFormatByKeysAsync',
    GetPreviusFormatByKeys: 'api/Format/GetPreviusFormatByKeysAsync',
    UpdateFormat: 'api/Format/UpdateAsync',
  },
  formatDetail: {
    CreateFormatDetail: 'api/FormatDetail/CreateAsync',
    DeleteFormatDetail: 'api/FormatDetail/DeleteAsync',
    DeleteSomeDetails: 'api/FormatDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/FormatDetail/ExportDetailConsultation',
    GetAllFormatDetail: 'api/FormatDetail/GetAllFormatDetailsAsync',
    GetAllFormatDetailsWithPaginationAsync: 'api/FormatDetail/GetAllFormatDetailsWithPaginationAsync',
    GetColumnsForCaptureTableAsync: 'api/FormatDetail/GetColumnsForCaptureTableAsync',
    GetByIdAsync: 'api/FormatDetail/GetByIdAsync',
    GetColumnsForDetailConsultationAsync: 'api/FormatDetail/GetColumnsForDetailConsultationAsync',
    GetFormatDetailsByFormatId: 'api/FormatDetail/GetFormatDetailsByFormatIdAsync',
    GetFormatDetailsForCaptureTableAsync: 'api/FormatDetail/GetFormatDetailsForCaptureTableAsync',
    GetFormatDetailByFormatAndName: 'api/FormatDetail/GetFormatDetailByFormatAndNameAsync',
    UpdateFormatDetail: 'api/FormatDetail/UpdateAsync',
    UpdateRangeFormatDetail: 'api/FormatDetail/UpdateRangeAsync',
  },
  freight: {
    CreateAsync: 'api/Freight/CreateAsync',
    DeleteAsync: 'api/Freight/DeleteAsync',
    ExportGeneralConsultation: 'api/Freight/ExportGeneralConsultation',
    GetAllConceptsForSelectAsync: 'api/Freight/GetAllConceptsForSelectAsync',
    GetAllFreightsWithPaginationAsync: 'api/Freight/GetAllFreightsWithPaginationAsync',
    GetByIdAsync: 'api/Freight/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Freight/GetColumnsForGeneralConsultationAsync',
    GetFreightColumnsForConstructionSiteAsync: 'api/Freight/GetFreightColumnsForConstructionSiteAsync',
    GetFreightByDocumentRental: 'api/Freight/GetFreightByDocumentRental',
    GetFreightByKeys: 'api/Freight/GetFreightByKeys',
    UpdateAsync: 'api/Freight/UpdateAsync',

    GetFreightByConstructionSiteAsync: 'api/Freight/GetFreightByConstructionSiteAsync',
    HasFreightsAsync: 'api/Freight/HasFreightsAsync',
  },
  generalParameter: {
    GetAllGeneralParameters: 'api/GeneralParameter/GetAllGeneralParametersAsync',
    GetAllGeneralParameterWithPaginationAsync: 'api/GeneralParameter/GetAllGeneralParameterWithPaginationAsync',
    GetColumnsGeneralParameterAsync: 'api/GeneralParameter/GetColumnsGeneralParameterAsync',
    GetGeneralParametersByCompany: 'api/GeneralParameter/GetGeneralParametersByCompanyAsync',
    GetGeneralParametersByUserAutheticated: 'api/GeneralParameter/GetGeneralParametersByUserAutheticatedAsync',
    SaveGeneralParametersByCompany: 'api/GeneralParameter/SaveGeneralParametersByCompanyAsync',
  },
  group: {
    CreateGroup: 'api/Group/CreateAsync',
    DeleteGroup: 'api/Group/DeleteAsync',
    DownloadGuideImport: 'api/Group/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Group/ExportGeneralConsultation',
    ExportImportErrors: 'api/Group/ExportImportErrors',
    GetAllGroupsForSelectAsync: 'api/Group/GetAllGroupsForSelectAsync',
    GetAllGroupsWithPaginationAsync: 'api/Group/GetAllGroupsWithPaginationAsync',
    GetGroupById: 'api/Group/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Group/GetColumnsForGeneralConsultationAsync',
    GetGroupByCode: 'api/Group/GetGroupByCodeAsync',
    ImportGroups: 'api/Group/ImportGroupsAsync',
    UpdateGroup: 'api/Group/UpdateAsync',
  },
  home: {
    GetCompanyNameByUser: 'api/Home/GetCompanyNameByUserAutheticatedAsync',
    GetUserName: 'api/Home/GetUserNameAutheticated',
  },
  icaRate: {
    CreateIcaRate: 'api/IcaRate/CreateAsync',
    DeleteIcaRate: 'api/IcaRate/DeleteAsync',
    DownloadGuideImport: 'api/IcaRate/DownloadGuideImport',
    ExportGeneralConsultation: 'api/IcaRate/ExportGeneralConsultation',
    ExportImportErrors: 'api/IcaRate/ExportImportErrors',
    GetAllConceptInvoicingForSelectAsync: 'api/IcaRate/GetAllConceptInvoicingForSelectAsync',
    GetAllIcaRatesWithPaginationAsync: 'api/IcaRate/GetAllIcaRatesWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/IcaRate/GetColumnsForGeneralConsultationAsync',
    GetIcaRateById: 'api/IcaRate/GetByIdAsync',
    GetIcaRateByCityByConceptInvoicing: 'api/IcaRate/GetIcaRateByCityIdConceptInvoicingIdAsync',
    ImportIcaRatesAsync: 'api/IcaRate/ImportIcaRatesAsync',
    UpdateIcaRate: 'api/IcaRate/UpdateAsync',
  },
  incomeConcept: {
    CreateIncomeConcept: 'api/IncomeConcept/CreateAsync',
    DeleteIncomeConcept: 'api/IncomeConcept/DeleteAsync',
    ExportGeneralConsultation: 'api/IncomeConcept/ExportGeneralConsultation',
    GetAllIncomeConcept: 'api/IncomeConcept/GetAllIncomeConceptAsync',
    GetAllIncomeConceptsWithPaginationAsync: 'api/IncomeConcept/GetAllIncomeConceptsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/IncomeConcept/GetColumnsForGeneralConsultationAsync',
    GetFirstIncomeConceptByKeysAsync: 'api/IncomeConcept/GetFirstIncomeConceptByKeysAsync',
    GetIncomeConceptByKeys: 'api/IncomeConcept/GetIncomeConceptByKeysAsync',
    GetIncomeConceptByBranchId: 'api/IncomeConcept/GetIncomeConceptByBranchIdAsync',
    GetIncomeConceptById: 'api/IncomeConcept/GetByIdAsync',
    GetLastIncomeConceptByKeysAsync: 'api/IncomeConcept/GetLastIncomeConceptByKeysAsync',
    GetNextIncomeConceptByKeysAsync: 'api/IncomeConcept/GetNextIncomeConceptByKeysAsync',
    GetPreviusIncomeConceptByKeysAsync: 'api/IncomeConcept/GetPreviusIncomeConceptByKeysAsync',
    UpdateIncomeConcept: 'api/IncomeConcept/UpdateAsync',
  },
  internalOrder: {
    AnnulInternalOrder: 'api/InternalOrder/AnnulInternalOrderAsync',
    CreateInternalOrder: 'api/InternalOrder/CreateAsync',
    DeleteInternalOrder: 'api/InternalOrder/DeleteAsync',
    DownloadGuideImport: 'api/InternalOrder/DownloadGuideImport',
    ExportImportErrors: 'api/InternalOrder/ExportImportErrors',
    ExportGeneralConsultation: 'api/InternalOrder/ExportGeneralConsultation',
    GetAllInternalOrders: 'api/InternalOrder/GetAllInternalOrdersAsync',
    GetInternalOrderById: 'api/InternalOrder/GetByIdAsync',
    GetColumnsForGeneralConsultation: 'api/InternalOrder/GetColumnsForGeneralConsultationAsync',
    GetFirstInternalOrderByKeys: 'api/InternalOrder/GetFirstInternalOrderByKeysAsync',
    GetInternalOrderByKeys: 'api/InternalOrder/GetInternalOrderByKeysAsync',
    GetLastInternalOrderByKeys: 'api/InternalOrder/GetLastInternalOrderByKeysAsync',
    GetNextInternalOrderByKeys: 'api/InternalOrder/GetNextInternalOrderByKeysAsync',
    GetPermission: 'api/InternalOrder/GetPermissionAsync',
    GetPrintInternalOrder: 'api/InternalOrder/GetPrintInternalOrderAsync',
    GetEmptyPrintInternalOrder: 'api/InternalOrder/GetEmptyPrintInternalOrder',
    GetPrintInternalOrderByFormat: 'api/InternalOrder/GetPrintInternalOrderByFormat',
    GetPreviusInternalOrderByKeys: 'api/InternalOrder/GetPreviusInternalOrderByKeysAsync',
    ImportInteralOrder: 'api/InternalOrder/ImportInternalOrderAsync',
    SetInternalOrderState: 'api/InternalOrder/SetInternalOrderStateAsync',
    UpdateInternalOrder: 'api/InternalOrder/UpdateAsync',
  },
  internalOrderDetail: {
    CreateInternalOrderDetail: 'api/InternalOrderDetail/CreateAsync',
    CreateByQuotation: 'api/InternalOrderDetail/CreateByQuotationAsync',
    DeleteDetails: 'api/InternalOrderDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/InternalOrderDetail/ExportDetailConsultation',
    GetAllInternalOrderDetails: 'api/InternalOrderDetail/GetAllInternalOrderDetailsAsync',
    GetInternalOrderDetailById: 'api/InternalOrderDetail/GetByIdAsync',
    GetInternalOrderDetailsByInternalOrder: 'api/InternalOrderDetail/GetInternalOrderDetailsByInternalOrder',
    GetColumnsForDetailConsultation: 'api/InternalOrderDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailCapture: 'api/InternalOrderDetail/GetColumnsForDetailCaptureAsync',
    UpdateInternalOrderDetail: 'api/InternalOrderDetail/UpdateAsync',
  },
  inventory: {
    CreateInventory: 'api/Inventory/CreateAsync',
    DeleteInventory: 'api/Inventory/DeleteAsync',
    ExportConsultation: 'api/Inventory/ExportConsultation',
    GetAllInventoriesForSelectAsync: 'api/Inventory/GetAllInventoriesForSelectAsync',
    GetAllInventoriesForSelectWithOutSubrentalAsync: 'api/Inventory/GetAllInventoriesForSelectWithOutSubrentalAsync',
    GetAllInventoriesForSelectReportAsync: 'api/Inventory/GetAllInventoriesForSelectReportAsync',
    GetAllTypeInventoriesForSelectAsync: 'api/Inventory/GetAllTypeInventoriesForSelectAsync',
    GetAllInventoryClassForSelectAsync: 'api/Inventory/GetAllInventoryClassForSelectAsync',
    GetAllInventoriesWithPaginationAsync: 'api/Inventory/GetAllInventoriesWithPaginationAsync',
    GetAllInventoryWithSubrental: 'api/Inventory/GetAllInventoriesWithSubrentalAsync',
    GetAllInventory: 'api/Inventory/GetAllInventoriesAsync',
    GetFirstInventoryByCompanyAuthenticatedAsync: 'api/Inventory/GetFirstInventoryByCompanyAuthenticatedAsync',
    GetFirstInventoryByCompanyId: 'api/Inventory/GetFirstInventoryByCompanyIdAsync',
    GetInventoryByCode: 'api/Inventory/GetInventoryByCodeAsync',
    GetInventoryById: 'api/Inventory/GetByIdAsync',
    GetColumnsConsultationAsync: 'api/Inventory/GetColumnsConsultationAsync',
    GetInventorySubrental: 'api/Inventory/GetInventorySubrentalAsync',
    UpdateInventory: 'api/Inventory/UpdateAsync',
  },
  inventoryBalance: {
    DownloadGuideImport: 'api/InventoryBalance/DownloadGuideImport',
    ExportImportErrors: 'api/InventoryBalance/ExportImportErrors',
    ImportInventoryBalancesAsync: 'api/InventoryBalance/ImportInventoryBalances',
    ReverseImportBalances: 'api/InventoryBalance/ReverseImportBalancesAsync',
  },
  inventoryUser: {
    GetAllInventoryUsersWithPaginationAsync: 'api/InventoryUser/GetAllInventoryUsersWithPaginationAsync',
    GetColumnsInventoryUserAsync: 'api/InventoryUser/GetColumnsInventoryUserAsync',
    SaveInventoryUserAsync: 'api/InventoryUser/SaveInventoryUserAsync',
  },
  inventoryClass: {
    GetAllInventoryClass: 'api/InventoryClass/GetAllInventoryClassesAsync',
    GetAllInventoryClassForSelectAsync: 'api/InventoryClass/GetAllInventoryClassForSelectAsync',
    CreateInventoryClass: 'api/InventoryClass/CreateAsync',
    GetInventoryClassById: 'api/InventoryClass/GetByIdAsync',
    UpdateInventoryClass: 'api/InventoryClass/UpdateAsync',
    DeleteInventoryClass: 'api/InventoryClass/DeleteAsync',
    GetInventoryClassByCode: 'api/InventoryClass/GetInventoryClassByCodeAsync',
    GetInventoryClassesForConsultation: 'api/InventoryClass/GetInventoryClassesForConsultation',
    GetColumnsForConsultation: 'api/InventoryClass/GetColumnsForConsultation',
  },
  inventoryEntry: {
    CreateInventoryEntry: 'api/InventoryEntry/CreateAsync',
    DeleteInventoryEntry: 'api/InventoryEntry/DeleteAsync',
    ExportGeneralConsultation: 'api/InventoryEntry/ExportGeneralConsultation',
    GetAllConceptsForSelectAsync: 'api/InventoryEntry/GetAllConceptsForSelectAsync',
    GetAllInventoriesForSelectAsync: 'api/InventoryEntry/GetAllInventoriesForSelectAsync',
    GetAllInventoryEntryTypesForSelectAsync: 'api/InventoryEntry/GetAllInventoryEntryTypesForSelectAsync',
    GetInventoryEntryById: 'api/InventoryEntry/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InventoryEntry/GetColumnsForGeneralConsultationAsync',
    GetConceptByIdForSelect: 'api/InventoryEntry/GetConceptByIdForSelect',
    GetFirstInventoryEntryByKeysAsync: 'api/InventoryEntry/GetFirstInventoryEntryByKeysAsync',
    GetEmptyPrintInventoryEntry: 'api/InventoryEntry/GetEmptyPrintInventoryEntry',
    GetInventoryByIdForSelect: 'api/InventoryEntry/GetInventoryByIdForSelect',
    GetInventoryEntriesForGeneralConsultation: 'api/InventoryEntry/GetInventoryEntriesForGeneralConsultation',
    GetInventoryEntryByKeysAsync: 'api/InventoryEntry/GetInventoryEntryByKeysAsync',
    GetInventoryEntryTypeByIdForSelect: 'api/InventoryEntry/GetInventoryEntryTypeByIdForSelect',
    GetLastInventoryEntryByKeysAsync: 'api/InventoryEntry/GetLastInventoryEntryByKeysAsync',
    GetNextInventoryEntryByKeysAsync: 'api/InventoryEntry/GetNextInventoryEntryByKeysAsync',
    GetPermissionPrint: 'api/InventoryEntry/GetPermissionPrintAsync',
    GetPrintInventoryEntry: 'api/InventoryEntry/GetPrintInventoryEntryAsync',
    GetPrintInventoryEntryByFormat: 'api/InventoryEntry/GetPrintInventoryEntryByFormat',
    GetPreviusInventoryEntryByKeysAsync: 'api/InventoryEntry/GetPreviusInventoryEntryByKeysAsync',
    GetPurchaseConcept: 'api/InventoryEntry/GetPurchaseConceptAsync',
    SetStateInventoryEntry: 'api/InventoryEntry/SetInventoryEntryStateAsync',
    UpdateInventoryEntry: 'api/InventoryEntry/UpdateAsync',
  },
  inventoryEntryDetail: {
    CreateInventoryEntryDetail: 'api/InventoryEntryDetail/CreateAsync',
    DeleteInventoryEntryDetail: 'api/InventoryEntryDetail/DeleteAsync',
    DeleteSomeDetails: 'api/InventoryEntryDetail/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/InventoryEntryDetail/DownloadGuideImport',
    ExportDetailConsultation: 'api/InventoryEntryDetail/ExportDetailConsultation',
    ExportImportErrors: 'api/InventoryEntryDetail/ExportImportErrors',
    ExportPurchaseOrderPendingConsultation: 'api/InventoryEntryDetail/ExportPurchaseOrderPendingConsultation',
    GetAllArticlesForEntriesForSelectAsync: 'api/InventoryEntryDetail/GetAllArticlesForEntriesForSelectAsync',
    GetArticlesDevolutionForEntries: 'api/InventoryEntryDetail/GetArticlesDevolutionForEntriesAsync',
    GetArticlesForEntries: 'api/InventoryEntryDetail/GetArticlesForEntriesAsync',
    GetArticlesPurchaseOrderForEntries: 'api/InventoryEntryDetail/GetArticlesPurchaseOrderForEntriesAsync',
    GetInventoryEntryDetailById: 'api/InventoryEntryDetail/GetByIdAsync',
    GetColumnsForArticles: 'api/InventoryEntryDetail/GetColumnsForArticlesAsync',
    GetColumnsForArticlesDevolutionForEntries: 'api/InventoryEntryDetail/GetColumnsForArticlesDevolutionForEntriesAsync',
    GetColumnsForArticlesPurchaseOrderForEntries: 'api/InventoryEntryDetail/GetColumnsForArticlesPurchaseOrderForEntriesAsync',
    GetColumnsForCaptureTableAsync: 'api/InventoryEntryDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultationAsync: 'api/InventoryEntryDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForPurchaseOrderPendingConsultation: 'api/InventoryEntryDetail/GetColumnsForPurchaseOrderPendingConsultationAsync',
    GetInventoryEntryDetailByEntryId: 'api/InventoryEntryDetail/GetInventoryEntryDetailsByEntryIdAsync',
    GetInventoryEntryDetailByKeys: 'api/InventoryEntryDetail/GetInventoryEntryDetailByKeysAsync',
    GetInventoryEntryDetailsForCaptureTable: 'api/InventoryEntryDetail/GetInventoryEntryDetailsForCaptureTable',
    GetInventoryEntryDetailsForDetailConsultation: 'api/InventoryEntryDetail/GetInventoryEntryDetailsForDetailConsultation',
    GetPurchaseOrderPendingConsultation: 'api/InventoryEntryDetail/GetPurchaseOrderPendingConsultationAsync',
    GetStocksByArticleIdStoreId: 'api/InventoryEntryDetail/GetStocksByArticleIdStoreIdAsync',
    GetQuantityPendingDevolutionByOrigin: 'api/InventoryEntryDetail/GetQuantityPendingDevolutionByOriginAsync',
    GetQuantityPendingPuchaseOrderByArticle: 'api/InventoryEntryDetail/GetQuantityPendingPuchaseOrderByArticleAsync',
    ImportInventoryEntry: 'api/InventoryEntryDetail/ImportInventoryEntryAsync',
    UpdateInventoryEntryDetail: 'api/InventoryEntryDetail/UpdateAsync',
  },
  synchronizeSiesaCloud: {
    SynchronizeAsync: 'api/SynchronizeSiesaCloud/SynchronizeAsync',
  },
  inventoryOutput: {
    CreateInventoryOutput: 'api/InventoryOutput/CreateAsync',
    DeleteAllBalances: 'api/InventoryOutput/DeleteAllBalances',
    DeleteInventoryOutput: 'api/InventoryOutput/DeleteAsync',
    ExportGeneralConsultation: 'api/InventoryOutput/ExportGeneralConsultation',
    GetAllClientsForSelectAsync: 'api/InventoryOutput/GetAllClientsForSelectAsync',
    GetAllConceptsForSelectAsync: 'api/InventoryOutput/GetAllConceptsForSelectAsync',
    GetAllInventoriesForSelectAsync: 'api/InventoryOutput/GetAllInventoriesForSelectAsync',
    GetAllInventoryOutputTypesForSelectAsync: 'api/InventoryOutput/GetAllInventoryOutputTypesForSelectAsync',
    GetAllInventoryOutputsWithPaginationAsync: 'api/InventoryOutput/GetAllInventoryOutputsWithPaginationAsync',
    GetBussinessDocumentsClassIdAsync: 'api/InventoryOutput/GetBussinessDocumentsClassIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InventoryOutput/GetColumnsForGeneralConsultationAsync',
    GetEmptyInventoryOutputPrint: 'api/InventoryOutput/GetEmptyInventoryOutputPrint',
    GetFirstInventoryOutputByKeysAsync: 'api/InventoryOutput/GetFirstInventoryOutputByKeysAsync',
    GetInventoryOutputById: 'api/InventoryOutput/GetByIdAsync',
    GetInventoryOutputByKeysAsync: 'api/InventoryOutput/GetInventoryOutputByKeysAsync',
    GetInventoryOutputByKeysForPrintAsync: 'api/InventoryOutput/GetInventoryOutputByKeysForPrintAsync',
    GetLastInventoryOutputByKeysAsync: 'api/InventoryOutput/GetLastInventoryOutputByKeysAsync',
    GetNextInventoryOutputByKeysAsync: 'api/InventoryOutput/GetNextInventoryOutputByKeysAsync',
    GetPermissionPrint: 'api/InventoryOutput/GetPermissionPrintAsync',
    GetPreviusInventoryOutputByKeysAsync: 'api/InventoryOutput/GetPreviusInventoryOutputByKeysAsync',
    SetInventoryOutputState: 'api/InventoryOutput/SetInventoryOutputStateAsync',
    UpdateInventoryOutput: 'api/InventoryOutput/UpdateAsync',
  },
  inventoryOutputDetail: {
    CreateInventoryOutputDetail: 'api/InventoryOutputDetail/CreateAsync',
    CreateSomeDetails: 'api/InventoryOutputDetail/CreateDetailsAsync',
    DeleteInventoryOutputDetail: 'api/InventoryOutputDetail/DeleteAsync',
    DeleteSomeDetails: 'api/InventoryOutputDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/InventoryOutputDetail/ExportDetailConsultation',
    ExportPendingOrderConsultation: 'api/InventoryOutputDetail/ExportPendingOrderConsultation',
    GetAllInventoryOutputDetailsWithPaginationAsync: 'api/InventoryOutputDetail/GetAllInventoryOutputDetailsWithPaginationAsync',
    GetAllPendingOrdersWithPaginationAsync: 'api/InventoryOutputDetail/GetAllPendingOrdersWithPaginationAsync',
    GetArticlesForOutputs: 'api/InventoryOutputDetail/GetArticlesForOutputsAsync',
    GetColumnsForArticles: 'api/InventoryOutputDetail/GetColumnsForArticlesAsync',
    GetColumnsForCaptureTableAsync: 'api/InventoryOutputDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultation: 'api/InventoryOutputDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForPendingOrdersConsultation: 'api/InventoryOutputDetail/GetColumnsForPendingOrdersConsultationAsync',
    GetColumnsArticleInternalOrder: 'api/InventoryOutputDetail/GetColumnsForListArticlesInInternalOrderAsync',
    GetColumnsForListStocksInShop: 'api/InventoryOutputDetail/GetColumnsForListStocksInShopAsync',
    GetInventoryOutputDetailById: 'api/InventoryOutputDetail/GetByIdAsync',
    GetInventoryOutputDetailByKeys: 'api/InventoryOutputDetail/GetInventoryOutputDetailByKeysAsync',
    GetInventoryOutputDetailsByOutputId: 'api/InventoryOutputDetail/GetInventoryOutputDetailsByOutputIdAsync',
    GetInventoryOutputDetailsForCaptureTable: 'api/InventoryOutputDetail/GetInventoryOutputDetailsForCaptureTableAsync',
    GetListArticlesInInternalOrder: 'api/InventoryOutputDetail/GetListArticlesInInternalOrderAsync',
    GetListStocksInShop: 'api/InventoryOutputDetail/GetListStocksInShopAsync',
    GetStocksByArticleIdStoreId: 'api/InventoryOutputDetail/GetStocksByArticleIdStoreIdAsync',
    UpdateInventoryOutputDetail: 'api/InventoryOutputDetail/UpdateAsync',
  },
  inventoryPeriod: {
    CreateInventoryPeriod: 'api/InventoryPeriod/CreateAsync',
    DeleteInventoryPeriod: 'api/InventoryPeriod/DeleteAsync',
    ExportDocumentsForDelete: 'api/InventoryPeriod/ExportDocumentsForDelete',
    ExportDocumentsOpenedConsultation: 'api/InventoryPeriod/ExportDocumentsOpenedConsultation',
    ExportGeneralConsultation: 'api/InventoryPeriod/ExportGeneralConsultation',
    GetAllDocumentsForDeleteWithPaginationAsync: 'api/InventoryPeriod/GetAllDocumentsForDeleteWithPaginationAsync',
    GetAllDocumentsOpenedWithPaginationAsync: 'api/InventoryPeriod/GetAllDocumentsOpenedWithPaginationAsync',
    GetAllInventoryPeriodsWithPaginationAsync: 'api/InventoryPeriod/GetAllInventoryPeriodsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InventoryPeriod/GetColumnsForGeneralConsultationAsync',
    GetLastInventoryPeriod: 'api/InventoryPeriod/GetLastInventoryPeriodAsync',
    SetActiveInventoryPeriod: 'api/InventoryPeriod/SetActiveAsync',
    GetColumnsForDocumentsOpenedAsync: 'api/InventoryPeriod/GetColumnsForDocumentsOpenedAsync',
  },
  inventoryReport: {
    EntryShop: 'api/InventoryReport/InventoryReportEntryShop',
    ExportInventoryReportBranchAverageCost: 'api/InventoryReport/ExportInventoryReportBranchAverageCost',
    ExportInventoryReportEntryShop: 'api/InventoryReport/ExportInventoryReportEntryShop',
    ExportInventoryReportKardexArticle: 'api/InventoryReport/ExportInventoryReportKardexArticle',
    ExportInventoryReportOutputShop: 'api/InventoryReport/ExportInventoryReportOutputShop',
    ExportInventoryReportStockMax: 'api/InventoryReport/ExportInventoryReportStockMax',
    ExportInventoryReportStockMin: 'api/InventoryReport/ExportInventoryReportStockMin',
    ExportInventoryReportSummaryInventoryMovement: 'api/InventoryReport/ExportInventoryReportSummaryInventoryMovements',
    ExportInventoryReportTypeDetailedValues: 'api/InventoryReport/ExportInventoryReportTypeDetailedValues',
    ExportInventoryReportTypeSummaryValues: 'api/InventoryReport/ExportInventoryReportTypeSummaryValues',
    ExportInventoryReportTypeQuantities: 'api/InventoryReport/ExportInventoryReportTypeQuantities',
    InventoryReportBranchAverageCost: 'api/InventoryReport/InventoryReportBranchAverageCost',
    KardexArticle: 'api/InventoryReport/InventoryReportKardexArticle',
    OutputShop: 'api/InventoryReport/InventoryReportOutputShop',
    StockMax: 'api/InventoryReport/InventoryReportStockMax',
    StockMin: 'api/InventoryReport/InventoryReportStockMin',
    SummaryInventoryMovements: 'api/InventoryReport/InventoryReportSummaryInventoryMovements',
    TypeDetailedValues: 'api/InventoryReport/InventoryReportTypeDetailedValues',
    TypeSummaryValues: 'api/InventoryReport/InventoryReportTypeSummaryValues',
    TypeQuantities: 'api/InventoryReport/InventoryReportTypeQuantities',
  },
  inventoryTransfer: {
    AnnulInventoryTransfer: 'api/InventoryTransfer/AnnulInventoryTransferAsync',
    ConfirmInventoryTransfer: 'api/InventoryTransfer/ConfirmInventoryTransfer',
    CreateInventoryTransfer: 'api/InventoryTransfer/CreateAsync',
    DeleteInventoryTransfer: 'api/InventoryTransfer/DeleteAsync',
    ExportGeneralConsultation: 'api/InventoryTransfer/ExportGeneralConsultation',
    GetAllTransportersForSelectAsync: 'api/InventoryTransfer/GetAllTransportersForSelectAsync',
    GetAllVehiclesForSelectAsync: 'api/InventoryTransfer/GetAllVehiclesForSelectAsync',
    GetAllStoresForSelectAsync: 'api/InventoryTransfer/GetAllStoresForSelectAsync',
    GetBranchdByStoreId: 'api/InventoryTransfer/GetBranchdByStoreId',
    GetConsecutiveEntryAndOutputByInventoryTransferId: 'api/InventoryTransfer/GetConsecutiveEntryAndOutputByInventoryTransferId',
    GetColumnsForGeneralConsultationAsync: 'api/InventoryTransfer/GetColumnsForGeneralConsultationAsync',
    GetFirstInventoryTransferByKeysAsync: 'api/InventoryTransfer/GetFirstInventoryTransferByKeysAsync',
    GetInventoryTransferById: 'api/InventoryTransfer/GetByIdAsync',
    GetInventoryTransferByKeysAsync: 'api/InventoryTransfer/GetInventoryTransferByKeysAsync',
    GetInventoryTransferForPrint: 'api/InventoryTransfer/GetInventoryTransferForPrintAsync',
    GetInventoryTransfersForGeneralConsultation: 'api/InventoryTransfer/GetInventoryTransfersForGeneralConsultation',
    GetLastInventoryTransferByKeysAsync: 'api/InventoryTransfer/GetLastInventoryTransferByKeysAsync',
    GetNextInventoryTransferByKeysAsync: 'api/InventoryTransfer/GetNextInventoryTransferByKeysAsync',
    GetPreviusInventoryTransferByKeysAsync: 'api/InventoryTransfer/GetPreviusInventoryTransferByKeysAsync',
    HowManyTranfersInTransitByUserAuthenticated: 'api/InventoryTransfer/HowManyTranfersInTransitByUserAuthenticated',
    SetStateInventoryTransfer: 'api/InventoryTransfer/SetStateAsync',
    UpdateInventoryTransfer: 'api/InventoryTransfer/UpdateAsync',
    getEmptyInventoryTransferPrint: 'api/InventoryTransfer/GetEmptyInventoryTransferPrint',
  },
  inventoryTransferDetail: {
    AreThereDetailsWithQuantity0: 'api/InventoryTransferDetail/AreThereDetailsWithQuantity0',
    CreateInventoryTransferDetail: 'api/InventoryTransferDetail/CreateAsync',
    CreateSomeDetails: 'api/InventoryTransferDetail/AddDocumentsToTransporInvoiceAsync',
    DeleteInventoryTransferDetail: 'api/InventoryTransferDetail/DeleteAsync',
    DeleteSomeDetails: 'api/InventoryTransferDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/InventoryTransferDetail/ExportDetailConsultation',
    GetArticlesForDetailsAsync: 'api/InventoryTransferDetail/GetArticlesForDetailsAsync',
    GetColumnsForArticlesAsync: 'api/InventoryTransferDetail/GetColumnsForArticlesAsync',
    GetColumnsForCaptureTableAsync: 'api/InventoryTransferDetail/GetColumnsForCaptureAsync',
    GetColumnsForDetailConsultationAsync: 'api/InventoryTransferDetail/GetColumnsForDetailConsultationAsync',
    GetInventoryTransferDetailById: 'api/InventoryTransferDetail/GetByIdAsync',
    GetDetailsForCaptureTableAsync: 'api/InventoryTransferDetail/GetDetailsForCaptureTableAsync',
    GetInventoryTransferDetailByKeys: 'api/InventoryTransferDetail/GetInventoryTransferDetailByKeysAsync',
    GetInventoryTransferDetailsForDetailConsultation: 'api/InventoryTransferDetail/GetInventoryTransferDetailsForDetailConsultation',
    UpdateInventoryTransferDetail: 'api/InventoryTransferDetail/UpdateAsync',
  },
  purchaseModel: {
    CreatePurchaseModel: 'api/PurchaseModel/CreateAsync',
    DeletePurchaseModel: 'api/PurchaseModel/DeleteAsync',
    ExportGeneralConsultationPurchaseModel: 'api/PurchaseModel/ExportGeneralConsultation',
    GetAllPurchaseModelsWithPaginationAsync: 'api/PurchaseModel/GetAllPurchaseModelsWithPaginationAsync',
    GetPurchaseModelsForSelectionAsync: 'api/PurchaseModel/GetPurchaseModelsForSelectionAsync',
    GetColumnsForGeneralConsultationPurchaseModelAsync: 'api/PurchaseModel/GetColumnsForGeneralConsultationAsync',
    GetFirstPurchaseModelByKeysAsync: 'api/PurchaseModel/GetFirstPurchaseModelAsync',
    GetPurchaseModelByConsecutive: 'api/PurchaseModel/GetPurchaseModelByConsecutiveAsync',
    GetPurchaseModelById: 'api/PurchaseModel/GetByIdAsync',
    GetLastPurchaseModelByKeysAsync: 'api/PurchaseModel/GetLastPurchaseModelAsync',
    GetNextPurchaseModelByKeysAsync: 'api/PurchaseModel/GetNextPurchaseModelAsync',
    GetPreviusPurchaseModelByKeysAsync: 'api/PurchaseModel/GetPreviusPurchaseModelByKeysAsync',
    UpdatePurchaseModel: 'api/PurchaseModel/UpdateAsync',
  },
  invoicingModel: {
    CreateInvoicingModel: 'api/InvoicingModel/CreateAsync',
    CopyInvoicingModel: 'api/InvoicingModel/CopyAsync',
    DeleteInvoicingModel: 'api/InvoicingModel/DeleteAsync',
    ExportGeneralConsultation: 'api/InvoicingModel/ExportGeneralConsultation',
    GetAllInvoicingModelsWithPaginationAsync: 'api/InvoicingModel/GetAllInvoicingModelsWithPaginationAsync',
    GetInvoicingModelsForSelectionAsync: 'api/InvoicingModel/GetInvoicingModelsForSelectionAsync',
    GetColumnsInvoicingModelAsync: 'api/InvoicingModel/GetColumnsInvoicingModelAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InvoicingModel/GetColumnsForGeneralConsultationAsync',
    GetFirstInvoicingModelByKeysAsync: 'api/InvoicingModel/GetFirstInvoicingModelAsync',
    GetInvoicingModelByConsecutive: 'api/InvoicingModel/GetInvoicingModelByConsecutiveAsync',
    GetInvoicingModelById: 'api/InvoicingModel/GetByIdAsync',
    GetLastInvoicingModelByKeysAsync: 'api/InvoicingModel/GetLastInvoicingModelAsync',
    GetNextInvoicingModelByKeysAsync: 'api/InvoicingModel/GetNextInvoicingModelAsync',
    GetPreviusInvoicingModelByKeysAsync: 'api/InvoicingModel/GetPreviusInvoicingModelByKeysAsync',
    UpdateInvoicingModel: 'api/InvoicingModel/UpdateAsync',
  },
  invoicingModelDetail: {
    CreateDetails: 'api/InvoicingModelDetail/CreateDetailsAsync',
    CreateInvoicingModelDetail: 'api/InvoicingModelDetail/CreateAsync',
    CreatePurchaseModelDetailAsync: 'api/InvoicingModelDetail/CreatePurchaseModelDetailAsync',
    DeleteSomeDetails: 'api/InvoicingModelDetail/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/InvoicingModelDetail/DownloadGuideImport',
    DownloadPurchaseGuideImport: 'api/InvoicingModelDetail/DownloadPurchaseGuideImport',
    ExportDetailConsultation: 'api/InvoicingModelDetail/ExportDetailConsultation',
    GetAllInvoicingModelDetailsWithPaginationAsync: 'api/InvoicingModelDetail/GetAllInvoicingModelDetailsWithPaginationAsync',
    GetAllPurchaseModelDetailsWithPaginationAsync: 'api/InvoicingModelDetail/GetAllPurchaseModelDetailsWithPaginationAsync',
    GetColumnsForCaptureTableAsync: 'api/InvoicingModelDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForTaxesAsync: 'api/InvoicingModelDetail/GetColumnsForTaxesAsync',
    GetColumnsForDetailConsultationAsync: 'api/InvoicingModelDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForPurchaseDetailConsultationAsync: 'api/InvoicingModelDetail/GetColumnsForPurchaseDetailConsultationAsync',
    GetColumnsInvoicingModelDetailAsync: 'api/InvoicingModelDetail/GetColumnsInvoicingModelDetailAsync',
    GetColumnsPurchaseModelDetailAsync: 'api/InvoicingModelDetail/GetColumnsPurchaseModelDetailAsync',
    GetInvoicingModelDetailById: 'api/InvoicingModelDetail/GetByIdAsync',
    GetInvoicingModelDetailByIdForSelectionAsync: 'api/InvoicingModelDetail/GetInvoicingModelsDetailForSelectionAsync',
    GetPurchaseModelDetailByIdForSelectionAsync: 'api/InvoicingModelDetail/GetPurchaseModelsDetailForSelectionAsync',
    GetInvoicingModelDetailByKeys: 'api/InvoicingModelDetail/GetInvoicingModelDetailByKeysAsync',
    GetInvoicingModelDetailsForCaptureTableAsync: 'api/InvoicingModelDetail/GetInvoicingModelDetailsForCaptureTableAsync',
    GetInvoicingModelDetailsByModel: 'api/InvoicingModelDetail/GetInvoicingModelDetailsByModelAsync',
    GetColumnsForCaptureTablePurchaseConceptAsync: 'api/InvoicingModelDetail/GetColumnsForCaptureTablePurchaseConceptAsync',
    GetPurchaseModelDetailsForCaptureTableAsync: 'api/InvoicingModelDetail/GetPurchaseModelDetailsForCaptureTableAsync',
    GetTaxesForDetailsAsync: 'api/InvoicingModelDetail/GetTaxesForDetailsAsync',
    ImportInvoicingModelDetailsAsync: 'api/InvoicingModelDetail/ImportInvoicingModelDetailsAsync',
    ImportPurchaseModelDetailsAsync: 'api/InvoicingModelDetail/ImportPurchaseModelDetailsAsync',
    UpdateInvoicingModelDetail: 'api/InvoicingModelDetail/UpdateAsync',
    UpdatePurchaseModelDetail: 'api/InvoicingModelDetail/UpdatePurchaseModelDetailAsync',
  },
  invoice: {
    AttachFilesToInvoice: 'api/Invoice/AttachFilesToInvoiceAsync',
    BlockInvoice: 'api/Invoice/BlockInvoiceAsync',
    CopyInvoice: 'api/Invoice/CopyInvoice',
    CreateInvoice: 'api/Invoice/CreateAsync',
    DeleteFilesToInvoice: 'api/Invoice/DeleteFileToInvoiceAsync',
    DeleteInvoice: 'api/Invoice/DeleteAsync',
    DownloadFileToInvoice: 'api/Invoice/DownloadFileToInvoiceAsync',
    DownloadGuideImport: 'api/Invoice/DownloadGuideImport',
    ExportImportErrors: 'api/Invoice/ExportImportErrors',
    ExportGeneralConsultation: 'api/Invoice/ExportGeneralConsultation',
    GetAccountingInterfaceCodeAsync: 'api/Invoice/GetAccountingInterfaceCodeAsync',
    GetAllAttachmentsWithPaginationAsync: 'api/Invoice/GetAllAttachmentsWithPaginationAsync',
    GetAllBussinessDocumentsTypesForSelectAsync: 'api/Invoice/GetAllBussinessDocumentsTypesForSelectAsync',
    GetAllClientsForSelectAsync: 'api/Invoice/GetAllClientsForSelectAsync',
    GetAllCostCenterForSelectAsync: 'api/Invoice/GetAllCostCenterForSelectAsync',
    GetAllCostCenterByBranchIdForSelectAsync: 'api/Invoice/GetAllCostCenterByBranchIdForSelectAsync',
    GetAllCostCenterForPreinvoiceSelectAsync: 'api/Invoice/GetAllCostCenterForPreinvoiceSelectAsync',
    GetAllInvoiceOperationsForSelectAsync: 'api/Invoice/GetAllInvoiceOperationsForSelectAsync',
    GetAllInvoiceWalletTypeForSelectAsync: 'api/Invoice/GetAllInvoiceWalletTypeForSelectAsync',
    GetAllInvoicesWithPagination: 'api/Invoice/GetAllInvoicesWithPaginationAsync',
    GetAllIvaTypeForSelectAsync: 'api/Invoice/GetAllIvaTypeForSelectAsync',
    GetAllPaymentMethodsForSelectAsync: 'api/Invoice/GetAllPaymentMethodsForSelectAsync',
    GetAllTypeDIANForSelectAsync: 'api/Invoice/GetAllTypeDIANForSelectAsync',
    GetAllZonesForSelectsAsync: 'api/Invoice/GetAllZonesForSelectsAsync',
    GetAllZonesByBranchIdForSelectsAsync: 'api/Invoice/GetAllZonesByBranchIdForSelectsAsync',
    GetClientByIdForRegisterInvoiceAsync: 'api/Invoice/GetClientByIdForRegisterInvoiceAsync',
    GetColumnsForAttachmentsAsync: 'api/Invoice/GetColumnsForAttachmentsAsync',
    GetColumnsForGeneralConsultation: 'api/Invoice/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoicesByClientAsync: 'api/Invoice/GetColumnsForInvoicesByClientAsync',
    GetElectronicInvoiceInterfaceCodeByIdAsync: 'api/Invoice/GetElectronicInvoiceInterfaceCodeByIdAsync',
    GetFilesToInvoice: 'api/Invoice/GetFilesToInvoiceAsync',
    GetFirstInvoiceByKeys: 'api/Invoice/GetFirstInvoiceByKeysAsync',
    GetInvoiceById: 'api/Invoice/GetByIdAsync',
    GetInvoiceByKeys: 'api/Invoice/GetInvoiceByKeysAsync',
    GetInvoiceCodeByIdForPrintingRangeAsync: 'api/Invoice/GetInvoiceCodeByIdForPrintingRangeAsync',
    GetInvoicingCutoffCodeByIdAsync: 'api/Invoice/GetInvoicingCutoffCodeByIdAsync',
    GetInvoicesByClientIdAsync: 'api/Invoice/GetInvoicesByClientIdAsync',
    GetLastInvoiceByKeys: 'api/Invoice/GetLastInvoiceByKeysAsync',
    GetMovementCodeByIdAsync: 'api/Invoice/GetMovementCodeByIdAsync',
    GetNextInvoiceByKeys: 'api/Invoice/GetNextInvoiceByKeysAsync',
    GetPermissionPrint: 'api/Invoice/GetPermissionPrintAsync',
    GetPreviusInvoiceByKeys: 'api/Invoice/GetPreviusInvoiceByKeysAsync',
    GetPrintInvoiceForFormat: 'api/Invoice/GetPrintInvoiceForFormatAsync',
    GetRentalPeriodByIdForRegisterInvoiceAsync: 'api/Invoice/GetRentalPeriodByIdForRegisterInvoiceAsync',
    ImportInvoices: 'api/Invoice/ImportInvoicesAsync',
    SetInvoiceState: 'api/Invoice/SetInvoiceStateAsync',
    SetInvoiceWalletType: 'api/Invoice/SetInvoiceWalletTypeAsync',
    PrintInvoices: 'api/Invoice/PrintInvoicesAsync',
    PrintsInvoices: 'api/Invoice/PrintInvoices',
    UpdateInvoice: 'api/Invoice/UpdateAsync',
    VerifyInvoiceContado: 'api/Invoice/VerifyInvoiceContadoAsync',
    GetInvoiceByParams: 'api/Invoice/GetInvoiceByParamsAsync',
    GenerateInvoiceToPdf: 'api/InvoicePdf/GenerateInvoiceToPdf',
  },
  invoiceCashReceipt: {
    CreateAsync: 'api/InvoiceCashReceipt/CreateAsync',
    CreateSomeAsync: 'api/InvoiceCashReceipt/CreateSomeAsync',
    DeleteInvoiceCashReceipt: 'api/InvoiceCashReceipt/DeleteAsync',
    DeleteSomeInvoiceCashReceipts: 'api/InvoiceCashReceipt/DeleteSomeInvoiceCashReceiptsAsync',
    ExportInvoiceCashReceiptsConsultation: 'api/InvoiceCashReceipt/ExportInvoiceCashReceiptsConsultation',
    ExportInvoiceCashReceiptDetailsConsultation: 'api/InvoiceCashReceipt/ExportInvoiceCashReceiptDetailsConsultation',
    GetAllInvoiceCashReceiptsWithPaginationAsync: 'api/InvoiceCashReceipt/GetAllInvoiceCashReceiptsWithPaginationAsync',
    GetColumnsForCaptureTableAsync: 'api/InvoiceCashReceipt/GetColumnsForCaptureTableAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InvoiceCashReceipt/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoiceSelectionAsync: 'api/InvoiceCashReceipt/GetColumnsForInvoiceSelectionAsync',
    GetInvoiceCashReceiptById: 'api/InvoiceCashReceipt/GetByIdAsync',
    GetInvoiceCashReceiptByKeys: 'api/InvoiceCashReceipt/GetInvoiceCashReceiptByKeysAsync',
    GetInvoiceCashReceiptsByCashReceiptId: 'api/InvoiceCashReceipt/GetInvoiceCashReceiptsByCashReceiptIdAsync',
    GetInvoicesForCashReceipt: 'api/InvoiceCashReceipt/GetInvoicesForCashReceipt',
    GetInvoiceCashsForCaptureTable: 'api/InvoiceCashReceipt/GetInvoiceCashsForCaptureTableAsync',
    GetListInvoicesForSelectionAsync: 'api/InvoiceCashReceipt/GetListInvoicesForSelectionAsync',
    UpdateInvoiceCashReceipt: 'api/InvoiceCashReceipt/UpdateAsync',
  },
  invoiceCashReceiptRetention: {
    CreateInvoiceCashReceiptRetention: 'api/InvoiceCashReceiptRetention/CreateAsync',
    DeleteInvoiceCashReceiptRetention: 'api/InvoiceCashReceiptRetention/DeleteAsync',
    GetColumnsForModalConsultationAsync: 'api/InvoiceCashReceiptRetention/GetColumnsForModalConsultationAsync',
    GetAllRetentionsModalWithPaginationAsync: 'api/InvoiceCashReceiptRetention/GetAllRetentionsModalWithPaginationAsync',
    GetInvoiceCashReceiptRetentionById: 'api/InvoiceCashReceiptRetention/GetByIdAsync',
    GetInvoiceCashReceiptRetentionByKeys: 'api/InvoiceCashReceiptRetention/GetInvoiceCashReceiptRetentionByKeysAsync',
    GetInvoiceCashReceiptRetentionsByInvoiceCashReceipt: 'api/InvoiceCashReceiptRetention/GetInvoiceCashReceiptRetentionsByInvoiceCashReceiptAsync',
    UpdateInvoiceCashReceiptRetention: 'api/InvoiceCashReceiptRetention/UpdateAsync',
  },
  invoiceConcept: {
    GetInvoiceConceptById: 'api/InvoiceConcept/GetByIdAsync',
    GetInvoiceConceptsByInvoiceId: 'api/InvoiceConcept/GetInvoiceConceptsByInvoiceIdAsync',
    SaveGeneralDiscount: 'api/InvoiceConcept/SaveGeneralDiscountAsync',
    GetReteFuenteByInvoiceAndConcept: 'api/InvoiceConcept/GetReteFuenteByInvoiceAndConceptAsync',
    GetReteIcaByInvoiceAndConcept: 'api/InvoiceConcept/GetReteIcaByInvoiceAndConceptAsync',
    GetBaseIvaByInvoiceAndConcept: 'api/InvoiceConcept/GetBaseIvaByInvoiceAndConceptAsync',
    GetColumnsForConceptConsultation: 'api/InvoiceConcept/GetColumnsForConceptConsultationAsync',
    GetColumnsForInvoiceDiscountConceptAsync: 'api/InvoiceConcept/GetColumnsForInvoiceDiscountConceptAsync',
    GetAllInvoiceConceptsWithPagination: 'api/InvoiceConcept/GetAllInvoiceConceptsWithPaginationAsync',
    GetInvoiceConceptsByInvoiceIdWithPagination: 'api/InvoiceConcept/GetInvoiceConceptsByInvoiceIdWithPagination',
    ExportConceptConsultation: 'api/InvoiceConcept/ExportConceptConsultation',
    GetConceptInvoicingNameByIdAsync: 'api/InvoiceConcept/GetConceptInvoicingNameByIdAsync',
    GetConceptInvoicingCodeNameByIdAsync: 'api/InvoiceConcept/GetConceptInvoicingCodeNameByIdAsync',
  },
  invoiceDetail: {
    CreateDetailFromSalesRemissionAsync: 'api/InvoiceDetail/CreateDetailFromSalesRemissionAsync',
    CreateInvoiceDetail: 'api/InvoiceDetail/CreateAsync',
    DeleteInvoiceDetail: 'api/InvoiceDetail/DeleteAsync',
    DeleteSomeDetails: 'api/InvoiceDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/InvoiceDetail/ExportDetailConsultation',
    ExportInvoiceDetailsAsync: 'api/InvoiceDetail/ExportInvoiceDetailsAsync',
    GetAllConceptInvoicingForSelectAsync: 'api/InvoiceDetail/GetAllConceptInvoicingForSelectAsync',
    GetAllInvoiceDetailsWithPagination: 'api/InvoiceDetail/GetAllInvoiceDetailsWithPaginationAsync',
    GetAllStoreForSelectAsync: 'api/InvoiceDetail/GetAllStoreForSelectAsync',
    GetArticleByIdAsync: 'api/InvoiceDetail/GetArticleByIdAsync',
    GetArticlesForInvoicesAsync: 'api/InvoiceDetail/GetArticlesForInvoicesAsync',
    GetColumnsForArticlesAsync: 'api/InvoiceDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailConsultation: 'api/InvoiceDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailsInvoiceAsync: 'api/InvoiceDetail/GetColumnsForDetailsInvoiceAsync',
    GetInvoiceDetailById: 'api/InvoiceDetail/GetByIdAsync',
    GetInvoiceDetailByKeys: 'api/InvoiceDetail/GetInvoiceDetailByKeysAsync',
    GetInvoiceDetailsByInvoiceId: 'api/InvoiceDetail/GetInvoiceDetailsByInvoiceIdAsync',
    GetInvoicesDetailsByInvoiceIdWithPagination: 'api/InvoiceDetail/GetInvoicesDetailsByInvoiceIdWithPagination',
    GetListStocksInShop: 'api/InvoiceDetail/GetListStocksInShopAsync',
    GetPriceArticleByConceptInvoicing: 'api/InvoiceDetail/GetPriceArticleByConceptInvoicing',
    GetStocksByArticleIdStoreId: 'api/InvoiceDetail/GetStocksByArticleIdStoreIdAsync',
    UpdateInvoiceDetail: 'api/InvoiceDetail/UpdateAsync',
  },
  invoicingCutoff: {
    CreateInvoicingCutoff: 'api/InvoicingCutoff/CreateAsync',
    DeleteCostCentersWithAlerts: 'api/InvoicingCutoff/DeleteCostCentersWithAlertsAsync',
    DeleteInvoicingCutoff: 'api/InvoicingCutoff/DeleteAsync',
    ExportGeneralConsultation: 'api/InvoicingCutoff/ExportGeneralConsultation',
    ExportPreInvoicingErrorsTxt: 'api/InvoicingCutoff/ExportPreInvoicingErrorsTxt',
    GetAllEnterprisesForSelectAsync: 'api/InvoicingCutoff/GetAllEnterprisesForSelectAsync',
    GetAllInvoicingCutoffsWithPaginationAsync: 'api/InvoicingCutoff/GetAllInvoicingCutoffsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/InvoicingCutoff/GetColumnsForGeneralConsultationAsync',
    GetConsecutiveInvoicingCutoff: 'api/InvoicingCutoff/GetConsecutiveInvoicingCutoffAsync',
    GetFirstInvoicingCutoffByKeys: 'api/InvoicingCutoff/GetFirstInvoicingCutoffByKeysAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/InvoicingCutoff/GetIndicatorsForGeneralConsultationAsync',
    GetInitialAndFinalInvoiceByIdAsync: 'api/InvoicingCutoff/GetInitialAndFinalInvoiceByIdAsync',
    GetInitialAndFinalInvoiceByKeysAsync: 'api/InvoicingCutoff/GetInitialAndFinalInvoiceByKeysAsync',
    GetInvoicingCutoffById: 'api/InvoicingCutoff/GetByIdAsync',
    GetInvoicingCutoffByKeys: 'api/InvoicingCutoff/GetInvoicingCutoffByKeysAsync',
    GetInvoicingCutoffByKeysForFormats: 'api/InvoicingCutoff/GetInvoicingCutoffByKeysForFormats',
    GetLastInvoicingCutoffByKeys: 'api/InvoicingCutoff/GetLastInvoicingCutoffByKeysAsync',
    GetLastInvoicingCutoffByKeysForFormats: 'api/InvoicingCutoff/GetLastInvoicingCutoffByKeysForFormats',
    GetNextInvoicingCutoffByKeys: 'api/InvoicingCutoff/GetNextInvoicingCutoffByKeysAsync',
    GetPreviusInvoicingCutoffByKeys: 'api/InvoicingCutoff/GetPreviusInvoicingCutoffByKeysAsync',
    GetPrintInvoicingCutoffForFormat: 'api/InvoicingCutoff/GetPrintInvoicingCutoffForFormatAsync',
    GetUserBlockByIdAsync: 'api/InvoicingCutoff/GetUserBlockByIdAsync',
    OpenInvoicingCutoffById: 'api/InvoicingCutoff/OpenInvoicingCutoffByIdAsync',
    PreInvoicingByInvoicingCutoffId: 'api/InvoicingCutoff/PreInvoicingByInvoicingCutoffIdAsync',
    SuspendInvoicingCutoffById: 'api/InvoicingCutoff/SuspendInvoicingCutoffByIdAsync',
    ToInvoiceInvoicingCutoffById: 'api/InvoicingCutoff/ToInvoiceInvoicingCutoffByIdAsync',
    UnlockAllInvoicingCutoff: 'api/InvoicingCutoff/UnlockAllInvoicingCutoffAsync',
    UnlockInvoicingCutoffByBranchId: 'api/InvoicingCutoff/UnlockInvoicingCutoffByBranchIdAsync',
    UnlockInvoicingCutoffById: 'api/InvoicingCutoff/UnlockInvoicingCutoffByIdAsync',
    UpdateInvoicingCutoff: 'api/InvoicingCutoff/UpdateAsync',
    ValidateCountInvoicingCutoffsOpen: 'api/InvoicingCutoff/ValidateCountInvoicingCutoffsOpenAsync',
  },
  invoicingCutoffDetail: {
    CreateInvoicingCutoffDetail: 'api/InvoicingCutoffDetail/CreateAsync',
    DeleteInvoicingCutoffDetail: 'api/InvoicingCutoffDetail/DeleteAsync',
    ExportDetailConsultation: 'api/InvoicingCutoffDetail/ExportDetailConsultation',
    GetAllInvoicingCutoffDetailsWithPaginationAsync: 'api/InvoicingCutoffDetail/GetAllInvoicingCutoffDetailsWithPaginationAsync',
    GetColumnsForCostCenters: 'api/InvoicingCutoffDetail/GetColumnsForCostCentersAsync',
    GetColumnsForDetailConsultationAsync: 'api/InvoicingCutoffDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForInvoicingConcepts: 'api/InvoicingCutoffDetail/GetColumnsForInvoicingConceptsAsync',
    GetColumnsForRegisterTable: 'api/InvoicingCutoffDetail/GetColumnsForRegisterTableAsync',
    GetCostCentersForInvoicingCutoffAsync: 'api/InvoicingCutoffDetail/GetCostCentersForInvoicingCutoffAsync',
    GetInvoicingConceptsForInvoicingCutoffAsync: 'api/InvoicingCutoffDetail/GetInvoicingConceptsForInvoicingCutoffAsync',
    GetInvoicingCutoffDetailById: 'api/InvoicingCutoffDetail/GetByIdAsync',
    GetInvoicingCutoffDetailsForRegisterTable: 'api/InvoicingCutoffDetail/GetInvoicingCutoffDetailsForRegisterTable',
    ThereDetailsWithoutMovements: 'api/InvoicingCutoffDetail/ThereDetailsWithoutMovements',
    UpdateInvoicingCutoffDetail: 'api/InvoicingCutoffDetail/UpdateAsync',
  },
  invoicingReport: {
    ExportInvoicingReportDiscountsLowerHundredPercent: 'api/InvoicingReport/ExportInvoicingReportDiscountsLowerHundredPercent',
    ExportInvoicingReportDiscountsTopThirtyPercent: 'api/InvoicingReport/ExportInvoicingReportDiscountsTopThirtyPercent',
    ExportIncomeCostcenterEquipment: 'api/InvoicingReport/ExportIncomeCostcenterEquipment',
    ExportInvoicingReportIncomeReport: 'api/InvoicingReport/ExportInvoicingReportIncomeReport',
    ExportInvoicingReportInvoicesByConcept: 'api/InvoicingReport/ExportInvoicingReportInvoicesByConcept',
    ExportInvoicingReportInvoicesGenerated: 'api/InvoicingReport/ExportInvoicingReportInvoicesGenerated',
    ExportInvoicingReportInvoicingAddressReport: 'api/InvoicingReport/ExportInvoicingReportInvoicingAddressReport',
    ExportInvoicingReportInvoicingBusinessType: 'api/InvoicingReport/ExportInvoicingReportInvoicingBusinessType',
    ExportInvoicingReportInvoicingClient: 'api/InvoicingReport/ExportInvoicingReportInvoicingClient',
    ExportInvoicingReportInvoicingClientConstructionSiteCostCenter: 'api/InvoicingReport/ExportInvoicingReportInvoicingClientConstructionSiteCostCenter',
    ExportInvoicingReportInvoicingClientCostCenterGroup: 'api/InvoicingReport/ExportInvoicingReportInvoicingClientCostCenterGroup',
    ExportInvoicingReportInvoicingConcept: 'api/InvoicingReport/ExportInvoicingReportInvoicingConcept',
    ExportInvoicingReportInvoicingConceptSeller: 'api/InvoicingReport/ExportInvoicingReportInvoicingConceptSeller',
    ExportInvoicingReportInvoicingCostCenter: 'api/InvoicingReport/ExportInvoicingReportInvoicingCostCenter',
    ExportInvoicingReportInvoicingFamily: 'api/InvoicingReport/ExportInvoicingReportInvoicingFamily',
    ExportInvoicingReportInvoicingSellerConcept: 'api/InvoicingReport/ExportInvoicingReportInvoicingSellerConcept',
    ExportInvoicingReportInvoicingSellerKilograms: 'api/InvoicingReport/ExportInvoicingReportInvoicingSellerKilograms',
    ExportInvoicingReportItemRevenue: 'api/InvoicingReport/ExportInvoicingReportItemRevenue',
    ExportInvoicingReportPreInvoicingItemRevenue: 'api/InvoicingReport/ExportInvoicingReportPreInvoicingItemRevenue',
    ExportInvoicingReportDailyReportVoucher: 'api/InvoicingReport/ExportInvoicingReportDailyReportVoucher',
    ExportInvoicingReportInvoicingKilograms: 'api/InvoicingReport/ExportInvoicingReportInvoicingKilograms',
    ExportInvoicingReportItemRevenueStore: 'api/InvoicingReport/ExportInvoicingReportItemRevenueStore',
    ExportInvoicingReportPendingInvoice: 'api/InvoicingReport/ExportInvoicingReportPendingInvoice',
    ExportInvoicingReportTaxReport: 'api/InvoicingReport/ExportInvoicingReportTaxReport',
    ExportInvoicingReportTotalMonth: 'api/InvoicingReport/ExportInvoicingReportTotalMonth',
    ExportInvoicingReportBalancesCostcenter: 'api/InvoicingReport/ExportInvoicingReportBalancesCostcenter',
    InvoicingAddressReport: 'api/InvoicingReport/InvoicingReportAddressReport',
    InvoicesByConcept: 'api/InvoicingReport/InvoicingReportInvoicesByConcept',
    InvoicesGenerated: 'api/InvoicingReport/InvoicingReportInvoicesGenerated',
    InvoicingClient: 'api/InvoicingReport/InvoicingReportInvoicingClient',
    InvoicingClientConstructionSiteCostCenter: 'api/InvoicingReport/InvoicingReportInvoicingClientConstructionSiteCostCenter',
    InvoicingClientCostCenterGroup: 'api/InvoicingReport/InvoicingReportInvoicingClientCostCenterGroup',
    DiscountsTopThirtyPercent: 'api/InvoicingReport/InvoicingReportDiscountsTopThirtyPercent',
    DiscountsLowerHundredPercent: 'api/InvoicingReport/InvoicingReportDiscountsLowerHundredPercent',
    IncomeCostcenterEquipment: 'api/InvoicingReport/InvoicingReportIncomeCostCenterEquipment',
    IncomeReport: 'api/InvoicingReport/InvoicingReportIncomeReport',
    InvoicingConcept: 'api/InvoicingReport/InvoicingReportInvoicingConcept',
    InvoicingConceptSeller: 'api/InvoicingReport/InvoicingReportInvoicingConceptSeller',
    InvoicingCostCenter: 'api/InvoicingReport/InvoicingReportInvoicingCostCenter',
    InvoicingFamily: 'api/InvoicingReport/InvoicingReportFamilyRevenue',
    InvoicingReportDailyReportVoucher: 'api/InvoicingReport/InvoicingReportDailyReportVoucher',
    InvoicingKilograms: 'api/InvoicingReport/InvoicingReportInvoicingKilograms',
    ItemRevenue: 'api/InvoicingReport/InvoicingReportItemRevenue',
    PreInvoicingItemRevenue: 'api/InvoicingReport/InvoicingReportPreInvoicingItemRevenue',
    ItemRevenueStore: 'api/InvoicingReport/InvoicingReportItemRevenueStore',
    PendingInvoice: 'api/InvoicingReport/InvoicingReportPendingInvoice',
    TaxReport: 'api/InvoicingReport/InvoicingReportTaxReport',
    TotalMonth: 'api/InvoicingReport/InvoicingReportTotalMonth',
    InvoicingSellerConcept: 'api/InvoicingReport/InvoicingReportInvoicingSellerConcept',
    InvoicingSellerKilograms: 'api/InvoicingReport/InvoicingReportInvoicingSellerKilograms',
    InvoicingBusinessType: 'api/InvoicingReport/InvoicingReportBusinessType',
    InvoicingBalancesCostcenter: 'api/InvoicingReport/InvoicingReportBalancesCostcenter',
  },
  login: {
    LoginUser: 'api/User/LoginUser',
    LogoutUser: 'api/User/LogoutUser',
  },
  maintenanceActivities: {
    CreateAsync: 'api/MaintenanceActivities/CreateAsync',
    DeleteAsync: 'api/MaintenanceActivities/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceActivities/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/MaintenanceActivities/DownloadGuideImport',
    ExportGeneralConsultation: 'api/MaintenanceActivities/ExportGeneralConsultation',
    ExportImportErrors: 'api/MaintenanceActivities/ExportImportErrors',
    GetAllMaintenanceActivitiesWithPaginationAsync: 'api/MaintenanceActivities/GetAllMaintenanceActivitiesWithPaginationAsync',
    GetByIdAsync: 'api/MaintenanceActivities/GetByIdAsync',
    GetByCodeAsync: 'api/MaintenanceActivities/GetByCodeAsync',
    GetColumnsForGeneralConsultationAsync: 'api/MaintenanceActivities/GetColumnsForGeneralConsultationAsync',
    GetFirstMaintenanceActivitiesByKeysAsync: 'api/MaintenanceActivities/GetFirstMaintenanceActivitiesByKeysAsync',
    GetLastMaintenanceActivitiesByKeysAsync: 'api/MaintenanceActivities/GetLastMaintenanceActivitiesByKeysAsync',
    GetNextMaintenanceActivitiesByKeysAsync: 'api/MaintenanceActivities/GetNextMaintenanceActivitiesByKeysAsync',
    GetPreviusMaintenanceActivitiesByKeysAsync: 'api/MaintenanceActivities/GetPreviusMaintenanceActivitiesByKeysAsync',
    ImportMaintenanceActivitiesAsync: 'api/MaintenanceActivities/ImportMaintenanceActivitiesAsync',
    UpdateAsync: 'api/MaintenanceActivities/UpdateAsync',
  },
  maintenanceOrder: {
    AnnulMaintenanceOrderAsync: 'api/MaintenanceOrder/AnnulMaintenanceOrderAsync',
    AttachFilesToMaintenanceOrderAsync: 'api/MaintenanceOrder/AttachFilesToMaintenanceOrderAsync',
    BlockMaintenanceOrderAsync: 'api/MaintenanceOrder/BlockMaintenanceOrderAsync',
    CreateAsync: 'api/MaintenanceOrder/CreateAsync',
    CreateRescheduledMaintenanceOrderAsync: 'api/MaintenanceOrder/CreateRescheduledMaintenanceOrderAsync',
    DeleteAsync: 'api/MaintenanceOrder/DeleteAsync',
    DeleteFileToMaintenanceOrderAsync: 'api/MaintenanceOrder/DeleteFileToMaintenanceOrderAsync',
    DownloadFileToMaintenanceOrderAsync: 'api/MaintenanceOrder/DownloadFileToMaintenanceOrderAsync',
    DownloadGuideImport: 'api/MaintenanceOrder/DownloadGuideImport',
    ExportGeneralConsultation: 'api/MaintenanceOrder/ExportGeneralConsultation',
    ExportImportErrors: 'api/MaintenanceOrder/ExportImportErrors',
    ManageSuspensionAsync: 'api/MaintenanceOrder/ManageSuspensionAsync',
    GetFilesToMaintenanceOrderAsync: 'api/MaintenanceOrder/GetFilesToMaintenanceOrderAsync',
    GetAllCostCentersForSelectMaintenanceOrderAsync: 'api/MaintenanceOrder/GetAllCostCentersForSelectMaintenanceOrderAsync',
    GetAllMaintenanceOrdersWithPaginationAsync: 'api/MaintenanceOrder/GetAllMaintenanceOrdersWithPaginationAsync',
    GetByIdAsync: 'api/MaintenanceOrder/GetByIdAsync',
    GetColumnsForAttachmentsAsync: 'api/MaintenanceOrder/GetColumnsForAttachmentsAsync',
    GetColumnsForEquipmentAsync: 'api/MaintenanceOrder/GetColumnsForEquipmentAsync',
    GetColumnsForGeneralConsultationAsync: 'api/MaintenanceOrder/GetColumnsForGeneralConsultationAsync',
    GetCurrentNoteStage: 'api/MaintenanceOrder/GetCurrentNoteStage',
    GetCurrentHourometerAsync: 'api/MaintenanceOrder/GetCurrentHourometerAsync',
    GetEquipmentAsync: 'api/MaintenanceOrder/GetEquipmentAsync',
    GetFirstMaintenanceOrderByKeysAsync: 'api/MaintenanceOrder/GetFirstMaintenanceOrderByKeysAsync',
    GetLastMaintenanceOrderByKeysAsync: 'api/MaintenanceOrder/GetLastMaintenanceOrderByKeysAsync',
    GetMaintenanceOrderByKeysAsync: 'api/MaintenanceOrder/GetMaintenanceOrderByKeysAsync',
    GetMaintenanceOrderByKeysByPrintAsync: 'api/MaintenanceOrder/GetMaintenanceOrderByKeysByPrintAsync',
    GetMaintenanceOrderScheduledByKeysByPrintAsync: 'api/MaintenanceOrder/GetMaintenanceOrderScheduledByKeysByPrintAsync',
    GetNextMaintenanceOrderByKeysAsync: 'api/MaintenanceOrder/GetNextMaintenanceOrderByKeysAsync',
    GetPreviusMaintenanceOrderByKeysAsync: 'api/MaintenanceOrder/GetPreviusMaintenanceOrderByKeysAsync',
    GetSuspensionByMaintenanceOrderAsync: 'api/MaintenanceOrder/GetSuspensionByMaintenanceOrderAsync',
    GetTotalActivitiesRescheduledAsync: 'api/MaintenanceOrder/GetTotalActivitiesRescheduledAsync',
    HasExistingMaintenanceOrderAsync: 'api/MaintenanceOrder/HasExistingMaintenanceOrderAsync',
    ImportMaintenanceOrdersAsync: 'api/MaintenanceOrder/ImportMaintenanceOrdersAsync',
    UpdateAsync: 'api/MaintenanceOrder/UpdateAsync',
    ValidateKmHoromValueAsyncAsync: 'api/MaintenanceOrder/ValidateKmHoromValueAsync',
    ValidateMaintenanceOrderOriginAsync: 'api/MaintenanceOrder/ValidateMaintenanceOrderOriginAsync',
  },
  maintenanceOrderActivities: {
    CreateActivitiesByMaintenancePlanAsync: 'api/MaintenanceOrderActivities/CreateActivitiesByMaintenancePlanAsync',
    DeleteAllMaintenanceOrderActivitiesAsync: 'api/MaintenanceOrderActivities/DeleteAllMaintenanceOrderActivitiesAsync',
    GetMaintenanceOrderActivitiesAsync: 'api/MaintenanceOrderActivities/GetMaintenanceOrderActivitiesAsync',
    GetTotalMaintenanceOrderActivitiesAsync: 'api/MaintenanceOrderActivities/GetTotalMaintenanceOrderActivitiesAsync',
    UpdateAsync: 'api/MaintenanceOrderActivities/UpdateAsync',
  },
  maintenanceOrderSupplies: {
    CreateAsync: 'api/MaintenanceOrderSupplies/CreateAsync',
    CreateSuppliesByMaintenancePlanAsync: 'api/MaintenanceOrderSupplies/CreateSuppliesByMaintenancePlanAsync',
    DeleteAsync: 'api/MaintenanceOrderSupplies/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceOrderSupplies/DeleteSomeDetailsAsync',
    GetAllMaintenanceOrderSuppliesWithPaginationAsync: 'api/MaintenanceOrderSupplies/GetAllMaintenanceOrderSuppliesWithPaginationAsync',
    GetByIdAsync: 'api/MaintenanceOrderSupplies/GetByIdAsync',
    GetColumnsForTableAsync: 'api/MaintenanceOrderSupplies/GetColumnsForTableAsync',
    GetListHomologousArticlesByArticleIdAsync: 'api/MaintenanceOrderSupplies/GetListHomologousArticlesByArticleIdAsync',
    GetMaintenanceOrderSuppliesByKeysAsync: 'api/MaintenanceOrderSupplies/GetMaintenanceOrderSuppliesByKeysAsync',
    UpdateAsync: 'api/MaintenanceOrderSupplies/UpdateAsync',
  },
  maintenanceOrderNote: {
    CreateAsync: 'api/MaintenanceOrderNote/CreateAsync',
    DeleteAsync: 'api/MaintenanceOrderNote/DeleteAsync',
    ExportGeneralConsultation: 'api/MaintenanceOrderNote/ExportGeneralConsultation',
    GetAllMaintenanceOrderNotesForSelectAsync: 'api/MaintenanceOrderNote/GetAllMaintenanceOrderNotesForSelectAsync',
    GetAllMaintenanceOrderNotesWithPaginationAsync: 'api/MaintenanceOrderNote/GetAllMaintenanceOrderNotesWithPaginationAsync',
    GetByIdAsync: 'api/MaintenanceOrderNote/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/MaintenanceOrderNote/GetColumnsForGeneralConsultationAsync',
    UpdateAsync: 'api/MaintenanceOrderNote/UpdateAsync',
  },
  maintenanceRoutine: {
    CopyMaintenanceRoutineAsync: 'api/MaintenanceRoutine/CopyMaintenanceRoutineAsync',
    CreateAsync: 'api/MaintenanceRoutine/CreateAsync',
    DeleteAsync: 'api/MaintenanceRoutine/DeleteAsync',
    DownloadGuideImport: 'api/MaintenanceRoutine/DownloadGuideImport',
    ExportGeneralConsultation: 'api/MaintenanceRoutine/ExportGeneralConsultation',
    ExportImportErrors: 'api/MaintenanceRoutine/ExportImportErrors',
    GetAllMaintenanceRoutinesForSelectAsync: 'api/MaintenanceRoutine/GetAllMaintenanceRoutinesForSelectAsync',
    GetArticleByIdAsync: 'api/MaintenanceRoutine/GetArticleByIdAsync',
    GetArticlesForMaintenanceRoutineAsync: 'api/MaintenanceRoutine/GetArticlesForMaintenanceRoutineAsync',
    GetByIdAsync: 'api/MaintenanceRoutine/GetByIdAsync',
    GetColumnsAsync: 'api/MaintenanceRoutine/GetColumnsAsync',
    GetColumnsForArticlesAsync: 'api/MaintenanceRoutine/GetColumnsForArticlesAsync',
    GetEmptyMaintenanceRoutinePrint: 'api/MaintenanceRoutine/GetEmptyMaintenanceRoutinePrint',
    GetMaintenanceRoutineByArticleAsync: 'api/MaintenanceRoutine/GetMaintenanceRoutineByArticleAsync',
    GetMaintenanceRoutineByKeysByPrintAsync: 'api/MaintenanceRoutine/GetMaintenanceRoutineByKeysByPrintAsync',
    GetMaintenanceRoutineWithPaginationAsync: 'api/MaintenanceRoutine/GetMaintenanceRoutineWithPaginationAsync',
    ImportMaintenanceRoutine: 'api/MaintenanceRoutine/ImportMaintenanceRoutineAsync',
    SetActiveAsync: 'api/MaintenanceRoutine/SetActiveAsync',
  },
  maintenanceRoutineDetail: {
    CreateMultipleDetailsAsync: 'api/MaintenanceRoutineDetail/CreateMultipleDetailsAsync',
    DeleteAsync: 'api/MaintenanceRoutineDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceRoutineDetail/DeleteSomeDetailsAsync',
    GetAllMaintenanceRoutineDetailsWithPaginationAsync: 'api/MaintenanceRoutineDetail/GetAllMaintenanceRoutineDetailsWithPaginationAsync',
    GetMaintenanceRoutineDetailsByElementIdAsync: 'api/MaintenanceRoutineDetail/GetMaintenanceRoutineDetailsByElementIdAsync',
    GetByIdAsync: 'api/MaintenanceRoutineDetail/GetByIdAsync',
    GetMaintenanceActivitiesForSelectionAsync: 'api/MaintenanceRoutineDetail/GetMaintenanceActivitiesForSelectionAsync',
    GetColumnsAsync: 'api/MaintenanceRoutineDetail/GetColumnsAsync',
    GetColumnsForActivitiesAsync: 'api/MaintenanceRoutineDetail/GetColumnsForActivitiesAsync',
    UpdateAsync: 'api/MaintenanceRoutineDetail/UpdateAsync',
  },
  maintenanceRoutineHomologous: {
    CreateMultipleHomologousAsync: 'api/MaintenanceRoutineHomologous/CreateMultipleHomologousAsync',
    DeleteAsync: 'api/MaintenanceRoutineHomologous/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceRoutineHomologous/DeleteSomeDetailsAsync',
    GetAllSuppliesHomologousAsync: 'api/MaintenanceRoutineHomologous/GetAllSuppliesHomologousAsync',
    GetHomologousByMainArticleAsync: 'api/MaintenanceRoutineHomologous/GetHomologousByMainArticleAsync',
    GetByIdAsync: 'api/MaintenanceRoutineHomologous/GetByIdAsync',
    GetColumnsAsync: 'api/MaintenanceRoutineHomologous/GetColumnsAsync',
    GetColumnsForSuppliesAsync: 'api/MaintenanceRoutineHomologous/GetColumnsForSuppliesAsync',
  },
  maintenanceRoutineSupply: {
    CreateMultipleSuppliesAsync: 'api/MaintenanceRoutineSupply/CreateMultipleSuppliesAsync',
    CreateAsync: 'api/MaintenanceRoutineSupply/CreateAsync',
    DeleteAsync: 'api/MaintenanceRoutineSupply/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceRoutineSupply/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/MaintenanceRoutineSupply/DownloadGuideImport',
    ExportImportErrors: 'api/MaintenanceRoutineSupply/ExportImportErrors',
    GetAllSuppliesAsync: 'api/MaintenanceRoutineSupply/GetAllSuppliesAsync',
    GetAllSuppliesForSelectAsync: 'api/MaintenanceRoutineSupply/GetAllSuppliesForSelectAsync',
    GetByIdAsync: 'api/MaintenanceRoutineSupply/GetByIdAsync',
    GetColumnsAsync: 'api/MaintenanceRoutineSupply/GetColumnsAsync',
    GetColumnsForArticlesAsync: 'api/MaintenanceRoutineSupply/GetColumnsForArticlesAsync',
    GetMaintenanceRoutineSupplyByKeysAsync: 'api/MaintenanceRoutineSupply/GetMaintenanceRoutineSupplyByKeysAsync',
    GetMaintenanceRoutineSuppliesWithPaginationAsync: 'api/MaintenanceRoutineSupply/GetMaintenanceRoutineSuppliesWithPaginationAsync',
    GetQuantitySuppliesAsync: 'api/MaintenanceRoutineSupply/GetQuantitySuppliesAsync',
    ImportMaintenanceRoutineSupply: 'api/MaintenanceRoutineSupply/ImportMaintenanceRoutineSupply',
    UpdateAsync: 'api/MaintenanceRoutineSupply/UpdateAsync',
  },
  maintenanceScheduling: {
    CreateAsync: 'api/MaintenanceScheduling/CreateAsync',
    DeleteAsync: 'api/MaintenanceScheduling/DeleteAsync',
    ExportGeneralConsultation: 'api/MaintenanceScheduling/ExportGeneralConsultation',
    GetAllMaintenanceSchedulingWithPaginationAsync: 'api/MaintenanceScheduling/GetAllMaintenanceSchedulingWithPaginationAsync',
    GetByIdAsync: 'api/MaintenanceScheduling/GetByIdAsync',
    GetByCodeAsync: 'api/MaintenanceScheduling/GetByCodeAsync',
    GetColumnsForGeneralConsultationAsync: 'api/MaintenanceScheduling/GetColumnsForGeneralConsultationAsync',
    GetFirstMaintenanceSchedulingByKeysAsync: 'api/MaintenanceScheduling/GetFirstMaintenanceSchedulingByKeysAsync',
    GetLastMaintenanceSchedulingByKeysAsync: 'api/MaintenanceScheduling/GetLastMaintenanceSchedulingByKeysAsync',
    GetLastMaintenanceSchedulingByTypeAsync: 'api/MaintenanceScheduling/GetLastMaintenanceSchedulingByTypeAsync',
    GetNextMaintenanceSchedulingByKeysAsync: 'api/MaintenanceScheduling/GetNextMaintenanceSchedulingByKeysAsync',
    GetPreviousMaintenanceSchedulingByKeysAsync: 'api/MaintenanceScheduling/GetPreviousMaintenanceSchedulingByKeysAsync',
    GetMaintenanceSchedulingByKeysAsync: 'api/MaintenanceScheduling/GetMaintenanceSchedulingByKeysAsync',
    GetPermissionAsync: 'api/MaintenanceScheduling/GetPermissionAsync',
    GetTotalWithoutMaintenanceOrder: 'api/MaintenanceScheduling/GetTotalWithoutMaintenanceOrder',
    SetActiveAsync: 'api/MaintenanceScheduling/SetActiveAsync',
    UpdateAsync: 'api/MaintenanceScheduling/UpdateAsync',
  },
  maintenanceSchedulingDetail: {
    DeleteSomeDetailsAsync: 'api/MaintenanceSchedulingDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/MaintenanceSchedulingDetail/ExportDetailConsultation',
    ExportProcessErrorsTxt: 'api/MaintenanceSchedulingDetail/ExportProcessErrorsTxt',
    GenerateMaintenanceOrdersAsync: 'api/MaintenanceSchedulingDetail/GenerateMaintenanceOrdersAsync',
    GetAllMaintenanceSchedulingDetailsWithPaginationAsync: 'api/MaintenanceSchedulingDetail/GetAllMaintenanceSchedulingDetailsWithPaginationAsync',
    GetColumnsForDetailConsultationAsync: 'api/MaintenanceSchedulingDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsDetailsForCaptureAsync: 'api/MaintenanceSchedulingDetail/GetColumnsDetailsForCaptureAsync',
    GetColumnsDetailByDaysForCaptureAsync: 'api/MaintenanceSchedulingDetail/GetColumnsDetailByDaysForCaptureAsync',
    GetColumnsForArticlesAsync: 'api/MaintenanceSchedulingDetail/GetColumnsForArticlesAsync',
    GetColumnsForPendingMaintenanceSchedulingByOrderAsync: 'api/MaintenanceSchedulingDetail/GetColumnsForPendingMaintenanceSchedulingByOrderAsync',
    GetAllArticlesAsync: 'api/MaintenanceSchedulingDetail/GetAllArticlesAsync',
    GetDetailsForCaptureAsync: 'api/MaintenanceSchedulingDetail/GetDetailsForCaptureAsync',
    GetPendingMaintenanceSchedulingByOrderAsync: 'api/MaintenanceSchedulingDetail/GetPendingMaintenanceSchedulingByOrderAsync',
    ProcessMaintenanceSchedulingByDaysAsync: 'api/MaintenanceSchedulingDetail/ProcessMaintenanceSchedulingByDaysAsync',
    ProcessMaintenanceSchedulingByHourometerAsync: 'api/MaintenanceSchedulingDetail/ProcessMaintenanceSchedulingByHourometerAsync',
  },
  maintenanceStrategy: {
    CreateAsync: 'api/MaintenanceStrategy/CreateAsync',
    DeleteAsync: 'api/MaintenanceStrategy/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MaintenanceStrategy/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/MaintenanceStrategy/DownloadGuideImport',
    ExportImportErrors: 'api/MaintenanceStrategy/ExportImportErrors',
    GetAllMaintenanceStrategiesWithPaginationAsync: 'api/MaintenanceStrategy/GetAllMaintenanceStrategiesWithPaginationAsync',
    GetAllUnitsForSelectAsync: 'api/MaintenanceStrategy/GetAllUnitsForSelectAsync',
    GetMaintenancePlansAsync: 'api/MaintenanceStrategy/GetMaintenancePlansAsync',
    GetMaintenancePlansByArticleAsync: 'api/MaintenanceStrategy/GetMaintenancePlansByArticleAsync',
    GetByIdAsync: 'api/MaintenanceStrategy/GetByIdAsync',
    GetColumnsForTableAsync: 'api/MaintenanceStrategy/GetColumnsForTableAsync',
    GetLastMaintenanceStrategyAsync: 'api/MaintenanceStrategy/GetLastMaintenanceStrategyAsync',
    GetTotalMaintenanceStrategiesAsync: 'api/MaintenanceStrategy/GetTotalMaintenanceStrategiesAsync',
    ImportMaintenanceStrategy: 'api/MaintenanceStrategy/ImportMaintenanceStrategy',
    UpdateAsync: 'api/MaintenanceStrategy/UpdateAsync',
  },
  masterSolution: {
    ChangeStateAsync: 'api/MasterSolution/ChangeStateAsync',
    CreateAsync: 'api/MasterSolution/CreateAsync',
    DeleteAsync: 'api/MasterSolution/DeleteAsync',
    ExportGeneralConsultation: 'api/MasterSolution/ExportGeneralConsultation',
    GetAllMasterSolutionsWithPaginationAsync: 'api/MasterSolution/GetAllMasterSolutionsWithPaginationAsync',
    GetByIdAsync: 'api/MasterSolution/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/MasterSolution/GetColumnsForGeneralConsultationAsync',
    GetColumnsMasterSolutionSelection: 'api/MasterSolution/GetColumnsMasterSolutionSelectionAsync',
    GetFirstMasterSolutionByKeys: 'api/MasterSolution/GetFirstMasterSolutionByKeysAsync',
    GetLastMasterSolutionByKeys: 'api/MasterSolution/GetLastMasterSolutionByKeysAsync',
    GetMasterSolutionByKeys: 'api/MasterSolution/GetMasterSolutionByKeysAsync',
    GetMasterSolutionsForSelection: 'api/MasterSolution/GetMasterSolutionsForSelectionAsync',
    GetNextMasterSolutionByKeys: 'api/MasterSolution/GetNextMasterSolutionByKeysAsync',
    GetPreviusMasterSolutionByKeys: 'api/MasterSolution/GetPreviusMasterSolutionByKeysAsync',
    UpdateAsync: 'api/MasterSolution/UpdateAsync',
  },
  compositeArticleDetail: {
    CreateAsync: 'api/CompositeArticleDetail/CreateAsync',
    CreateDetailsAsync: 'api/CompositeArticleDetail/CreateDetailsAsync',
    DeleteAsync: 'api/CompositeArticleDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/CompositeArticleDetail/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/CompositeArticleDetail/DownloadGuideImport',
    ExportDetailConsultation: 'api/CompositeArticleDetail/ExportDetailConsultation',
    ExportImportErrors: 'api/CompositeArticleDetail/ExportImportErrors',
    GetArticlesForSelectionAsync: 'api/CompositeArticleDetail/GetArticlesForSelectionAsync',
    GetByIdAsync: 'api/CompositeArticleDetail/GetByIdAsync',
    GetColumnsForArticleSelectionAsync: 'api/CompositeArticleDetail/GetColumnsForArticleSelectionAsync',
    GetColumnsForDetailCaptureAsync: 'api/CompositeArticleDetail/GetColumnsForDetailCaptureAsync',
    GetCompositeArticleDetailsForSelectionAsync: 'api/CompositeArticleDetail/GetCompositeArticleDetailsForSelectionAsync',
    GetColumnsForDetailConsultationAsync: 'api/CompositeArticleDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailSelectionAsync: 'api/CompositeArticleDetail/GetColumnsForDetailSelectionAsync',
    GetCompositeArticleDetailByKeysAsync: 'api/CompositeArticleDetail/GetCompositeArticleDetailByKeysAsync',
    GetCompositeArticleDetailsForCaptureAsync: 'api/CompositeArticleDetail/GetCompositeArticleDetailsForCaptureAsync',
    GetCompositeArticleDetailsWithPaginationAsync: 'api/CompositeArticleDetail/GetCompositeArticleDetailsWithPaginationAsync',
    // ImportCompositeArticleDetailsAsync: 'api/CompositeArticleDetail/ImportCompositeArticleDetailsAsync',
    UpdateAsync: 'api/CompositeArticleDetail/UpdateAsync',
  },
  masterSolutionDetail: {
    CreateAsync: 'api/MasterSolutionDetail/CreateAsync',
    CreateDetailsAsync: 'api/MasterSolutionDetail/CreateDetailsAsync',
    DeleteAsync: 'api/MasterSolutionDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MasterSolutionDetail/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/MasterSolutionDetail/DownloadGuideImport',
    ExportDetailConsultation: 'api/MasterSolutionDetail/ExportDetailConsultation',
    ExportImportErrors: 'api/MasterSolutionDetail/ExportImportErrors',
    GetAllMasterSolutionDetailsWithPaginationAsync: 'api/MasterSolutionDetail/GetAllMasterSolutionDetailsWithPaginationAsync',
    GetArticlesForDetailsAsync: 'api/MasterSolutionDetail/GetArticlesForDetailsAsync',
    GetByIdAsync: 'api/MasterSolutionDetail/GetByIdAsync',
    GetColumnsForDetailConsultationAsync: 'api/MasterSolutionDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForArticles: 'api/MasterSolutionDetail/GetColumnsForArticlesAsync',
    GetColumnsMasterSolutionDetails: 'api/MasterSolutionDetail/GetColumnsMasterSolutionDetailsAsync',
    GetDetailsByMasterSolutionIdAsync: 'api/MasterSolutionDetail/GetDetailsByMasterSolutionIdAsync',
    GetMasterSolutionDetailsForSelection: 'api/MasterSolutionDetail/GetMasterSolutionDetailsForSelectionAsync',
    GetMasterSolutionrDetailByKeys: 'api/MasterSolutionDetail/GetMasterSolutionDetailByKeysAsync',
    ImportTransferDetailsAsync: 'api/MasterSolutionDetail/ImportSolutionDetailsAsync',
    UpdateAsync: 'api/MasterSolutionDetail/UpdateAsync',
  },
  mechanic: {
    CreateMechanic: 'api/Mechanic/CreateAsync',
    DeleteMechanic: 'api/Mechanic/DeleteAsync',
    DownloadGuideImport: 'api/Mechanic/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Mechanic/ExportGeneralConsultation',
    ExportImportErrors: 'api/Mechanic/ExportImportErrors',
    GetAllMechanicsForSelectAsync: 'api/Mechanic/GetAllMechanicsForSelectAsync',
    GetAllMechanicsWithPaginationAsync: 'api/Mechanic/GetAllMechanicsWithPaginationAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/Mechanic/GetAllTypeDocumentsForSelectAsync',
    GetDigitVerification: 'api/Mechanic/GetDigitVerificationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Mechanic/GetColumnsForGeneralConsultationAsync',
    GetMechanicByDocumentAsync: 'api/Mechanic/GetMechanicByDocumentAsync',
    GetMechanicById: 'api/Mechanic/GetByIdAsync',
    GetMechanicByName: 'api/Mechanic/GetMechanicByNameAsync',
    GetMechanicsByBranchId: 'api/Mechanic/GetMechanicsByBranchIdAsync',
    ImportMechanic: 'api/Mechanic/ImportMechanicsAsync',
    SetActiveMechanic: 'api/Mechanic/SetActive',
    UpdateMechanic: 'api/Mechanic/UpdateAsync',
    UpdateMechanicDocument: 'api/Mechanic/UpdateMechanicDocumentAsync',
  },
  meter: {
    ChangeStateAsync: 'api/Meter/ChangeStateAsync',
    CreateAsync: 'api/Meter/CreateAsync',
    DeleteAsync: 'api/Meter/DeleteAsync',
    ExportGeneralConsultation: 'api/Meter/ExportGeneralConsultation',
    GetAllMetersWithPaginationAsync: 'api/Meter/GetAllMetersWithPaginationAsync',
    GetByIdAsync: 'api/Meter/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Meter/GetColumnsForGeneralConsultationAsync',
    GetFirstMeterByKeysAsync: 'api/Meter/GetFirstMeterByKeysAsync',
    GetLastMeterByKeysAsync: 'api/Meter/GetLastMeterByKeysAsync',
    GetMeterByKeysAsync: 'api/Meter/GetMeterByKeysAsync',
    GetNextMeterByKeysAsync: 'api/Meter/GetNextMeterByKeysAsync',
    GetPreviousMeterByKeysAsync: 'api/Meter/GetPreviousMeterByKeysAsync',
    UpdateAsync: 'api/Meter/UpdateAsync',
  },
  meterDetail: {
    CreateAsync: 'api/MeterDetail/CreateAsync',
    CreateDetailsAsync: 'api/MeterDetail/CreateDetailsAsync',
    DeleteAsync: 'api/MeterDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/MeterDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/MeterDetail/ExportDetailConsultation',
    GetAllMeterDetailsWithPaginationAsync: 'api/MeterDetail/GetAllMeterDetailsWithPaginationAsync',
    GetArticlesForSelectionAsync: 'api/MeterDetail/GetArticlesForSelectionAsync',
    GetDetailsForCaptureAsync: 'api/MeterDetail/GetDetailsForCaptureAsync',
    GetByIdAsync: 'api/MeterDetail/GetByIdAsync',
    GetCalculatedQuantityAsync: 'api/MeterDetail/GetCalculatedQuantityAsync',
    GetColumnsArticlesForSelectionAsync: 'api/MeterDetail/GetColumnsArticlesForSelectionAsync',
    GetColumnsForDetailConsultationAsync: 'api/MeterDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsDetailsForCaptureAsync: 'api/MeterDetail/GetColumnsDetailsForCaptureAsync',
    GetMeterDetailByKeysAsync: 'api/MeterDetail/GetMeterDetailByKeysAsync',
    ResetHourMeterAsync: 'api/MeterDetail/ResetHourMeterAsync',
    CalculateResetHourMeterAsync: 'api/MeterDetail/CalculateResetHourMeterAsync',
    UpdateAsync: 'api/MeterDetail/UpdateAsync',
  },
  module: {
    GetAllModulesByPlatform: 'api/Module/GetAllModulesByPlatform',
    CreateModule: 'api/Module/CreateAsync',
    GetMenuByUser: 'api/Module/GetMenuByUser',
    GetMenuByCompany: 'api/Module/GetMenuByCompanyAsync',
    GetMenuByCompanyAuthenticatedByPlatform: 'api/Module/GetMenuByCompanyAuthenticatedByPlatform',
    GetMenuByProfileUser: 'api/Module/GetMenuByProfileUserAsync',
    SaveModulesByCompany: 'api/Module/SaveModulesByCompanyAsync',
    SaveModulesByProfileUser: 'api/Module/SaveModulesByProfileUserAsync',
  },
  movement: {
    ExportPreinvoicesAsync: 'api/Movement/ExportPreinvoicesAsync',
    GetAllMovementsByInvoicingCutoffId: 'api/Movement/GetAllMovementsByInvoicingCutoffIdAsync',
    GetBaseIvaByMovementAndConcept: 'api/Movement/GetBaseIvaByMovementAndConceptAsync',
    GetPrintPreinvoices: 'api/Movement/GetPrintPreinvoicesAsync',
    GetReteFuenteByMovementAndConcept: 'api/Movement/GetReteFuenteByMovementAndConceptAsync',
    GetReteIcaByMovementAndConcept: 'api/Movement/GetReteIcaByMovementAndConceptAsync',
    GetRetentionsByMovement: 'api/Movement/GetRetentionsByMovementAsync',
    GetRetentionsByMovements: 'api/Movement/GetRetentionsByMovementsAsync',
  },
  note: {
    AnnulInvoiceByNote: 'api/Note/AnnulInvoiceByNoteAsync',
    CreateNote: 'api/Note/CreateAsync',
    DeleteNote: 'api/Note/DeleteAsync',
    DownloadGuideImport: 'api/Note/DownloadGuideImport',
    ExportImportErrors: 'api/Article/ExportImportErrors',
    ExportGeneralConsultation: 'api/Note/ExportGeneralConsultation',
    GenerateNoteByRequestNoteAsync: 'api/Note/GenerateNoteByRequestNoteAsync',
    GetAccountingInterfaceCodeAsync: 'api/Note/GetAccountingInterfaceCodeAsync',
    GetAllBussinessDocumentsTypesForSelectAsync: 'api/Note/GetAllBussinessDocumentsTypesForSelectAsync',
    GetAllBussinessDocumentsTypesInvoiceForSelectAsync: 'api/Note/GetAllBussinessDocumentsTypesInvoiceForSelectAsync',
    GetAllConceptForSelectAsync: 'api/Note/GetAllConceptForSelectAsync',
    GetAllNoteTypeForSelectsAsync: 'api/Note/GetAllNoteTypeForSelectsAsync',
    GetAllNotesWithPagination: 'api/Note/GetAllNotesWithPaginationAsync',
    GetAlloperationTypeDianForSelectAsync: 'api/Note/GetAlloperationTypeDianForSelectAsync',
    GetClientByIdForRegisterNoteAsync: 'api/Note/GetClientByIdForRegisterNoteAsync',
    GetColumnsForGeneralConsultation: 'api/Note/GetColumnsForGeneralConsultationAsync',
    GetElectronicInvoiceInterfaceCodeByIdAsync: 'api/Note/GetElectronicInvoiceInterfaceCodeByIdAsync',
    GetFirstNoteByKeys: 'api/Note/GetFirstNoteByKeysAsync',
    GetLastNoteByKeys: 'api/Note/GetLastNoteByKeysAsync',
    GetLastNoteForFormats: 'api/Note/GetLastNoteForFormatsAsync',
    GetNextNoteByKeys: 'api/Note/GetNextNoteByKeysAsync',
    GetNoteById: 'api/Note/GetByIdAsync',
    GetNoteByKeys: 'api/Note/GetNoteByKeysAsync',
    GetPermissionPrint: 'api/Note/GetPermissionPrintAsync',
    GetPreviusNoteByKeys: 'api/Note/GetPreviusNoteByKeysAsync',
    GetProviderByIdForRegisterNoteAsync: 'api/Note/GetProviderByIdForRegisterNoteAsync',
    ImportNotesAsync: 'api/Note/ImportNotesAsync',
    PrintNote: 'api/Note/PrintNote',
    SetNoteState: 'api/Note/SetNoteStateAsync',
    UpdateNote: 'api/Note/UpdateAsync',
  },
  noteConcept: {
    GetNoteConceptById: 'api/NoteConcept/GetByIdAsync',
    GetNoteConceptDetailsByNoteIdAsync: 'api/NoteConcept/GetNoteConceptDetailsByNoteIdAsync',
    GetNoteConceptByKeysAsync: 'api/NoteConcept/GetNoteConceptByKeysAsync',
    CreateNoteConcept: 'api/NoteConcept/CreateAsync',
    UpdateNoteConcept: 'api/NoteConcept/UpdateAsync',
    DeleteSomeNoteConcepts: 'api/NoteConcept/DeleteSomeConceptsAsync',
    GetColumnsForConceptConsultation: 'api/NoteConcept/GetColumnsForConceptConsultationAsync',
    GetAllNoteConceptsWithPagination: 'api/NoteConcept/GetAllNoteConceptsWithPaginationAsync',
    ExportConceptConsultation: 'api/NoteConcept/ExportConceptConsultation',
    GetNotesConceptDetailsByNoteIdWithPagination: 'api/NoteConcept/GetNotesConceptDetailsByNoteIdWithPagination',
    GetColumnsForConceptDetailsNoteAsync: 'api/NoteConcept/GetColumnsForConceptDetailsNoteAsync',
    GetReteFuenteByNoteAndConcept: 'api/NoteConcept/GetReteFuenteByNoteAndConceptAsync',
    GetReteIcaByNoteAndConcept: 'api/NoteConcept/GetReteIcaByNoteAndConceptAsync',
    GetIvaRateByNoteAndConcept: 'api/NoteConcept/GetIvaRateByNoteAndConceptAsync',
  },
  noteDetail: {
    GetArticlesForNote: 'api/NoteDetail/GetArticlesForNoteAsync',
    GetNoteDetailById: 'api/NoteDetail/GetByIdAsync',
    CreateNoteDetail: 'api/NoteDetail/CreateAsync',
    UpdateNoteDetail: 'api/NoteDetail/UpdateAsync',
    DeleteNoteDetail: 'api/NoteDetail/DeleteSomeDetailsAsync',
    GetNoteDetailsByNoteId: 'api/NoteDetail/GetNoteDetailsByNoteIdAsync',
    GetNoteDetailByKeys: 'api/NoteDetail/GetNoteDetailByKeysAsync',
    GetColumnsForArticleCaptureNote: 'api/NoteDetail/GetColumnsForArticleCaptureNoteAsync',
    GetColumnsForDetailConsultation: 'api/NoteDetail/GetColumnsForDetailConsultationAsync',
    GetAllNoteDetailsWithPagination: 'api/NoteDetail/GetAllNoteDetailsWithPaginationAsync',
    ExportDetailConsultation: 'api/NoteDetail/ExportDetailConsultation',
    GetNotesDetailsByNoteIdWithPagination: 'api/NoteDetail/GetNotesDetailsByNoteIdWithPagination',
    GetColumnsForDetailsNoteAsync: 'api/NoteDetail/GetColumnsForDetailsNoteAsync',
    GetAllConceptInvoicingForSelectAsync: 'api/NoteDetail/GetAllConceptInvoicingForSelectAsync',
    GetAllStoreForSelectAsync: 'api/NoteDetail/GetAllStoreForSelectAsync',
    GetArticleByIdAsync: 'api/NoteDetail/GetArticleByIdAsync',
  },
  optionWindow: {
    ActivateAllPermissionsByUserAsync: 'api/OptionWindow/ActivateAllPermissionsByUserAsync',
    DeactivateAllPermissionsByUserAsync: 'api/OptionWindow/DectivateAllPermissionsByUserAsync',
    GetColumnsAsync: 'api/OptionWindow/GetColumnsAsync',
    GetOptionWindowsByCompanyAuthenticated: 'api/OptionWindow/GetOptionWindowsByCompanyAuthenticatedAsync',
    GetOptionWindowsByUser: 'api/OptionWindow/GetOptionWindowsByUserAsync',
    GetOptionsWindowsByUserWithPaginationAsync: 'api/OptionWindow/GetOptionsWindowsByUserWithPaginationAsync',
    SaveOptionWindowsByUser: 'api/OptionWindow/SaveOptionWindowsByUserAsync',
    SaveOptionWindowsByUserAsync: 'api/OptionWindow/SaveOptionWindowsByUserAsync',
    GetPermissionsForUserByWindow: 'api/OptionWindow/GetPermissionsForUserByWindow',
  },
  order: {
    AttachFilesToOrder: 'api/Order/AttachFilesToOrderAsync',
    BulkCloseOrdersAsync: 'api/Order/BulkCloseOrdersAsync',
    CreateOrder: 'api/Order/CreateAsync',
    DeleteFilesToOrder: 'api/Order/DeleteFileToOrderAsync',
    DeleteOrder: 'api/Order/DeleteAsync',
    DownloadFileToOrder: 'api/Order/DownloadFileToOrderAsync',
    DownloadGuideImport: 'api/Order/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Order/ExportGeneralConsultation',
    ImportPendingsOrdersAsync: 'api/Order/ImportPendingsOrdersAsync',
    GetAllAttachmentsWithPaginationAsync: 'api/Order/GetAllAttachmentsWithPaginationAsync',
    GetAllClientsForSelectAsync: 'api/Order/GetAllClientsForSelectAsync',
    GetAllConcepsForSelectAsync: 'api/Order/GetAllConcepsForSelectAsync',
    GetAllCostCenterForSelectAsync: 'api/Order/GetAllCostCenterForSelectAsync',
    GetAllOrderForSelectAsync: 'api/Order/GetAllOrderForSelectAsync',
    GetAllOrdersWithPaginationAsync: 'api/Order/GetAllOrdersWithPaginationAsync',
    GetAllOrdersConsultationWithPaginationAsync: 'api/Order/GetAllOrdersConsultationWithPaginationAsync',
    GetAllOrderTypesForSelectAsync: 'api/Order/GetAllOrderTypesForSelectAsync',
    GetAllSellersForSelectAsync: 'api/Order/GetAllSellersForSelectAsync',
    GetClientByIdForRegisterAsync: 'api/Order/GetClientByIdForRegisterAsync',
    GetColumnsForAttachmentsAsync: 'api/Order/GetColumnsForAttachmentsAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Order/GetColumnsForGeneralConsultationAsync',
    GetColumnsForOrdersConsultationAsync: 'api/Order/GetColumnsForOrdersConslutationAsync',
    GetColumnsForOrderSelectionAsync: 'api/Order/GetColumnsForOrderSelectionAsync',
    GetCostCenterByIdForRegisterAsync: 'api/Order/GetCostCenterByIdForRegisterAsync',
    GetEmptyOrderPrint: 'api/Order/GetEmptyOrderPrint',
    GetFirstOrderByKeys: 'api/Order/GetFirstOrderByKeysAsync',
    GetFirstOrderByQuotationId: 'api/Order/GetFirstOrderByQuotationIdAsync',
    GetFilesToOrder: 'api/Order/GetFilesToOrderAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/Order/GetIndicatorsForGeneralConsultationAsync',
    GetLastOrderByKeys: 'api/Order/GetLastOrderByKeysAsync',
    GetNextOrderByKeys: 'api/Order/GetNextOrderByKeysAsync',
    GetOrderById: 'api/Order/GetByIdAsync',
    GetOrderByKeys: 'api/Order/GetOrderByKeysAsync',
    GetOrderByKeysByPrintAsync: 'api/Order/GetOrderByKeysByPrintAsync',
    GetOrderConsecutiveByIdAsync: 'api/Order/GetOrderConsecutiveByIdAsync',
    GetOrderDataByIdAsync: 'api/Order/GetOrderDataByIdAsync',
    GetOrdersForSelectionAsync: 'api/Order/GetOrdersForSelectionAsync',
    GetPermission: 'api/Order/GetPermissionAsync',
    GetPreviusOrderByKeys: 'api/Order/GetPreviusOrderByKeysAsync',
    RevertOrderState: 'api/Order/RevertOrderStateAsync',
    SetStateOrder: 'api/Order/SetOrderStateAsync',
    UpdateOrder: 'api/Order/UpdateAsync',
  },
  orderDetail: {
    AnnulOrder: 'api/OrderDetail/AnnulOrderAsync',
    CreateDetailsAsync: 'api/OrderDetail/CreateDetailsAsync',
    CreateOrderByQuotation: 'api/OrderDetail/CreateOrderByQuotation',
    CreateOrderDetail: 'api/OrderDetail/CreateAsync',
    DeleteOrderDetail: 'api/OrderDetail/DeleteAsync',
    DeleteSomeDetails: 'api/OrderDetail/DeleteSomeDetailsAsync',
    ExportImportErrors: 'api/OrderDetail/ExportImportErrors',
    DownloadGuideImport: 'api/OrderDetail/DownloadGuideImport',
    ExportDetailConsultation: 'api/OrderDetail/ExportDetailConsultation',
    GetAllOrderDetailsWithPaginationAsync: 'api/OrderDetail/GetAllOrderDetailsWithPaginationAsync',
    GetArticlesForDetailsAsync: 'api/OrderDetail/GetArticlesForDetailsAsync',
    GetColumnsForArticles: 'api/OrderDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailCaptureAsync: 'api/OrderDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForDetailConsultationAsync: 'api/OrderDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForOrderDetailSelectionAsync: 'api/OrderDetail/GetColumnsForOrderDetailSelectionAsync',
    GetOrderDetailById: 'api/OrderDetail/GetByIdAsync',
    GetOrderDetailByKeys: 'api/OrderDetail/GetOrderDetailByKeysAsync',
    GetOrderDetailsForCaptureTableAsync: 'api/OrderDetail/GetOrderDetailsForCaptureTableAsync',
    GetOrderDetailsForSelectionAsync: 'api/OrderDetail/GetOrderDetailsForSelectionAsync',
    GetRentalUnitForSelectAsync: 'api/OrderDetail/GetRentalUnitForSelectAsync',
    GetStocksByArticleIdByOrder: 'api/OrderDetail/GetStocksByArticleIdByOrderAsync',
    ImportOrderDetailsAsync: 'api/OrderDetail/ImportOrderDetailsAsync',
    UpdateCompromiseDateByOrderId: 'api/OrderDetail/UpdateCompromiseDateByOrderId',
    UpdateOrderDetail: 'api/OrderDetail/UpdateAsync',
    UpdateOrderPrice: 'api/OrderDetail/UpdateOrderPriceAsync',
  },
  physicalInventory: {
    AdjustWithExcess: 'api/PhysicalInventory/AdjustWithExcessAsync',
    AdjustWithMissing: 'api/PhysicalInventory/AdjustWithMissingAsync',
    CreatePhysicalInventory: 'api/PhysicalInventory/CreateAsync',
    DeletePhysicalInventory: 'api/PhysicalInventory/DeleteAsync',
    GetAllPhysicalInventories: 'api/PhysicalInventory/GetAllPhysicalInventoriesAsync',
    GetAllStoresForSelectAsync: 'api/PhysicalInventory/GetAllStoresForSelectAsync',
    GetFirstPhysicalInventoryByKeys: 'api/PhysicalInventory/GetFirstPhysicalInventoryByKeysAsync',
    GetLastPhysicalInventoryByKeys: 'api/PhysicalInventory/GetLastPhysicalInventoryByKeysAsync',
    GetNextPhysicalInventoryByKeys: 'api/PhysicalInventory/GetNextPhysicalInventoryByKeysAsync',
    GetPhysicalInventoryByKeys: 'api/PhysicalInventory/GetPhysicalInventoryByKeysAsync',
    GetPreviusPhysicalInventoryByKeys: 'api/PhysicalInventory/GetPreviusPhysicalInventoryByKeysAsync',
    GetPhysicalInventoryById: 'api/PhysicalInventory/GetByIdAsync',
    GetPhysicalInventoryReportAsync: 'api/PhysicalInventory/GetPhysicalInventoryReportAsync',
    SetPhysicalInventoryState: 'api/PhysicalInventory/SetPhysicalInventoryStateAsync',
    UpdatePhysicalInventory: 'api/PhysicalInventory/UpdateAsync',
  },
  physicalInventoryDetail: {
    CreatePhysicalInventoryDetail: 'api/PhysicalInventoryDetail/CreateAsync',
    CreateSomeDetails: 'api/PhysicalInventoryDetail/CreateDetailsAsync',
    DeletePhysicalInventoryDetail: 'api/PhysicalInventoryDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/PhysicalInventoryDetail/DeleteSomeDetailsAsync',
    GetArticleByCodeAsync: 'api/PhysicalInventoryDetail/GetArticleByCodeAsync',
    GetArticleCountModalWithPaginationAsync: 'api/PhysicalInventoryDetail/GetArticleCountModalWithPaginationAsync',
    GetAllPhysicalInventoryDetails: 'api/PhysicalInventoryDetail/GetAllPhysicalInventoryDetailsAsync',
    GetColumnsForCountModal: 'api/PhysicalInventoryDetail/GetColumnsForCountModalAsync',
    GetColumnsForListArticleSelection: 'api/PhysicalInventoryDetail/GetColumnsForListArticleSelectionAsync',
    GetColumnsForRegisterTable: 'api/PhysicalInventoryDetail/GetColumnsForRegisterTableAsync',
    GetListArticleSelectionAsync: 'api/PhysicalInventoryDetail/GetListArticleSelectionAsync',
    GetPhysicalInventoryDetailByKeys: 'api/PhysicalInventoryDetail/GetPhysicalInventoryDetailByKeysAsync',
    GetPhysicalInventoryDetailById: 'api/PhysicalInventoryDetail/GetByIdAsync',
    GetPhysicalInventoryDetailsForRegisterTable: 'api/PhysicalInventoryDetail/GetPhysicalInventoryDetailsForRegisterTable',
    UpdatePhysicalInventoryDetail: 'api/PhysicalInventoryDetail/UpdateAsync',
  },
  physicalInventoryReport: {
    ExportPhysicalInventoryReportAsync: 'api/PhysicalInventoryReport/ExportPhysicalInventoryReportAsync',
    PhysicalInventoryReportAsync: 'api/PhysicalInventoryReport/GetPhysicalInventoryReportAsync',
  },
  preInvoice: {
    GetColumnsForGeneralConsultation: 'api/preInvoice/GetColumnsForGeneralConsultationAsync',
    GetAllPreInvoicesWithPagination: 'api/preInvoice/GetAllPreInvoicesWithPaginationAsync',
    ExportGeneralConsultation: 'api/preInvoice/ExportGeneralConsultation',
  },
  preInvoiceDetail: {
    GetColumnsForDetailConsultation: 'api/preInvoiceDetail/GetColumnsForDetailConsultationAsync',
    GetAllPreInvoicesDetailWithPagination: 'api/preInvoiceDetail/GetAllPreInvoicesDetailWithPaginationAsync',
    ExportDetailConsultation: 'api/preInvoiceDetail/ExportDetailConsultation',
  },
  preInvoiceConcept: {
    GetColumnsForConceptConsultation: 'api/preInvoiceConcept/GetColumnsForConceptConsultationAsync',
    GetAllPreInvoicesConceptWithPagination: 'api/preInvoiceConcept/GetAllPreInvoicesConceptWithPaginationAsync',
    ExportConceptConsultation: 'api/preInvoiceConcept/ExportConceptConsultation',
  },
  preliminariesReport: {
    ExportPreliminariesReportPendingOrder: 'api/PreliminariesReport/ExportPreliminariesReportPendingOrder',
    PreliminariesReportPendingOrder: 'api/PreliminariesReport/PreliminariesReportPendingOrder',
  },
  maintenanceReport: {
    ExportMaintenanceReportProgrammingDays: 'api/MaintenanceReport/ExportMaintenanceReportProgrammingDays',
    MaintenanceReportProgrammingDays: 'api/MaintenanceReport/MaintenanceReportProgrammingDays',
    ExportMaintenanceCostsForEquipment: 'api/MaintenanceReport/ExportMaintenanceReportMaintenanceCostsForEquipment',
    MaintenanceCostsForEquipment: 'api/MaintenanceReport/MaintenanceCostsForEquipment',
    ExportRepairHistory: 'api/MaintenanceReport/ExportMaintenanceReportRepairHistory',
    RepairHistory: 'api/MaintenanceReport/MaintenanceRepairHistory',
    ExportSimpleEquipmentLogbook: 'api/MaintenanceReport/ExportMaintenanceReportSimpleEquipmentLogbook',
    SimpleEquipmentLogbook: 'api/MaintenanceReport/MaintenanceReportSimpleEquipmentLogbook',
    ExportValuedEquipmentLogbook: 'api/MaintenanceReport/ExportMaintenanceReportValuedEquipmentLogbook',
    ValuedEquipmentLogbook: 'api/MaintenanceReport/MaintenanceReportValuedEquipmentLogbook',
  },
  priceList: {
    CreatePriceList: 'api/PriceList/CreateAsync',
    DeletePriceList: 'api/PriceList/DeleteAsync',
    DownloadGuideImport: 'api/PriceList/DownloadGuideImport',
    ExportGeneralConsultation: 'api/PriceList/ExportGeneralConsultation',
    GetAllPriceListsWithPaginationAsync: 'api/PriceList/GetAllPriceListsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/PriceList/GetColumnsForGeneralConsultationAsync',
    GetFirstPriceListByKeysAsync: 'api/PriceList/GetFirstPriceListByKeysAsync',
    GetLastPriceListByKeysAsync: 'api/PriceList/GetLastPriceListByKeysAsync',
    GetNextPriceListByKeysAsync: 'api/PriceList/GetNextPriceListByKeysAsync',
    GetPreviusPriceListByKeysAsync: 'api/PriceList/GetPreviusPriceListByKeysAsync',
    GetPriceListByBranchId: 'api/PriceList/GetPriceListByBranchIdAsync',
    GetPriceListByCodeAsync: 'api/PriceList/GetPriceListByCodeAsync',
    GetPriceListById: 'api/PriceList/GetByIdAsync',
    UpdatePriceList: 'api/PriceList/UpdateAsync',
  },
  priceListDetail: {
    CreatePriceListDetail: 'api/PriceListDetail/CreateAsync',
    CreateSomePriceListDetail: 'api/PriceListDetail/CreateSomeAsync',
    ExportDetailConsultation: 'api/PriceListDetail/ExportDetailConsultation',
    ExportCaptureDetailConsultation: 'api/PriceListDetail/ExportCaptureDetailConsultation',
    ExportImportErrors: 'api/PriceListDetail/ExportImportErrors',
    GetAllPriceListDetailsWithPaginationAsync: 'api/PriceListDetail/GetAllPriceListDetailsWithPaginationAsync',
    GetArticleIdInPriceListDetails: 'api/PriceListDetail/GetArticleIdInPriceListDetailsAsync',
    GetBaseUnitValue: 'api/PriceListDetail/GetBaseUnitValueAsync',
    GetClientUnitValueByPriceListArticle: 'api/PriceListDetail/GetClientUnitValueByPriceListArticleAsync',
    DeletePriceListDetail: 'api/PriceListDetail/DeleteAsync',
    DownloadGuideImport: 'api/PriceListDetail/DownloadGuideImport',
    GetArticlesWithPriceByQuotationWithPagination: 'api/PriceListDetail/GetArticlesWithPriceByQuotationWithPaginationAsync',
    GetColumnsFoArticlesWithPriceByQuotation: 'api/PriceListDetail/GetColumnsFoArticlesWithPriceByQuotationAsync',
    GetColumnsForArticleSelectionAsync: 'api/PriceListDetail/GetColumnsForArticleSelectionAsync',
    GetColumnsForCaptureTableAsync: 'api/PriceListDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultation: 'api/PriceListDetail/GetColumnsForDetailConsultationAsync',
    GetListArticlesForSelectionAsync: 'api/PriceListDetail/GetListArticlesForSelectionAsync',
    GetPriceListDetailById: 'api/PriceListDetail/GetByIdAsync',
    GetPriceListDetailByKeysAsync: 'api/PriceListDetail/GetPriceListDetailByKeysAsync',
    GetPriceListDetailsForCaptureTable: 'api/PriceListDetail/GetPriceListDetailsForCaptureTableAsync',
    ImportValuesPriceList: 'api/PriceListDetail/ImportValuesPriceListAsync',
    ImportValuesPriceListBase: 'api/PriceListDetail/ImportValuesPriceListBaseAsync',
    ImportPercentagePriceList: 'api/PriceListDetail/ImportPercentagePriceListAsync',
    ImportPriceListAs: 'api/PriceListDetail/ImportPriceListAsAsync',
    ReplicateArticleInOtherList: 'api/PriceListDetail/ReplicateArticleInOtherListAsync',
    UpdatePriceListDetail: 'api/PriceListDetail/UpdateAsync',
  },
  profileUser: {
    CreateProfileUser: 'api/ProfileUser/CreateAsync',
    UpdateProfileUser: 'api/ProfileUser/UpdateAsync',
    DeleteProfileUser: 'api/ProfileUser/DeleteAsync',
    GetProfileUserById: 'api/ProfileUser/GetByIdAsync',
    GetProfileUserByCode: 'api/ProfileUser/GetProfileUserByCodeAsync',
    ExportConsultation: 'api/ProfileUser/ExportConsultation',
    GetColumnsAsync: 'api/ProfileUser/GetColumnsAsync',
    GetProfileUsersForConsultation: 'api/ProfileUser/GetProfileUsersForConsultation',
  },
  provider: {
    CreateProvider: 'api/Provider/CreateAsync',
    DeleteProvider: 'api/Provider/DeleteAsync',
    DownloadGuideImport: 'api/Provider/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Provider/ExportGeneralConsultation',
    ExportImportErrors: 'api/Provider/ExportImportErrors',
    GetAllProvidersForSelect: 'api/Provider/GetAllProvidersForSelectAsync',
    GetAllProvidersTransportForSelectAsync: 'api/Provider/GetAllProvidersTransportForSelectAsync',
    GetAllProvidersWithPaginationAsync: 'api/Provider/GetAllProvidersWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Provider/GetColumnsForGeneralConsultationAsync',
    GetDigitVerification: 'api/Provider/GetDigitVerificationAsync',
    GetProviderByDocumentAsync: 'api/Provider/GetProviderByDocumentAsync',
    GetProviderById: 'api/Provider/GetByIdAsync',
    GetProviderByIdForSelect: 'api/Provider/GetProviderByIdForSelect',
    ImportProvider: 'api/Provider/ImportProvidersAsync',
    SetActiveProvider: 'api/Provider/SetActive',
    UpdateProvider: 'api/Provider/UpdateAsync',
    UpdateProviderDocument: 'api/Provider/UpdateProviderDocumentAsync',
  },
  providerInvoice: {
    ChangeStateAsync: 'api/ProviderInvoice/ChangeStateAsync',
    CreateProviderInvoice: 'api/ProviderInvoice/CreateAsync',
    DeleteProviderInvoice: 'api/ProviderInvoice/DeleteAsync',
    ExportGeneralConsultation: 'api/ProviderInvoice/ExportGeneralConsultation',
    GetArticleOthersAsync: 'api/ProviderInvoice/GetArticleOthersAsync',
    GetArticleWithEntryAsync: 'api/ProviderInvoice/GetArticleWithEntryAsync',
    GetArticleWithOCAsync: 'api/ProviderInvoice/GetArticleWithOCAsync',
    GetDaysExpirationByProviderIdAsync: 'api/ProviderInvoice/GetDaysExpirationByProviderIdAsync',
    GetColumnsForArticleOthersAsync: 'api/ProviderInvoice/GetColumnsForArticleOthersAsync',
    GetColumnsForArticleWithEntryAsync: 'api/ProviderInvoice/GetColumnsForArticleWithEntryAsync',
    GetColumnsForArticleWithOCAsync: 'api/ProviderInvoice/GetColumnsForArticleWithOCAsync',
    GetColumnsForGeneralConsultation: 'api/ProviderInvoice/GetColumnsForGeneralConsultationAsync',
    GetFirstProviderInvoiceByKeysAsync: 'api/ProviderInvoice/GetFirstProviderInvoiceByKeysAsync',
    GetLastProviderInvoiceByKeysAsync: 'api/ProviderInvoice/GetLastProviderInvoiceByKeysAsync',
    GetNextProviderInvoiceByKeysAsync: 'api/ProviderInvoice/GetNextProviderInvoiceByKeysAsync',
    GetPreviusProviderInvoiceByKeysAsync: 'api/ProviderInvoice/GetPreviusProviderInvoiceByKeysAsync',
    GetProviderInvoiceById: 'api/ProviderInvoice/GetByIdAsync',
    GetProviderInvoiceByKeysAsync: 'api/ProviderInvoice/GetProviderInvoiceByKeysAsync',
    GetProviderInvoicesForGeneralConsultation: 'api/ProviderInvoice/GetProviderInvoicesForGeneralConsultation',
    UpdateProviderInvoice: 'api/ProviderInvoice/UpdateAsync',
  },
  providerInvoiceConcept: {
    CreateProviderInvoiceConcept: 'api/ProviderInvoiceConcept/CreateAsync',
    DeleteProviderInvoiceConcept: 'api/ProviderInvoiceConcept/DeleteAsync',
    ExportGeneralConsultation: 'api/ProviderInvoiceConcept/ExportGeneralConsultation',
    GetColumnsForGeneralConsultation: 'api/ProviderInvoiceConcept/GetColumnsForGeneralConsultationAsync',
    GetProviderInvoiceConceptById: 'api/ProviderInvoiceConcept/GetByIdAsync',
    GetProviderInvoiceConceptsForGeneralConsultation: 'api/ProviderInvoiceConcept/GetProviderInvoiceConceptsForGeneralConsultation',
    UpdateProviderInvoiceConcept: 'api/ProviderInvoiceConcept/UpdateAsync',
  },
  providerInvoiceDetail: {
    CreateProviderInvoiceDetail: 'api/ProviderInvoiceDetail/CreateAsync',
    CreateBulkProviderInvoiceDetail: 'api/ProviderInvoiceDetail/CreateBulkAsync',
    DeleteProviderInvoiceDetail: 'api/ProviderInvoiceDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/ProviderInvoiceDetail/DeleteSomeDetailsAsync',
    ExportGeneralConsultation: 'api/ProviderInvoiceDetail/ExportGeneralConsultation',
    GetColumnsForDetailsProviderInvoiceAsync: 'api/ProviderInvoiceDetail/GetColumnsForDetailsProviderInvoiceAsync',
    GetColumnsForGeneralConsultation: 'api/ProviderInvoiceDetail/GetColumnsForGeneralConsultationAsync',
    GetProviderInvoiceDetailById: 'api/ProviderInvoiceDetail/GetByIdAsync',
    GetProviderInvoiceDetailByKeysAsync: 'api/ProviderInvoiceDetail/GetProviderInvoiceDetailByKeysAsync',
    GetProviderInvoiceDetailsByProviderInvoiceIdWithPagination: 'api/ProviderInvoiceDetail/GetProviderInvoiceDetailsByProviderInvoiceIdWithPagination',
    GetProviderInvoiceDetailsForGeneralConsultation: 'api/ProviderInvoiceDetail/GetProviderInvoiceDetailsForGeneralConsultation',
    UpdateProviderInvoiceDetail: 'api/ProviderInvoiceDetail/UpdateAsync',
  },
  providerInvoiceRetention: {
    CreateProviderInvoiceRetention: 'api/ProviderInvoiceRetention/CreateAsync',
    DeleteProviderInvoiceRetention: 'api/ProviderInvoiceRetention/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/ProviderInvoiceRetention/DeleteSomeDetailsAsync',
    GetAllTaxesForSelectAsync: 'api/ProviderInvoiceRetention/GetAllTaxesForSelectAsync',
    GetColumnsForProviderInvoiceRetentionAsync: 'api/ProviderInvoiceRetention/GetColumnsForProviderInvoiceRetentionAsync',
    GetProviderInvoiceRetentionById: 'api/ProviderInvoiceRetention/GetByIdAsync',
    GetProviderInvoiceRetentionsByProviderInvoiceIdWithPagination: 'api/ProviderInvoiceRetention/GetProviderInvoiceRetentionsByProviderInvoiceIdWithPagination',
    UpdateProviderInvoiceRetention: 'api/ProviderInvoiceRetention/UpdateAsync',
  },
  providerNote: {
    ChangeStateAsync: 'api/ProviderNote/ChangeStateAsync',
    CreateProviderNote: 'api/ProviderNote/CreateAsync',
    DeleteProviderNote: 'api/ProviderNote/DeleteAsync',
    ExportGeneralConsultation: 'api/ProviderNote/ExportGeneralConsultation',
    GetColumnsForGeneralConsultation: 'api/ProviderNote/GetColumnsForGeneralConsultationAsync',
    GetColumnsForProviderInvoiceAsync: 'api/ProviderNote/GetColumnsForProviderInvoiceAsync',
    GetFirstProviderNoteByKeysAsync: 'api/ProviderNote/GetFirstProviderNoteByKeysAsync',
    GetLastProviderNoteByKeysAsync: 'api/ProviderNote/GetLastProviderNoteByKeysAsync',
    GetNextProviderNoteByKeysAsync: 'api/ProviderNote/GetNextProviderNoteByKeysAsync',
    GetPreviusProviderNoteByKeysAsync: 'api/ProviderNote/GetPreviusProviderNoteByKeysAsync',
    GetProviderNoteByKeysAsync: 'api/ProviderNote/GetProviderNoteByKeysAsync',
    GetProviderNoteById: 'api/ProviderNote/GetByIdAsync',
    GetProviderInvoiceAsync: 'api/ProviderNote/GetProviderInvoiceAsync',
    GetProviderNotesForGeneralConsultation: 'api/ProviderNote/GetProviderNotesForGeneralConsultation',
    UpdateProviderNote: 'api/ProviderNote/UpdateAsync',
  },
  providerNoteDetail: {
    CreateAsync: 'api/ProviderNoteDetail/CreateAsync',
    CreateBulkAsync: 'api/ProviderNoteDetail/CreateBulkAsync',
    DeleteSomeDetailsAsync: 'api/ProviderNoteDetail/DeleteSomeDetailsAsync',
    ExportGeneralConsultation: 'api/ProviderNoteDetail/ExportGeneralConsultation',
    GetArticleByIdAsync: 'api/ProviderNoteDetail/GetArticleByIdAsync',
    GetArticlesForProviderNoteAsync: 'api/ProviderNoteDetail/GetArticlesForProviderNoteAsync',
    GetColumnsForArticleCaptureProviderNoteAsync: 'api/ProviderNoteDetail/GetColumnsForArticleCaptureProviderNoteAsync',
    GetColumnsForGeneralConsultation: 'api/ProviderNoteDetail/GetColumnsForGeneralConsultationAsync',
    GetColumnsForProviderNoteDetailsAsync: 'api/ProviderNoteDetail/GetColumnsForProviderNoteDetailsAsync',
    GetProviderNoteDetailByKeysAsync: 'api/ProviderNoteDetail/GetProviderNoteDetailByKeysAsync',
    GetProviderNoteDetailsByProviderNoteIdAsync: 'api/ProviderNoteDetail/GetProviderNoteDetailsByProviderNoteIdAsync',
    GetProviderNoteDetailsForGeneralConsultation: 'api/ProviderNoteDetail/GetProviderNoteDetailsForGeneralConsultation',
    UpdateAsync: 'api/ProviderNoteDetail/UpdateAsync',
  },
  providerNoteRetention: {
    CreateProviderNoteRetention: 'api/ProviderNoteRetention/CreateAsync',
    DeleteProviderNoteRetention: 'api/ProviderNoteRetention/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/ProviderNoteRetention/DeleteSomeDetailsAsync',
    GetAllTaxesForSelectAsync: 'api/ProviderNoteRetention/GetAllTaxesForSelectAsync',
    GetColumnsForProviderNoteRetentionAsync: 'api/ProviderNoteRetention/GetColumnsForProviderNoteRetentionAsync',
    GetProviderNoteRetentionById: 'api/ProviderNoteRetention/GetByIdAsync',
    GetProviderNoteRetentionsByProviderNoteIdWithPagination: 'api/ProviderNoteRetention/GetProviderNoteRetentionsByProviderNoteIdWithPagination',
    UpdateProviderNoteRetention: 'api/ProviderNoteRetention/UpdateAsync',
  },
  purchaseOrder: {
    AnnulPurchaseOrder: 'api/PurchaseOrder/AnnulAsync',
    CreatePurchaseOrder: 'api/PurchaseOrder/CreateAsync',
    DeletePurchaseOrder: 'api/PurchaseOrder/DeleteAsync',
    DownloadGuideImport: 'api/PurchaseOrder/DownloadGuideImport',
    ExportGeneralConsultation: 'api/PurchaseOrder/ExportGeneralConsultation',
    ExportImportErrors: 'api/PurchaseOrder/ExportImportErrors',
    FinalClosePurchaseOrder: 'api/PurchaseOrder/FinalCloseAsync',
    GetColumnsForGeneralConsultation: 'api/PurchaseOrder/GetColumnsForGeneralConsultationAsync',
    GetFirstPurchaseOrderByKeys: 'api/PurchaseOrder/GetFirstPurchaseOrderByKeysAsync',
    GetLastPurchaseOrderByKeys: 'api/PurchaseOrder/GetLastPurchaseOrderByKeysAsync',
    GetNextPurchaseOrderByKeys: 'api/PurchaseOrder/GetNextPurchaseOrderByKeysAsync',
    GetPreviusPurchaseOrderByKeys: 'api/PurchaseOrder/GetPreviusPurchaseOrderByKeysAsync',
    GetPurchaseOrderById: 'api/PurchaseOrder/GetByIdAsync',
    GetPurchaseOrderByKeys: 'api/PurchaseOrder/GetPurchaseOrderByKeysAsync',
    GetPurchaseOrdersForGeneralConsultation: 'api/PurchaseOrder/GetPurchaseOrdersForGeneralConsultation',
    ImportPurchaseOrdersAsync: 'api/PurchaseOrder/ImportPurchaseOrdersAsync',
    InitialClosePurchaseOrder: 'api/PurchaseOrder/InitialCloseAsync',
    PrintPurchaseOrder: 'api/PurchaseOrder/PrintPurchaseOrder',
    ReverseStatePurchaseOrder: 'api/PurchaseOrder/ReverseStateAsync',
    UpdatePurchaseOrder: 'api/PurchaseOrder/UpdateAsync',
  },
  purchaseOrderDetail: {
    CreatePurchaseOrderDetails: 'api/PurchaseOrderDetail/CreateAsync',
    CreateWithOrdersPurchaseOrderDetails: 'api/PurchaseOrderDetail/CreateWithOrderAsync',
    DeleteSomeDetails: 'api/PurchaseOrderDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/PurchaseOrderDetail/ExportDetailConsultation',
    GetArticlesForSelection: 'api/PurchaseOrderDetail/GetArticlesForSelection',
    GetArticlesWithOrderForSelection: 'api/PurchaseOrderDetail/GetArticlesWithOrderForSelection',
    GetColumnsForArticleSelection: 'api/PurchaseOrderDetail/GetColumnsForArticleSelection',
    GetColumnsForArticleWithOrderSelection: 'api/PurchaseOrderDetail/GetColumnsForArticleWithOrderSelection',
    GetColumnsForCaptureTable: 'api/PurchaseOrderDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultation: 'api/PurchaseOrderDetail/GetColumnsForDetailConsultationAsync',
    GetPurchaseOrderDetailById: 'api/PurchaseOrderDetail/GetByIdAsync',
    GetPurchaseOrderDetailByKeys: 'api/PurchaseOrderDetail/GetPurchaseOrderDetailByKeys',
    GetPurchaseOrderDetailsForCaptureTable: 'api/PurchaseOrderDetail/GetPurchaseOrderDetailsForCaptureTable',
    GetPurchaseOrderDetailsForDetailConsultation: 'api/PurchaseOrderDetail/GetPurchaseOrderDetailsForDetailConsultation',
    UpdatePurchaseOrderDetail: 'api/PurchaseOrderDetail/UpdateAsync',
  },
  purchaseProjection: {
    CreateAsync: 'api/PurchaseProjection/CreateAsync',
    DeleteAsync: 'api/PurchaseProjection/DeleteAsync',
    ExportGeneralConsultation: 'api/PurchaseProjection/ExportGeneralConsultation',
    GetAllPurchaseProjectionsWithPaginationAsync: 'api/PurchaseProjection/GetAllPurchaseProjectionsWithPaginationAsync',
    GetArticlesForSelectAsync: 'api/PurchaseProjection/GetArticlesForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/PurchaseProjection/GetColumnsForGeneralConsultationAsync',
    GetByIdAsync: 'api/PurchaseProjection/GetByIdAsync',
    GetPurchaseProjectionByKeysAsync: 'api/PurchaseProjection/GetPurchaseProjectionByKeysAsync',
    UpdateAsync: 'api/PurchaseProjection/UpdateAsync',
  },
  quotation: {
    GetQuotationById: 'api/Quotation/GetByIdAsync',
    CreateQuotation: 'api/Quotation/CreateAsync',
    CreateOrdersFromQuotationAsync: 'api/Quotation/CreateOrdersFromQuotationAsync',
    CreateQuotationsFromCostCenterPrices: 'api/Quotation/CreateQuotationsFromCostCenterPrices',
    GetNameCompanyForImplementQuotation: 'api/Quotation/GetNameCompanyForImplementQuotation',
    UpdateQuotation: 'api/Quotation/UpdateAsync',
    DeleteQuotation: 'api/Quotation/DeleteAsync',
    ExportGeneralConsultation: 'api/Quotation/ExportGeneralConsultation',
    SetStateQuotation: 'api/Quotation/SetQuotationStateAsync',
    RevertStateQuotation: 'api/Quotation/RevertQuotationStateAsync',
    RejectQuotation: 'api/Quotation/RejectQuotationAsync',
    RevertImplementQuotation: 'api/Quotation/RevertImplementQuotation',
    GetAllQuotationsWithPagination: 'api/Quotation/GetAllQuotationsWithPaginationAsync',
    GetAllClientsForSelect: 'api/Quotation/GetAllClientsForSelectAsync',
    GetAllConstructionSitesForSelect: 'api/Quotation/GetAllConstructionSitesForSelectAsync',
    GetAllRejectConceptsForSelect: 'api/Quotation/GetAllRejectConceptsForSelectAsync',
    GetAllPricesListForSelect: 'api/Quotation/GetAllPricesListForSelectAsync',
    GetAllSellersForSelect: 'api/Quotation/GetAllSellersForSelectAsync',
    GetAllTypesBussinesses1ForSelect: 'api/Quotation/GetAllTypesBussinesses1ForSelectAsync',
    GetAllTypesBussinesses2ForSelect: 'api/Quotation/GetAllTypesBussinesses2ForSelectAsync',
    GetAllTypesEquipmentForSelect: 'api/Quotation/GetAllTypesEquipmentForSelectAsync',
    GetAllTypesQuotationsForSelect: 'api/Quotation/GetAllTypesQuotationsForSelectAsync',
    GetColumnsForGeneralConsultation: 'api/Quotation/GetColumnsForGeneralConsultationAsync',
    GetIndicatorsForGeneralConsultation: 'api/Quotation/GetIndicatorsForGeneralConsultationAsync',
    GetBranchByIdForSelect: 'api/Quotation/GetBranchByIdForSelect',
    GetClientByIdForSelect: 'api/Quotation/GetClientByIdForSelect',
    GetConstructionSiteByIdForSelect: 'api/Quotation/GetConstructionSiteByIdForSelect',
    GetEmptyQuotationPrint: 'api/Quotation/GetEmptyQuotationPrint',
    GetPricesListByIdForSelect: 'api/Quotation/GetPricesListByIdForSelect',
    GetQuotationTypeByIdForSelect: 'api/Quotation/GetQuotationTypeByIdForSelect',
    GetQuotationByKeys: 'api/Quotation/GetQuotationByKeysAsync',
    GetSellerByIdForSelect: 'api/Quotation/GetSellerByIdForSelect',
    GetTypesBussinessesByIdForSelect: 'api/Quotation/GetTypesBussinessesByIdForSelect',
    GetTypeEquipmentByIdForSelect: 'api/Quotation/GetTypeEquipmentByIdForSelect',
    GetFirstQuotationByKeys: 'api/Quotation/GetFirstQuotationByKeysAsync',
    GetLastQuotationByKeys: 'api/Quotation/GetLastQuotationByKeysAsync',
    GetPreviusQuotationByKeys: 'api/Quotation/GetPreviusQuotationByKeysAsync',
    GetNextQuotationByKeys: 'api/Quotation/GetNextQuotationByKeysAsync',
    AttachFilesToQuotation: 'api/Quotation/AttachFilesToQuotationAsync',
    GetFilesToQuotation: 'api/Quotation/GetFilesToQuotationAsync',
    DownloadFileToQuotation: 'api/Quotation/DownloadFileToQuotationAsync',
    DeleteFilesToQuotation: 'api/Quotation/DeleteFileToQuotationAsync',
    GetPermission: 'api/Quotation/GetPermissionAsync',
    GetQuotationForPrint: 'api/Quotation/GetQuotationForPrintAsync',
    GetQuotationByKeysByPrintAsync: 'api/Quotation/GetQuotationByKeysByPrintAsync',
    GetQuotationsForSelectionAsync: 'api/Quotation/GetQuotationsForSelectionAsync',
    GetColumnsForQuotationSelectionAsync: 'api/Quotation/GetColumnsForQuotationSelectionAsync',
    DownloadGuideImport: 'api/Quotation/DownloadGuideImport',
    RevertImportQuotation: 'api/Quotation/RevertImportQuotation',
    ImportQuotationsAsync: 'api/Quotation/ImportQuotationsAsync',
  },
  quotationDetail: {
    GetAllCostCenterForSelect: 'api/QuotationDetail/GetAllCostCenterForSelectAsync',
    GetAllBaseValueForSelect: 'api/QuotationDetail/GetAllBaseValueForSelectAsync',
    GetAllUnitsForSelect: 'api/QuotationDetail/GetAllUnitsForSelectAsync',
    GetColumnsForDetailByVersionsSelectionAsync: 'api/QuotationDetail/GetColumnsForDetailByVersionsSelectionAsync',
    GetColumnsForQuotationDetailsSelectionAsync: 'api/QuotationDetail/GetColumnsForQuotationDetailsSelectionAsync',
    GetColumnsForQuotationDetailsByVersion: 'api/QuotationDetail/GetColumnsForQuotationDetailsByVersionAsync',
    GetDetailByVersionsForSelectionAsync: 'api/QuotationDetail/GetDetailByVersionsForSelectionAsync',
    GetFirstQuotationDetailByKeys: 'api/QuotationDetail/GetFirstQuotationDetailByKeysAsync',
    GetLastQuotationDetailByKeys: 'api/QuotationDetail/GetLastQuotationDetailByKeysAsync',
    GetNextQuotationDetailByKeys: 'api/QuotationDetail/GetNextQuotationDetailByKeysAsync',
    GetPreviusQuotationDetailByKeys: 'api/QuotationDetail/GetPreviusQuotationDetailByKeysAsync',
    GetQuotationDetailsByVersion: 'api/QuotationDetail/GetQuotationDetailsByVersionAsync',
    GetQuotationDetailById: 'api/QuotationDetail/GetByIdAsync',
    GetQuotationDetailsForSelectionAsync: 'api/QuotationDetail/GetQuotationDetailsForSelectionAsync',
    CreateQuotationDetail: 'api/QuotationDetail/CreateAsync',
    UpdateQuotationDetail: 'api/QuotationDetail/UpdateAsync',
    DeleteQuotationDetail: 'api/QuotationDetail/DeleteAsync',
    DeleteSomeDetails: 'api/QuotationDetail/DeleteSomeDetailsAsync',
    GetQuotationDetailsByVersionId: 'api/QuotationDetail/GetQuotationDetailsByVersionIdAsync',
    CopySolutionFromQuotation: 'api/QuotationDetail/CopySolutionFromQuotation',
    AttachImages: 'api/QuotationDetail/AttachImagesAsync',
    GetImages: 'api/QuotationDetail/GetImagesAsync',
    DeleteImages: 'api/QuotationDetail/DeleteImagesAsync',
  },
  quotationVersion: {
    GetAllQuotationVersions: 'api/QuotationVersion/GetAllQuotationVersionsAsync',
    GetAllQuotationVersionsWithPagination: 'api/QuotationVersion/GetAllQuotationVersionsWithPaginationAsync',
    GetColumnsForConsultation: 'api/QuotationVersion/GetColumnsForConsultationAsync',
    GetQuotationVersionById: 'api/QuotationVersion/GetByIdAsync',
    GetQuotationVersionsForSelect: 'api/QuotationVersion/GetQuotationVersionsForSelectAsync',
    CreateQuotationVersion: 'api/QuotationVersion/CreateAsync',
    UpdateQuotationVersion: 'api/QuotationVersion/UpdateAsync',
    DeleteQuotationVersion: 'api/QuotationVersion/DeleteAsync',
    SetActive: 'api/QuotationVersion/SetActive',
    GetQuotationVersionsByQuotationId: 'api/QuotationVersion/GetQuotationVersionsByQuotationIdAsync',
    GetLastQuotationVersion: 'api/QuotationVersion/GetLastQuotationVersionAsync',
    GetQuotationVersionByKeys: 'api/QuotationVersion/GetQuotationVersionByKeysAsync',
  },
  remission: {
    AttachFilesToRemission: 'api/Remission/AttachFilesToRemissionAsync',
    DeleteFilesToRemission: 'api/Remission/DeleteFileToRemissionAsync',
    DownloadFileToRemission: 'api/Remission/DownloadFileToRemissionAsync',
    GetFilesToRemission: 'api/Remission/GetFilesToRemission',
    GetAllInvoiceForRemissionsWithPagination: 'api/Remission/GetAllInvoiceForRemissionsWithPaginationAsync',
    GetAllRemissionsWithPagination: 'api/Remission/GetAllRemissionsWithPaginationAsync',
    GetAllCostCenterForSelectAsync: 'api/Remission/GetAllCostCenterForSelectAsync',
    GetAllTransporterForSelectAsync: 'api/Remission/GetAllTransporterForSelectAsync',
    GetAllVehicleForSelectAsync: 'api/Remission/GetAllVehicleForSelectAsync',
    GetColumnsForGeneralConsultation: 'api/Remission/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoiceConsultation: 'api/Remission/GetColumnsForInvoiceConsultationAsync',
    GetRemissionById: 'api/Remission/GetByIdAsync',
    CreateRemission: 'api/Remission/CreateAsync',
    UpdateRemission: 'api/Remission/UpdateAsync',
    DeleteRemission: 'api/Remission/DeleteAsync',
    ExportGeneralConsultation: 'api/Remission/ExportGeneralConsultation',
    ExportInvoiceForRemissionConsultation: 'api/Remission/ExportInvoiceForRemissionConsultation',
    SetStateRemission: 'api/Remission/SetRemissionStateAsync',
    AnnulRemission: 'api/Remission/AnnulRemissionAsync',
    BlockRemission: 'api/Remission/BlockRemissionAsync',
    GetPermissionPrint: 'api/Remission/GetPermissionPrintAsync',
    PrintRemission: 'api/Remission/PrintRemissionAsync',
    GetRemissionByKeys: 'api/Remission/GetRemissionByKeysAsync',
    GetFirstRemissionByKeys: 'api/Remission/GetFirstRemissionByKeysAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/Remission/GetIndicatorsForGeneralConsultationAsync',
    GetLastRemissionByKeys: 'api/Remission/GetLastRemissionByKeysAsync',
    GetPreviusRemissionByKeys: 'api/Remission/GetPreviusRemissionByKeysAsync',
    GetNextRemissionByKeys: 'api/Remission/GetNextRemissionByKeysAsync',
    DownloadGuideImport: 'api/Article/DownloadGuideImport',
    ImportRemissions: 'api/Article/ImportRemissionsAsync',
    GetRemissionConsecutiveByIdAsync: 'api/Remission/GetRemissionConsecutiveByIdAsync',
    GetEmptyRemissionPrint: 'api/Remission/GetEmptyRemissionPrint',
    GetRemissionByKeysByPrint: 'api/Remission/GetRemissionByKeysByPrintAsync',
    GetAllConceptsDelayReasonForSelectAsync: 'api/Remission/GetAllConceptsDelayReasonForSelectAsync',
    GetAllConceptsTypeAvailabilityForSelectAsync: 'api/Remission/GetAllConceptsTypeAvailabilityForSelectAsync',
    GetAllConceptsRequirementTypeForSelectAsync: 'api/Remission/GetAllConceptsRequirementTypeForSelectAsync',
    GetAllUsersAppForSelectAsync: 'api/Remission/GetAllUsersAppForSelectAsync',
    HasExistingRemissionAsync: 'api/Remission/HasExistingRemissionAsync',
  },
  remissionDetail: {
    CreateRemissionDetail: 'api/RemissionDetail/CreateAsync',
    CreateDetails: 'api/RemissionDetail/CreateDetailsAsync',
    ExportDetailConsultation: 'api/RemissionDetail/ExportDetailConsultation',
    GetAllRemissionDetailsWithPagination: 'api/RemissionDetail/GetAllRemissionDetailsWithPaginationAsync',
    GetColumnsForDetailConsultation: 'api/RemissionDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForCaptureTable: 'api/RemissionDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForListStocksInShop: 'api/RemissionDetail/GetColumnsForListStocksInShopAsync',
    GetRemissionDetailById: 'api/RemissionDetail/GetByIdAsync',
    GetRemissionDetailsForCaptureTable: 'api/RemissionDetail/GetRemissionDetailsForCaptureTable',
    UpdateRemissionDetail: 'api/RemissionDetail/UpdateAsync',
    UpdateRemissionByHoursDaysAsync: 'api/RemissionDetail/UpdateRemissionByHoursDaysAsync',
    DeleteSomeDetails: 'api/RemissionDetail/DeleteSomeDetailsAsync',
    GetRemissionDetailByKeys: 'api/RemissionDetail/GetRemissionDetailByKeysAsync',
    GetRemissionDetailsByRemissionId: 'api/RemissionDetail/GetRemissionDetailsByRemissionIdAsync',
    GetStocksByArticleIdStoreId: 'api/RemissionDetail/GetStocksByArticleIdStoreIdAsync',
    GetListStocksInShop: 'api/RemissionDetail/GetListStocksInShopAsync',
    GetRemissionDetailsBySwIncludeStore: 'api/RemissionDetail/GetRemissionDetailsBySwIncludeStoreAsync',
    GetQuantityDetail: 'api/RemissionDetail/GetQuantityDetailAsync',
  },
  remissionFromOrder: {
    ExportRemissionFromOrderConsultation: 'api/RemissionFromOrder/ExportRemissionFromOrderConsultation',
    GetAllRemissionFromOrderWithPagination: 'api/RemissionFromOrder/GetAllRemissionFromOrderWithPaginationAsync',
    GetColumnsArticleAsync: 'api/RemissionFromOrder/GetColumnsArticleAsync',
    GetColumnsForRemissionFromOrderConsultation: 'api/RemissionFromOrder/GetColumnsForRemissionFromOrderConsultationAsync',
    GetColumnsStoresStockAsync: 'api/RemissionFromOrder/GetColumnsStoresStockAsync',
    GetOrderArticlesStockForSelectionAsync: 'api/RemissionFromOrder/GetOrderArticlesStockForSelectionAsync',
    GetOrderDetailsForRemission: 'api/RemissionFromOrder/GetOrderDetailsForRemissionAsync',
    GetRemissionDetailByOrder: 'api/RemissionFromOrder/GetRemissionDetailByOrderKeysAsync',
    GetRemissionFromOrderDetailById: 'api/RemissionFromOrder/GetRemissionFromOrderDetailByIdAsync',
    GetRemissionDetailByOrderKeysAsync: 'api/RemissionFromOrder/GetRemissionDetailByOrderKeysAsync',
    GetStoreStockByArticleForSelectionAsync: 'api/RemissionFromOrder/GetStoreStockByArticleForSelectionAsync',
    SaveRemisionDetail: 'api/RemissionFromOrder/SaveRemisionDetailAsync',
    CreateManualOrderAsync: 'api/RemissionFromOrder/CreateManualOrderAsync',
    ProcessManualOrderAsync: 'api/RemissionFromOrder/ProcessManualOrderAsync',
    UpdateManualOrderAsync: 'api/RemissionFromOrder/UpdateManualOrderAsync',
    GetColumnsForMassiveOrderSelectionAsync: 'api/RemissionFromOrder/GetColumnsForMassiveOrderSelectionAsync',
    GetMassiveOrderForSelectionAsync: 'api/RemissionFromOrder/GetMassiveOrderForSelectionAsync',
    GetMassiveOrderDetailForSelectionAsync: 'api/RemissionFromOrder/GetMassiveOrderDetailForSelectionAsync',
    GetColumnsForMassiveOrderDetailSelectionAsync: 'api/RemissionFromOrder/GetColumnsForMassiveOrderDetailSelectionAsync',
    CreateMassiveOrderAsync: 'api/RemissionFromOrder/CreateMassiveOrderAsync',
  },
  rentalBalance: {
    DownloadGuideImport: 'api/RentalBalance/DownloadGuideImport',
    ExportImportErrors: 'api/RentalBalance/ExportImportErrors',
    ImportBalances: 'api/RentalBalance/ImportBalancesAsync',
    ReverseImportBalances: 'api/RentalBalance/ReverseImportBalancesAsync',
    GetColumnsForRentalBalanceAsync: 'api/RentalBalance/GetColumnsForRentalBalanceAsync',
  },
  rentalMovements: {
    DownloadGuideImportRentalMovement: 'api/RentalMovements/DownloadGuideImportRentalMovement',
    ExportImportErrors: 'api/RentalMovements/ExportImportErrors',
    ImportRentalMovements: 'api/RentalMovements/ImportRentalMovementsAsync',
  },
  rentalPeriod: {
    CreateRentalPeriod: 'api/RentalPeriod/CreateAsync',
    DeleteRentalPeriod: 'api/RentalPeriod/DeleteAsync',
    ExportGeneralConsultation: 'api/RentalPeriod/ExportGeneralConsultation',
    ExportDocumentsForDelete: 'api/RentalPeriod/ExportDocumentsForDelete',
    ExportDocumentsOpenedConsultation: 'api/RentalPeriod/ExportDocumentsOpenedConsultation',
    GetAllDocumentsForDeleteWithPaginationAsync: 'api/RentalPeriod/GetAllDocumentsForDeleteWithPaginationAsync',
    GetAllDocumentsOpenedWithPaginationAsync: 'api/RentalPeriod/GetAllDocumentsOpenedWithPaginationAsync',
    GetAllRentalPeriodsWithPaginationAsync: 'api/RentalPeriod/GetAllRentalPeriodsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/RentalPeriod/GetColumnsForGeneralConsultationAsync',
    GetColumnsForDocumentsOpenedAsync: 'api/RentalPeriod/GetColumnsForDocumentsOpenedAsync',
    GetLastRentalPeriod: 'api/RentalPeriod/GetLastRentalPeriodAsync',
    GetRentalById: 'api/RentalPeriod/GetByIdAsync',
    GetRentalPeriodWithState: 'api/RentalPeriod/GetRentalPeriodWithStateAsync',
    SetActiveRentalPeriod: 'api/RentalPeriod/SetActiveAsync',
    UpdateProvider: 'api/RentalPeriod/UpdateAsync',
  },
  rentalReport: {
    ExportRentalReportBalancesClientCostCenter: 'api/RentalReport/ExportRentalReportBalancesClientCostcenter',
    ExportRentalReportBalancesShop: 'api/RentalReport/ExportRentalReportBalancesShop',
    ExportRentalReportBalancesWorkshop: 'api/RentalReport/ExportRentalReportBalancesWorkshop',
    ExportRentalReportClientDistribution: 'api/RentalReport/ExportRentalReportClientDistribution',
    ExportRentalReportConstructionWithoutEquipment: 'api/RentalReport/ExportRentalReportConstructionWithoutEquipment',
    ExportRentalReportDaysConstructionSite: 'api/RentalReport/ExportRentalReportDaysConstructionSite',
    ExportRentalReportMovementsKilograms: 'api/RentalReport/ExportRentalReportMovementsKilograms',
    ExportRentalReportHistoricalMovementCostCenter: 'api/RentalReport/ExportRentalReportHistoricalMovementCostcenter',
    ExportRentalReportHistoricalMovementShop: 'api/RentalReport/ExportRentalReportHistoricalMovementShop',
    ExportRentalReportCostCenterDiscounts: 'api/RentalReport/ExportRentalReportCostCenterDiscounts',
    ExportRentalReportHistoricalMovementWorkshop: 'api/RentalReport/ExportRentalReportHistoricalMovementWorkshop',
    ExportRentalReportCostCenterDistribution: 'api/RentalReport/ExportRentalReportCostCenterDistribution',
    ExportRentalReportInvoicedReplacement: 'api/RentalReport/ExportRentalReportInvoicedReplacement',
    ExportRentalReportOccupancyPercentage: 'api/RentalReport/ExportRentalReportOccupancyPercentage',
    ExportRentalReportReplacement: 'api/RentalReport/ExportRentalReportReplacement',
    ExportRentalReportSummaryBalances: 'api/RentalReport/ExportRentalReportSummaryBalances',
    ExportRentalReportTotalDistribution: 'api/RentalReport/ExportRentalReportTotalDistribution',
    ExportRentalReportTransport: 'api/RentalReport/ExportRentalReportTransport',
    BalancesClientCostcenter: 'api/RentalReport/RentalReportBalancesClientCostcenter',
    BalancesShop: 'api/RentalReport/RentalReportBalancesShop',
    BalancesWorkshop: 'api/RentalReport/RentalReportBalancesWorkshop',
    ClientDistributionModel: 'api/RentalReport/RentalReportClientDistribution',
    ConstructionWithoutEquipmentModel: 'api/RentalReport/RentalReportConstructionWithoutEquipment',
    CostCenterDistributionModel: 'api/RentalReport/RentalReportCostCenterDistribution',
    DaysConstructionSiteModel: 'api/RentalReport/RentalreportDaysConstructionSite',
    MovementsKilograms: 'api/RentalReport/RentalReportMovementsKilograms',
    HistoricalMovementCostCenter: 'api/RentalReport/RentalReportHistoricalMovementCostcenter',
    HistoricalMovementShop: 'api/RentalReport/RentalReportHistoricalMovementShop',
    CostCenterDiscounts: 'api/RentalReport/RentalReportCostCenterDiscounts',
    HistoricalMovementWorkshop: 'api/RentalReport/RentalReportHistoricalMovementWorkshop',
    InvoicedReplacement: 'api/RentalReport/RentalReportInvoicedReplacement',
    OccupancyPercentage: 'api/RentalReport/RentalReportOccupancyPercentage',
    ReportReplacement: 'api/RentalReport/RentalReportReplacement',
    SummaryBalances: 'api/RentalReport/RentalReportSummaryBalances',
    TotalDistributionModel: 'api/RentalReport/RentalReportTotalDistribution',
    Transport: 'api/RentalReport/RentalReportTransport',
  },
  repair: {
    CreateRepair: 'api/Repair/CreateAsync',
    CreateRepairsByMaintenanceOrderSuppliesAsync: 'api/Repair/CreateRepairsByMaintenanceOrderSuppliesAsync',
    DeleteRepair: 'api/Repair/DeleteAsync',
    DeleteSomeRepairsAsync: 'api/Repair/DeleteSomeRepairsAsync',
    DownloadGuideImport: 'api/Repair/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Repair/ExportGeneralConsultation',
    ExportImportErrors: 'api/Repair/ExportImportErrors',
    ExportModalConsultation: 'api/Repair/ExportModalConsultation',
    GetAllRepair: 'api/Repair/GetAllRepairAsync',
    GetAllRepairsWithPagination: 'api/Repair/GetAllRepairsWithPaginationAsync',
    GetAllRepairsModalWithPagination: 'api/Repair/GetAllRepairsModalWithPaginationAsync',
    GetAllRepairsDevolutionModalWithPagination: 'api/Repair/GetAllRepairsDevolutionModalWithPaginationAsync',
    GetColumnsForGeneralConsultation: 'api/Repair/GetColumnsForGeneralConsultationAsync',
    GetColumnsForModalConsultation: 'api/Repair/GetColumnsForModalConsultationAsync',
    GetColumnsForModalDevolution: 'api/Repair/GetColumnsForModalDevolutionAsync',
    GetRepairById: 'api/Repair/GetByIdAsync',
    GetRepairByKeysAsync: 'api/Repair/GetRapairsByKeysAsync',
    GetRapairsDevolutionByKeysAsync: 'api/Repair/GetRapairsDevolutionByKeysAsync',
    ImportRepairsAsync: 'api/Repair/ImportRepairsAsync',
    UpdateRepair: 'api/Repair/UpdateAsync',
  },
  requestNote: {
    AnnulInvoiceByRequestNoteAsync: 'api/RequestNote/AnnulInvoiceByRequestNoteAsync',
    AnnulRequestNoteAsync: 'api/RequestNote/AnnulRequestNoteAsync',
    AttachFilesToRequestNote: 'api/RequestNote/AttachFilesToRequestNoteAsync',
    CreateNoteAsync: 'api/RequestNote/CreateAsync',
    DeleteRequestNoteAsync: 'api/RequestNote/DeleteAsync',
    DeleteFilesToRequestNote: 'api/RequestNote/DeleteFileToRequestNoteAsync',
    DownloadFileToRequestNote: 'api/RequestNote/DownloadFileToRequestNoteAsync',
    GetFilesToRequestNote: 'api/RequestNote/GetFilesToRequestNote',
    ExportGeneralConsultation: 'api/RequestNote/ExportGeneralConsultation',
    GetAllRequestNotesWithPaginationAsync: 'api/RequestNote/GetAllRequestNotesWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/RequestNote/GetColumnsForGeneralConsultationAsync',
    GetColumnsForRequestNotesAsync: 'api/RequestNote/GetColumnsForRequestNotesAsync',
    GetEmptyRequestNotePrint: 'api/RequestNote/GetEmptyRequestNotePrint',
    GetFirstRequestNoteByKeysAsync: 'api/RequestNote/GetFirstRequestNoteByKeysAsync',
    GetLastRequestNoteByKeysAsync: 'api/RequestNote/GetLastRequestNoteByKeysAsync',
    GetNextRequestNoteByKeysAsync: 'api/RequestNote/GetNextRequestNoteByKeysAsync',
    GetPermissionPrintAsync: 'api/RequestNote/GetPermissionPrintAsync',
    GetPreviusRequestNoteByKeysAsync: 'api/RequestNote/GetPreviusRequestNoteByKeysAsync',
    GetRequestNoteByKeysAsync: 'api/RequestNote/GetRequestNoteByKeysAsync',
    GetRequestNoteByKeysByPrintAsync: 'api/RequestNote/GetRequestNoteByKeysByPrintAsync',
    GetRequestNotesForNoteAsync: 'api/RequestNote/GetRequestNotesForNoteAsync',
    SetRequestNoteStateAsync: 'api/RequestNote/SetRequestNoteStateAsync',
    UpdateRequestNoteasync: 'api/RequestNote/UpdateAsync',
  },
  requestNoteDetail: {
    ExportDetailConsultation: 'api/RequestNoteDetail/ExportDetailConsultation',
    GetAllRequestNoteDetailsWithPaginationAsync: 'api/RequestNoteDetail/GetAllRequestNoteDetailsWithPaginationAsync',
    GetColumnsForDetailConsultationAsync: 'api/RequestNoteDetail/GetColumnsForDetailConsultationAsync',
  },
  salesRemission: {
    BlockSalesRemissionAsync: 'api/SalesRemission/BlockSalesRemissionAsync',
    CreateSalesRemission: 'api/SalesRemission/CreateAsync',
    DeleteSalesRemission: 'api/SalesRemission/DeleteAsync',
    ExportGeneralConsultation: 'api/SalesRemission/ExportGeneralConsultation',
    GetAllClientsForSelectAsync: 'api/SalesRemission/GetAllClientsForSelectAsync',
    GetAllCostCenterForSelectAsync: 'api/SalesRemission/GetAllCostCenterForSelectAsync',
    GetAllInventoriesForSelectAsync: 'api/SalesRemission/GetAllInventoriesForSelectAsync',
    GetAllInventoryOutputTypesForSelectAsync: 'api/SalesRemission/GetAllInventoryOutputTypesForSelectAsync',
    GetAllSalesRemissionsWithPaginationAsync: 'api/SalesRemission/GetAllSalesRemissionsWithPaginationAsync',
    GetAllTransporterForSelectAsync: 'api/SalesRemission/GetAllTransporterForSelectAsync',
    GetAllVehicleForSelectAsync: 'api/SalesRemission/GetAllVehicleForSelectAsync',
    GetClientForSelectAsync: 'api/SalesRemission/GetClientForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/SalesRemission/GetColumnsForGeneralConsultationAsync',
    GetColumnsForSalesRemissionSelectionAsync: 'api/SalesRemission/GetColumnsForSalesRemissionSelectionAsync',
    GetConceptForSaleAsync: 'api/SalesRemission/GetConceptForSaleAsync',
    GetCostCenterForSelectAsync: 'api/SalesRemission/GetCostCenterForSelectAsync',
    GetEmptySalesRemissionPrint: 'api/SalesRemission/GetEmptySalesRemissionPrint',
    GetFirstSalesRemissionByKeysAsync: 'api/SalesRemission/GetFirstSalesRemissionByKeysAsync',
    GetLastSalesRemissionByKeysAsync: 'api/SalesRemission/GetLastSalesRemissionByKeysAsync',
    GetNextSalesRemissionByKeysAsync: 'api/SalesRemission/GetNextSalesRemissionByKeysAsync',
    GetPermissionPrint: 'api/SalesRemission/GetPermissionPrintAsync',
    GetPreviusSalesRemissionByKeysAsync: 'api/SalesRemission/GetPreviusSalesRemissionByKeysAsync',
    GetSalesRemissionById: 'api/SalesRemission/GetByIdAsync',
    GetSalesRemissionByKeysAsync: 'api/SalesRemission/GetSalesRemissionByKeysAsync',
    GetSalesRemissionByKeysForPrintAsync: 'api/SalesRemission/GetSalesRemissionByKeysForPrintAsync',
    GetSalesRemissionRelatedConsecutivesAsync: 'api/SalesRemission/GetSalesRemissionRelatedConsecutivesAsync',
    GetSalesRemissionsByInvoiceIdAsync: 'api/SalesRemission/GetSalesRemissionsByInvoiceIdAsync',
    GetSalesRemissionsForSelectionAsync: 'api/SalesRemission/GetSalesRemissionsForSelectionAsync',
    SetSalesRemissionStateAsync: 'api/SalesRemission/SetSalesRemissionStateAsync',
    UpdateSalesRemission: 'api/SalesRemission/UpdateAsync',
  },
  salesRemissionDetail: {
    CreateSalesRemissionDetail: 'api/SalesRemissionDetail/CreateAsync',
    CreateSomeDetails: 'api/SalesRemissionDetail/CreateDetailsAsync',
    DeleteSalesRemissionDetail: 'api/SalesRemissionDetail/DeleteAsync',
    DeleteSomeDetails: 'api/SalesRemissionDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/SalesRemissionDetail/ExportDetailConsultation',
    GetAllSalesRemissionDetailsWithPaginationAsync: 'api/SalesRemissionDetail/GetAllSalesRemissionDetailsWithPaginationAsync',
    GetColumnsForCaptureTableAsync: 'api/SalesRemissionDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForDetailConsultationAsync: 'api/SalesRemissionDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForListStocksInShopByInventoryAsync: 'api/SalesRemissionDetail/GetColumnsForListStocksInShopByInventoryAsync',
    GetListStocksInShopByInventoryAsync: 'api/SalesRemissionDetail/GetListStocksInShopByInventoryAsync',
    GetSalesRemissionDetailById: 'api/SalesRemissionDetail/GetByIdAsync',
    GetSalesRemissionDetailByKeys: 'api/SalesRemissionDetail/GetSalesRemissionDetailByKeysAsync',
    GetSalesRemissionDetailsForCaptureTable: 'api/SalesRemissionDetail/GetSalesRemissionDetailsForCaptureTableAsync',
    GetStocksByArticleIdStoreId: 'api/SalesRemissionDetail/GetStocksByArticleIdStoreIdAsync',
    UpdateSalesRemissionDetail: 'api/SalesRemissionDetail/UpdateAsync',
  },
  salesRemissionFromOrder: {
    CreateMassiveOrderAsync: 'api/SalesRemissionFromOrder/CreateMassiveOrderAsync',
    GetArticlesByOrderForSelectionAsync: 'api/SalesRemissionFromOrder/GetArticlesByOrderForSelectionAsync',
    GetColumnsForArticleByOrderAsync: 'api/SalesRemissionFromOrder/GetColumnsForArticleByOrderAsync',
    GetColumnsForMassiveOrderDetailSelectionAsync: 'api/SalesRemissionFromOrder/GetColumnsForMassiveOrderDetailSelectionAsync',
    GetColumnsForStoreStockByArticleAsync: 'api/SalesRemissionFromOrder/GetColumnsForStoreStockByArticleAsync',
    GetMassiveOrderDetailForSelectionAsync: 'api/SalesRemissionFromOrder/GetMassiveOrderDetailForSelectionAsync',
    GetStoreStockByArticleForSelectionAsync: 'api/SalesRemissionFromOrder/GetStoreStockByArticleForSelectionAsync',
  },
  sector: {
    CreateAsync: 'api/Sector/CreateAsync',
    DeleteAsync: 'api/Sector/DeleteAsync',
    ExportGeneralConsultation: 'api/Sector/ExportGeneralConsultation',
    GetSectorsForSelectionAsync: 'api/Sector/GetSectorsForSelectionAsync',
    GetAllSectorsForSelectAsync: 'api/Sector/GetAllSectorsForSelectAsync',
    GetAllSectorsWithPaginationAsync: 'api/Sector/GetAllSectorsWithPaginationAsync',
    GetByIdAsync: 'api/Sector/GetByIdAsync',
    GetSectorByKeysAsync: 'api/Sector/GetSectorByKeysAsync',
    GetSectorByConsecutiveAsync: 'api/Sector/GetSectorByConsecutiveAsync',
    GetColumnsForSelectionAsync: 'api/Sector/GetColumnsForSelectionAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Sector/GetColumnsForGeneralConsultationAsync',
    GetFirstSectorByKeysAsync: 'api/Sector/GetFirstSectorByKeysAsync',
    GetLastSectorByKeysAsync: 'api/Sector/GetLastSectorByKeysAsync',
    GetNextSectorByKeysAsync: 'api/Sector/GetNextSectorByKeysAsync',
    GetPreviusSectorByKeysAsync: 'api/Sector/GetPreviusSectorByKeysAsync',
    UpdateAsync: 'api/Sector/UpdateAsync',
  },
  seller: {
    CreateSeller: 'api/Seller/CreateAsync',
    DeleteSeller: 'api/Seller/DeleteAsync',
    DownloadGuideImport: 'api/Seller/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Seller/ExportGeneralConsultation',
    ExportImportErrors: 'api/Seller/ExportImportErrors',
    GetAllSellersForSelectByBranchIdAsync: 'api/Seller/GetAllSellersForSelectByBranchIdAsync',
    GetAllSellersForRegisterAsync: 'api/Seller/GetAllSellersForRegisterAsync',
    GetAllSellersWithPaginationAsync: 'api/Seller/GetAllSellersWithPaginationAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/Seller/GetAllTypeDocumentsForSelectAsync',
    GetAllUserByBranchIdForSelectAsync: 'api/Seller/GetAllUserByBranchIdForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Seller/GetColumnsForGeneralConsultationAsync',
    GetCityDepartmentAsync: 'api/Seller/GetCityDepartmentAsync',
    GetCitiesForSelectionAsync: 'api/Seller/GetCitiesForSelectionAsync',
    GetColumnsForCitiesSelectionAsync: 'api/Seller/GetColumnsForCitiesSelectionAsync',
    GetDigitVerification: 'api/Seller/GetDigitVerificationAsync',
    GetSellerByBranchId: 'api/Seller/GetSellerByBranchIdAsync',
    GetSellerByCostCenterId: 'api/Seller/GetSellerByCostCenterIdAsync',
    GetSellerByDocumentAsync: 'api/Seller/GetSellerByDocumentAsync',
    GetSellerById: 'api/Seller/GetByIdAsync',
    GetSellerByName: 'api/Seller/GetSellerByNameAsync',
    SetActiveSeller: 'api/Seller/SetActiveAsync',
    ImportSeller: 'api/Seller/ImportSellersAsync',
    UpdateSeller: 'api/Seller/UpdateAsync',
    UpdateSellerDocument: 'api/Seller/UpdateSellerDocumentAsync',
  },
  service: {
    AnnulService: 'api/Service/AnnulServiceAsync',
    AttachFilesToService: 'api/Service/AttachFilesToServiceAsync',
    BlockService: 'api/Service/BlockServiceAsync',
    CreateService: 'api/Service/CreateAsync',
    SaveServiceByOrderAsync: 'api/Service/SaveServiceByOrderAsync',
    DeleteFilesToService: 'api/Service/DeleteFileToServiceAsync',
    DeleteService: 'api/Service/DeleteAsync',
    DownloadFileToService: 'api/Service/DownloadFileToServiceAsync',
    ExportGeneralConsultation: 'api/Service/ExportGeneralConsultation',
    ExportInvoiceForServiceConsultation: 'api/Service/ExportInvoiceForServiceConsultation',
    GetFilesToServiceAsync: 'api/Service/GetFilesToServiceAsync',
    GetAllBranchesForSelectAsync: 'api/Service/GetAllBranchesForSelectAsync',
    GetAllClientsForSelectAsync: 'api/Service/GetAllClientsForSelectAsync',
    GetAllCostCentersForSelectAsync: 'api/Service/GetAllCostCentersForSelectAsync',
    GetAllCostCenterByBranchIdForSelectAsync: 'api/Service/GetAllCostCenterByBranchIdForSelectAsync',
    GetAllInvoiceForServicesWithPagination: 'api/Service/GetAllInvoiceForServicesWithPaginationAsync',
    GetAllServicesWithPaginationAsync: 'api/Service/GetAllServicesWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Service/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoiceConsultationAsync: 'api/Service/GetColumnsForInvoiceConsultationAsync',
    GetCostCenterByIdAsync: 'api/Service/GetCostCenterByIdAsync',
    GetFirstServiceByKeys: 'api/Service/GetFirstServiceByKeysAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/Service/GetIndicatorsForGeneralConsultationAsync',
    GetLastServiceByKeys: 'api/Service/GetLastServiceByKeysAsync',
    GetNextServiceByKeys: 'api/Service/GetNextServiceByKeysAsync',
    GetPermissionPrint: 'api/Service/GetPermissionPrintAsync',
    GetPreviusServiceByKeys: 'api/Service/GetPreviusServiceByKeysAsync',
    GetServiceById: 'api/Service/GetByIdAsync',
    GetServiceByKeys: 'api/Service/GetServiceByKeysAsync',
    GetServiceByKeysByPrintAsync: 'api/Service/GetServiceByKeysByPrintAsync',
    PrintService: 'api/Service/PrintServiceAsync',
    SetStateService: 'api/Service/SetServiceStateAsync',
    UpdateService: 'api/Service/UpdateAsync',
    GetEmptyServicePrint: 'api/Service/GetEmptyServicePrint',
  },
  serviceDetail: {
    CreateServiceDetail: 'api/ServiceDetail/CreateAsync',
    DeleteSomeDetails: 'api/ServiceDetail/DeleteSomeDetailsAsync',
    ExportGeneralConsultation: 'api/ServiceDetail/ExportGeneralConsultation',
    GetAllConceptsInvoicingForSelectAsync: 'api/ServiceDetail/GetAllConceptsInvoicingForSelectAsync',
    GetAllServiceDetailsWithPaginationAsync: 'api/ServiceDetail/GetAllServiceDetailsWithPaginationAsync',
    GetAllUnitsForSelectAsync: 'api/ServiceDetail/GetAllUnitsForSelectAsync',
    GetArticlesForDetailsAsync: 'api/ServiceDetail/GetArticlesForDetailsAsync',
    GetClientValue: 'api/ServiceDetail/GetClientValueAsync',
    GetColumnsForArticles: 'api/ServiceDetail/GetColumnsForArticlesAsync',
    GetColumnsForCaptureTableAsync: 'api/ServiceDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForGeneralConsultationAsync: 'api/ServiceDetail/GetColumnsForGeneralConsultationAsync',
    GetServiceDetailById: 'api/ServiceDetail/GetByIdAsync',
    GetServiceDetailsByServiceId: 'api/ServiceDetail/GetServiceDetailsByServiceIdAsync',
    GetServiceDetailsForCaptureTableAsync: 'api/ServiceDetail/GetServiceDetailsForCaptureTableAsync',
    UpdateServiceDetail: 'api/ServiceDetail/UpdateAsync',
    GetServiceDetailByKeysAsync: 'api/ServiceDetail/GetServiceDetailByKeysAsync',
  },
  store: {
    CreateStore: 'api/Store/CreateAsync',
    DeleteStore: 'api/Store/DeleteAsync',
    DownloadGuideImport: 'api/Store/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Store/ExportGeneralConsultation',
    ExportImportErrors: 'api/Store/ExportImportErrors',
    GetAllInventoriesForSelectAsync: 'api/Store/GetAllInventoriesForSelectAsync',
    GetAllStoresWithPaginationAsync: 'api/Store/GetAllStoresWithPaginationAsync',
    GetAllStoreActivesByBranchInventory: 'api/Store/GetStoresActivesByBranchIdInventoryIdAsync',
    GetAllStoreByBranchInventory: 'api/Store/GetStoresByBranchIdInventoryIdAsync',
    GetAllStoresForSelectAsync: 'api/Store/GetAllStoresForSelectAsync',
    GetAllStoresByBranchForSelectAsync: 'api/Store/GetAllStoresByBranchForSelectAsync',
    GetAllStoresWithoutSubrentalForSelect: 'api/Store/GetAllStoresWithoutSubrentalForSelectAsync',
    GetAllSubrentalStoresForSelectAsync: 'api/Store/GetAllSubrentalStoresForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Store/GetColumnsForGeneralConsultationAsync',
    GetDefaultStoreIdByBranch: 'api/Store/GetDefaultStoreIdByBranchAsync',
    GetFirstStoreByKeysAsync: 'api/Store/GetFirstStoreByKeysAsync',
    GetLastStoreByKeysAsync: 'api/Store/GetLastStoreByKeysAsync',
    GetNextStoreByKeysAsync: 'api/Store/GetNextStoreByKeysAsync',
    GetPreviusStoreByKeysAsync: 'api/Store/GetPreviusStoreByKeysAsync',
    GetStoreByCode: 'api/Store/GetStoreByCodeAsync',
    GetStoreById: 'api/Store/GetByIdAsync',
    GetStoresActivesByBranchInventoryForSelect: 'api/Store/GetStoresActivesByBranchInventoryForSelectAsync',
    GetStoresByBranchId: 'api/Store/GetStoresByBranchIdAsync',
    GetStoresForInvoice: 'api/Store/GetStoresForInvoiceAsync',
    GetStoresForNote: 'api/Store/GetStoresForNoteAsync',
    GetStoresRentalByBranchId: 'api/Store/GetStoresRentalByBranchIdAsync',
    ImportStores: 'api/Store/ImportStoresAsync',
    SetActiveStore: 'api/Store/SetActiveAsync',
    UpdateStore: 'api/Store/UpdateAsync',
  },
  stockMaxMin: {
    CreateStockMaxMin: 'api/StockMaxMin/CreateAsync',
    DeleteStockMaxMin: 'api/StockMaxMin/DeleteAsync',
    DownloadGuideImport: 'api/StockMaxMin/DownloadGuideImport',
    ExportGeneralConsultation: 'api/StockMaxMin/ExportGeneralConsultation',
    ExportImportErrors: 'api/StockMaxMin/ExportImportErrors',
    GetAllStockMaxMinForSelect: 'api/StockMaxMin/GetAllStockMaxMinForSelectAsync',
    GetAllStockMaxMinWithPaginationAsync: 'api/StockMaxMin/GetAllStockMaxMinWithPaginationAsync',
    GetArticlesForSelectAsync: 'api/StockMaxMin/GetArticlesForSelectAsync',
    GetArticlesForSelectByInventoryIdAsync: 'api/StockMaxMin/GetArticlesForSelectByInventoryIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/StockMaxMin/GetColumnsForGeneralConsultationAsync',
    GetFirstStockMaxMin: 'api/StockMaxMin/GetFirstStockMaxMinAsync',
    GetNextStockMaxMinByKeysAsync: 'api/StockMaxMin/GetNextStockMaxMinByKeysAsync',
    GetLastStockMaxMin: 'api/StockMaxMin/GetLastStockMaxMinAsync',
    GetPreviousStockMaxMinByKeysAsync: 'api/StockMaxMin/GetPreviousStockMaxMinByKeysAsync',
    GetStockMaxMinById: 'api/StockMaxMin/GetStockMaxMinByIdAsync',
    GetStockMaxMinByKeys: 'api/StockMaxMin/GetStockMaxMinByKeysAsync',
    ImportStockMaxMin: 'api/StockMaxMin/ImportStockMaxMinAsync',
    UpdateStockMaxMin: 'api/StockMaxMin/UpdateStockMaxMinAsync',
  },
  storePrice: {
    CreateStorePrice: 'api/StorePrice/CreateAsync',
    DeleteStorePrice: 'api/StorePrice/DeleteAsync',
    DownloadGuideImport: 'api/StorePrice/DownloadGuideImport',
    ExportGeneralConsultation: 'api/StorePrice/ExportGeneralConsultation',
    ExportImportErrors: 'api/StorePrice/ExportImportErrors',
    GetAllStorePricesWithPaginationAsync: 'api/StorePrice/GetAllStorePricesWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/StorePrice/GetColumnsForGeneralConsultationAsync',
    GetStorePriceById: 'api/StorePrice/GetByIdAsync',
    GetStorePriceByKeys: 'api/StorePrice/GetStorePriceByKeysAsync',
    ImportStorePrices: 'api/StorePrice/ImportStorePricesAsync',
    UpdateStorePrice: 'api/StorePrice/UpdateAsync',
  },
  subgroup: {
    CreateSubgroup: 'api/Subgroup/CreateAsync',
    DeleteSubgroup: 'api/Subgroup/DeleteAsync',
    DownloadGuideImport: 'api/Subgroup/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Subgroup/ExportGeneralConsultation',
    ExportImportErrors: 'api/Subgroup/ExportImportErrors',
    GetAllSubgroupsForSelectAsync: 'api/Subgroup/GetAllSubgroupsForSelectAsync',
    GetAllSubgroupsWithPaginationAsync: 'api/Subgroup/GetAllSubgroupsWithPaginationAsync',
    GetByGroupId: 'api/Subgroup/GetBygroupIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Subgroup/GetColumnsForGeneralConsultationAsync',
    GetSubgroupById: 'api/Subgroup/GetByIdAsync',
    GetSubgroupByCode: 'api/Subgroup/GetSubgroupByCodeAsync',
    ImportSubgroups: 'api/Subgroup/ImportSubgroupsAsync',
    UpdateSubgroup: 'api/Subgroup/UpdateAsync',
  },
  subrentalCutoff: {
    CreateSubrentalCutoff: 'api/SubrentalCutoff/CreateAsync',
    DeleteSubrentalCutoff: 'api/SubrentalCutoff/DeleteAsync',
    ExportGeneralConsultation: 'api/SubrentalCutoff/ExportGeneralConsultation',
    ExportLiquidationErrorsTxt: 'api/SubrentalCutoff/ExportLiquidationErrorsTxt',
    ExportSubrentalPreinvoicesAsync: 'api/SubrentalCutoff/ExportSubrentalPreinvoicesAsync',
    GetAllStoreForLiquidationSelectAsync: 'api/SubrentalCutoff/GetAllStoreForLiquidationSelectAsync',
    GetAllSubrentalCutoffsWithPaginationAsync: 'api/SubrentalCutoff/GetAllSubrentalCutoffsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/SubrentalCutoff/GetColumnsForGeneralConsultationAsync',
    GetEmptyLiquidationPrint: 'api/SubrentalCutoff/GetEmptyLiquidationPrint',
    GetFirstSubrentalCutoffByKeys: 'api/SubrentalCutoff/GetFirstSubrentalCutoffByKeysAsync',
    GetLastSubrentalCutoffByKeys: 'api/SubrentalCutoff/GetLastSubrentalCutoffByKeysAsync',
    GetLiquidationCutoffByKeysAsync: 'api/SubrentalCutoff/GetLiquidationCutoffByKeysAsync',
    GetNextSubrentalCutoffByKeys: 'api/SubrentalCutoff/GetNextSubrentalCutoffByKeysAsync',
    GetPreviusSubrentalCutoffByKeys: 'api/SubrentalCutoff/GetPreviusSubrentalCutoffByKeysAsync',
    GetSubrentalCutoffById: 'api/SubrentalCutoff/GetByIdAsync',
    GetSubrentalCutoffByKeys: 'api/SubrentalCutoff/GetSubrentalCutoffByKeysAsync',
    LiquidationBySubrentalCutoffId: 'api/SubrentalCutoff/LiquidationBySubrentalCutoffIdAsync',
    OpenCloseSubrentalCutoffAsync: 'api/SubrentalCutoff/OpenCloseSubrentalCutoffAsync',
    OpenSubrentalCutoffByIdAsync: 'api/SubrentalCutoff/OpenSubrentalCutoffByIdAsync',
    UpdateSubrentalCutoff: 'api/SubrentalCutoff/UpdateAsync',
    ValidateCountSubrentalCutoffsOpen: 'api/SubrentalCutoff/ValidateCountSubrentalCutoffsOpenAsync',
  },
  subrentalCutoffDetail: {
    CreateSubrentalCutoffDetail: 'api/SubrentalCutoffDetail/CreateAsync',
    DeleteSubrentalCutoffDetail: 'api/SubrentalCutoffDetail/DeleteAsync',
    ExportDetailConsultation: 'api/SubrentalCutoffDetail/ExportDetailConsultation',
    GetAllSubrentalCutoffDetailsWithPaginationAsync: 'api/SubrentalCutoffDetail/GetAllSubrentalCutoffDetailsWithPaginationAsync',
    GetColumnsForDetailConsultationAsync: 'api/SubrentalCutoffDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForRegisterTable: 'api/SubrentalCutoffDetail/GetColumnsForRegisterTableAsync',
    GetColumnsForStores: 'api/SubrentalCutoffDetail/GetColumnsForStoresAsync',
    GetStoresForSubrentalCutoffAsync: 'api/SubrentalCutoffDetail/GetStoresForSubrentalCutoffAsync',
    GetSubrentalCutoffDetailsForRegisterTable: 'api/SubrentalCutoffDetail/GetSubrentalCutoffDetailsForRegisterTable',
  },
  subrentalEntry: {
    CreateSubrentalEntry: 'api/SubrentalEntry/CreateAsync',
    DeleteSubrentalEntry: 'api/SubrentalEntry/DeleteAsync',
    ExportGeneralConsultation: 'api/SubrentalEntry/ExportGeneralConsultation',
    GetColumnsForGeneralConsultation: 'api/SubrentalEntry/GetColumnsForGeneralConsultationAsync',
    GetEmptySubrentalEntryPrint: 'api/SubrentalEntry/GetEmptySubrentalEntryPrint',
    GetFirstSubrentalEntryByKeys: 'api/SubrentalEntry/GetFirstSubrentalEntryByKeysAsync',
    GetLastSubrentalEntryByCompanyId: 'api/SubrentalEntry/GetLastSubrentalEntryByCompanyIdAsync',
    GetLastSubrentalEntryByKeys: 'api/SubrentalEntry/GetLastSubrentalEntryByKeysAsync',
    GetNextSubrentalEntryByKeys: 'api/SubrentalEntry/GetNextSubrentalEntryByKeysAsync',
    GetPreviusSubrentalEntryByKeys: 'api/SubrentalEntry/GetPreviusSubrentalEntryByKeysAsync',
    GetSubrentalEntriesForGeneralConsultation: 'api/SubrentalEntry/GetSubrentalEntriesForGeneralConsultation',
    GetSubrentalEntryById: 'api/SubrentalEntry/GetByIdAsync',
    GetSubrentalEntryByKeys: 'api/SubrentalEntry/GetSubrentalEntryByKeysAsync',
    GetSubrentalEntryByKeysForFormats: 'api/SubrentalEntry/GetSubrentalEntryByKeysForFormats',
    GetSubrentalEntryPrintByKeys: 'api/SubrentalEntry/GetSubrentalEntryPrintByKeysAsync',
    SetSubrentalEntryState: 'api/SubrentalEntry/SetSubrentalEntryStateAsync',
    UpdateSubrentalEntry: 'api/SubrentalEntry/UpdateAsync',
  },
  subrentalEntryDetail: {
    CreateSubrentalEntryDetail: 'api/SubrentalEntryDetail/CreateAsync',
    DeleteSomeDetails: 'api/SubrentalEntryDetail/DeleteSomeDetailsAsync',
    DeleteSubrentalEntryDetail: 'api/SubrentalEntryDetail/DeleteAsync',
    DownloadGuideImport: 'api/SubrentalEntryDetail/DownloadGuideImport',
    ExportDetailConsultation: 'api/SubrentalEntryDetail/ExportDetailConsultation',
    ExportImportErrors: 'api/SubrentalEntryDetail/ExportImportErrors',
    GetAllArticlesForSubrentalEntriesForSelectAsync: 'api/SubrentalEntryDetail/GetAllArticlesForSubrentalEntriesForSelectAsync',
    GetArticlesForEntries: 'api/SubrentalEntryDetail/GetArticlesForEntriesAsync',
    GetColumnsForArticles: 'api/SubrentalEntryDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailCapture: 'api/SubrentalEntryDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForDetailConsultation: 'api/SubrentalEntryDetail/GetColumnsForDetailConsultationAsync',
    GetStocksByArticleIdStoreId: 'api/SubrentalEntryDetail/GetStocksByArticleIdStoreIdAsync',
    GetSubrentalEntryDetailByEntryId: 'api/SubrentalEntryDetail/GetSubrentalEntryDetailsByEntryIdAsync',
    GetSubrentalEntryDetailById: 'api/SubrentalEntryDetail/GetByIdAsync',
    GetSubrentalEntryDetailByKeys: 'api/SubrentalEntryDetail/GetSubrentalEntryDetailByKeysAsync',
    GetSubrentalEntryDetailsForCapture: 'api/SubrentalEntryDetail/GetSubrentalEntryDetailsForCapture',
    GetSubrentalEntryDetailsForDetailConsultation: 'api/SubrentalEntryDetail/GetSubrentalEntryDetailsForDetailConsultation',
    ImportSubrentalEntry: 'api/SubrentalEntryDetail/ImportSubrentalEntryAsync',
    UpdateSubrentalEntryDetail: 'api/SubrentalEntryDetail/UpdateAsync',
  },
  subrentalOutput: {
    CreateSubrentalOutput: 'api/SubrentalOutput/CreateAsync',
    DeleteSubrentalOutput: 'api/SubrentalOutput/DeleteAsync',
    ExportGeneralConsultation: 'api/SubrentalOutput/ExportGeneralConsultation',
    GetAllSubretnalOutputTypeForSelect: 'api/SubrentalOutput/GetAllSubretnalOutputTypeForSelectAsync',
    GetAllTransporterForSelect: 'api/SubrentalOutput/GetAllTransporterForSelectAsync',
    GetAllVehicleForSelect: 'api/SubrentalOutput/GetAllVehicleForSelectAsync',
    GetColumnsForGeneralConsultation: 'api/SubrentalOutput/GetColumnsForGeneralConsultationAsync',
    GetDevolutionForSubrentalOutput: 'api/SubrentalOutput/GetDevolutionForSubrentalOutputAsync',
    GetEmptySubrentalOutputPrint: 'api/SubrentalOutput/GetEmptySubrentalOutputPrint',
    GetFirstSubrentalOutputByKeys: 'api/SubrentalOutput/GetFirstSubrentalOutputByKeysAsync',
    GetLastSubrentalOutputByCompanyId: 'api/SubrentalOutput/GetLastSubrentalOutputByCompanyIdAsync',
    GetLastSubrentalOutputByKeys: 'api/SubrentalOutput/GetLastSubrentalOutputByKeysAsync',
    GetNextSubrentalOutputByKeys: 'api/SubrentalOutput/GetNextSubrentalOutputByKeysAsync',
    GetPreviusSubrentalOutputByKeys: 'api/SubrentalOutput/GetPreviusSubrentalOutputByKeysAsync',
    GetSubrentalOutputById: 'api/SubrentalOutput/GetByIdAsync',
    GetSubrentalOutputByKeys: 'api/SubrentalOutput/GetSubrentalOutputByKeysAsync',
    GetSubrentalOutputByKeysForFormats: 'api/SubrentalOutput/GetSubrentalOutputByKeysForFormats',
    GetSubrentalOutputPrintByKeys: 'api/SubrentalOutput/GetSubrentalOutputPrintByKeysAsync',
    GetSubrentalOutputsForGeneralConsultation: 'api/SubrentalOutput/GetSubrentalOutputsForGeneralConsultation',
    SetSubrentalOutputState: 'api/SubrentalOutput/SetSubrentalOutputStateAsync',
    UpdateSubrentalOutput: 'api/SubrentalOutput/UpdateAsync',
  },
  subrentalOutputDetail: {
    CreateSubrentalOutputDetail: 'api/SubrentalOutputDetail/CreateAsync',
    DeleteSomeDetails: 'api/SubrentalOutputDetail/DeleteSomeDetailsAsync',
    DeleteSubrentalOutputDetail: 'api/SubrentalOutputDetail/DeleteAsync',
    ExportDetailConsultation: 'api/SubrentalOutputDetail/ExportDetailConsultation',
    GetColumnsForArticles: 'api/SubrentalOutputDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailCapture: 'api/SubrentalOutputDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForDetailConsultation: 'api/SubrentalOutputDetail/GetColumnsForDetailConsultationAsync',
    GetListStocksInShop: 'api/SubrentalOutputDetail/GetListStocksInShopAsync',
    GetStocksByArticleIdStoreId: 'api/SubrentalOutputDetail/GetStocksByArticleIdStoreIdAsync',
    GetSubrentalOutputDetailById: 'api/SubrentalOutputDetail/GetByIdAsync',
    GetSubrentalOutputDetailByKeys: 'api/SubrentalOutputDetail/GetSubrentalOutputDetailByKeysAsync',
    GetSubrentalOutputDetailByOutputId: 'api/SubrentalOutputDetail/GetSubrentalOutputDetailsByOutputIdAsync',
    GetSubrentalOutputDetailsForCapture: 'api/SubrentalOutputDetail/GetSubrentalOutputDetailsForCapture',
    GetSubrentalOutputDetailsForDetailConsultation: 'api/SubrentalOutputDetail/GetSubrentalOutputDetailsForDetailConsultation',
    UpdateSubrentalOutputDetail: 'api/SubrentalOutputDetail/UpdateAsync',
  },
  subrentalReport: {
    ExportSubrentalReportItemPreinvoicedValue: 'api/SubrentalReport/ExportSubrentalReportItemPreinvoicedValue',
    ExportSubrentalReportItemUtility: 'api/SubrentalReport/ExportSubrentalReportItemUtility',
    SubrentalReportItemPreinvoicedValue: 'api/SubrentalReport/SubrentalReportItemPreinvoicedValue',
    SubrentalReportItemUtility: 'api/SubrentalReport/SubrentalReportItemUtility',
  },
  suspension: {
    AnnulSuspension: 'api/Suspension/AnnulSuspensionAsync',
    BlockSuspension: 'api/Suspension/BlockSuspensionAsync',
    CreateSuspension: 'api/Suspension/CreateAsync',
    DeleteSuspension: 'api/Suspension/DeleteAsync',
    ExportGeneralConsultation: 'api/Suspension/ExportGeneralConsultation',
    ExportInvoiceForSuspensionConsultation: 'api/Suspension/ExportInvoiceForSuspensionConsultation',
    GetAllCostCentersForSelect: 'api/Suspension/GetAllCostCentersForSelectAsync',
    GetAllInvoiceForSuspensionsWithPagination: 'api/Suspension/GetAllInvoiceForSuspensionsWithPaginationAsync',
    GetAllSuspensionsWithPagination: 'api/Suspension/GetAllSuspensionsWithPaginationAsync',
    GetAllClientsForSelectAsync: 'api/Suspension/GetAllClientsForSelectAsync',
    GetColumnsForGeneralConsultation: 'api/Suspension/GetColumnsForGeneralConsultationAsync',
    GetColumnsForInvoiceConsultationAsync: 'api/Suspension/GetColumnsForInvoiceConsultationAsync',
    GetCostCenterByIdForRegisterSuspension: 'api/Suspension/GetCostCenterByIdForRegisterSuspensionAsync',
    GetRentalPeriodForRegisterSuspension: 'api/Suspension/GetRentalPeriodForRegisterSuspensionAsync',
    GetEmptySuspensionPrint: 'api/Suspension/GetEmptySuspensionPrint',
    GetFirstSuspensionByKeys: 'api/Suspension/GetFirstSuspensionByKeysAsync',
    GetIndicatorsForGeneralConsultationAsync: 'api/Suspension/GetIndicatorsForGeneralConsultationAsync',
    GetLastSuspensionByKeys: 'api/Suspension/GetLastSuspensionByKeysAsync',
    GetNextSuspensionByKeys: 'api/Suspension/GetNextSuspensionByKeysAsync',
    GetPermissionPrint: 'api/Suspension/GetPermissionPrintAsync',
    GetPreviusSuspensionByKeys: 'api/Suspension/GetPreviusSuspensionByKeysAsync',
    GetSuspensionById: 'api/Suspension/GetByIdAsync',
    GetSuspensionByKeys: 'api/Suspension/GetSuspensionByKeysAsync',
    GetSuspensionByKeysByPrintAsync: 'api/Suspension/GetSuspensionByKeysByPrintAsync',
    SetSuspensionState: 'api/Suspension/SetSuspensionStateAsync',
    UpdateSuspension: 'api/Suspension/UpdateAsync',
    PrintSuspensionAsync: 'api/Suspension/PrintSuspensionAsync',
  },
  suspensionDetail: {
    CreateSomeDetails: 'api/SuspensionDetail/CreateSomeDetailsAsync',
    DeleteSomeDetails: 'api/SuspensionDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/SuspensionDetail/ExportDetailConsultation',
    GetAllSuspensionDetailsWithPagination: 'api/SuspensionDetail/GetAllSuspensionDetailsWithPaginationAsync',
    GetColumnsForDetailCapture: 'api/SuspensionDetail/GetColumnsForDetailCaptureAsync',
    GetColumnsForDetailConsultation: 'api/SuspensionDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForStocksInCostCenter: 'api/SuspensionDetail/GetColumnsForStocksInCostCenterAsync',
    GetStocksInCostCenterForSuspensionId: 'api/SuspensionDetail/GetStocksInCostCenterForSuspensionIdWithPagination',
    GetSuspensionDetailById: 'api/SuspensionDetail/GetByIdAsync',
    GetSuspensionDetailBySuspensionId: 'api/SuspensionDetail/GetSuspensionDetailsBySuspensionIdAsync',
    GetSuspensionDetailsBySuspension: 'api/SuspensionDetail/GetSuspensionsDetailsBySuspensionIdWithPagination',
    UpdateSuspensionDetail: 'api/SuspensionDetail/UpdateAsync',
    GetSuspensionDetailByKeysAsync: 'api/SuspensionDetail/GetSuspensionDetailByKeysAsync',
  },
  tax: {
    CreateTax: 'api/Tax/CreateAsync',
    DeleteTax: 'api/Tax/DeleteAsync',
    DownloadGuideImport: 'api/Tax/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Tax/ExportGeneralConsultation',
    ExportImportErrors: 'api/Tax/ExportImportErrors',
    GetAllTaxesWithPaginationAsync: 'api/Tax/GetAllTaxesWithPaginationAsync',
    GetAllTypesForSelectAsync: 'api/Tax/GetAllTypesForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Tax/GetColumnsForGeneralConsultationAsync',
    GetColumnsForTaxesAsync: 'api/Tax/GetColumnsForTaxesAsync',
    GetIvaTaxes: 'api/Tax/GetIvaTaxesAsync',
    GetRtfTaxes: 'api/Tax/GetRtfTaxesAsync',
    GetTaxAndTypeByIdAsync: 'api/Tax/GetTaxAndTypeByIdAsync',
    GetTaxByCode: 'api/Tax/GetTaxByCodeAsync',
    GetTaxById: 'api/Tax/GetByIdAsync',
    GetTaxesForModalAsync: 'api/Tax/GetTaxesForModalAsync',
    ImportTaxesAsync: 'api/Tax/ImportTaxesAsync',
    UpdateTax: 'api/Tax/UpdateAsync',
  },
  mandator: {
    CreateMandatorAsync: 'api/Mandator/CreateAsync',
    DeleteMandatorAsync: 'api/Mandator/DeleteAsync',
    DeleteSomeAsync: 'api/Mandator/DeleteSomeAsync',
    ExportGeneralConsultation: 'api/Mandator/ExportGeneralConsultation',
    GetByIdAsync: 'api/Mandator/GetByIdAsync',
    GetColumnsForSelection: 'api/Mandator/GetColumnsForSelection',
    GetMandatorsForSelectionAsync: 'api/Mandator/GetMandatorsForSelectionAsync',
    UpdateMandatorAsync: 'api/Mandator/UpdateAsync',
  },
  taxType: {
    CreateTaxType: 'api/TaxType/CreateAsync',
    DeleteTaxType: 'api/TaxType/DeleteAsync',
    GetAllJurisdictionsForSelectAsync: 'api/TaxType/GetAllJurisdictionsForSelectAsync',
    GetAllTaxTypesByCountryId: 'api/TaxType/GetAllTaxTypesByCountryIdAsync',
    GetAllTaxTypes: 'api/TaxType/GetAllTaxTypeAsync',
    GetColumnsForConsultation: 'api/TaxType/GetColumnsForConsultation',
    GetTaxTypeById: 'api/TaxType/GetByIdAsync',
    GetTaxTypeByCode: 'api/TaxType/GetTaxTypeByCodeAsync',
    GetTaxTypesForConsultation: 'api/TaxType/GetTaxTypesForConsultation',
    UpdateTaxType: 'api/TaxType/UpdateAsync',
  },
  transactionsByCompany: {
    ExportTransactionsByCompany: 'api/TransactionsByCompany/ExportTransactionsByCompany',
    ExportTransactionsByUserAutheticated: 'api/TransactionsByCompany/ExportTransactionsByUserAutheticated',
    GetTransactionsByCompany: 'api/TransactionsByCompany/GetTransactionsByCompany',
    GetTransactionsByUserAutheticated: 'api/TransactionsByCompany/GetTransactionsByUserAutheticated',
  },
  log: {
    GetAllWithPaginationAsync: 'api/Log/GetAllWithPaginationAsync',
    GetColumnsForGeneralConsultation: 'api/Log/GetColumnsForGeneralConsultation',
  },
  transferStoreWorkshop: {
    AnnulAsync: 'api/TransferStoreWorkshop/AnnulAsync',
    BlockAsync: 'api/TransferStoreWorkshop/BlockAsync',
    ChangeStateAsync: 'api/TransferStoreWorkshop/ChangeStateAsync',
    CreateAsync: 'api/TransferStoreWorkshop/CreateAsync',
    DeleteAsync: 'api/TransferStoreWorkshop/DeleteAsync',
    ExportGeneralConsultation: 'api/TransferStoreWorkshop/ExportGeneralConsultation',
    GetAllTransferStoreWorkshopsWithPaginationAsync: 'api/TransferStoreWorkshop/GetAllTransferStoreWorkshopsWithPaginationAsync',
    GetByIdAsync: 'api/TransferStoreWorkshop/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/TransferStoreWorkshop/GetColumnsForGeneralConsultationAsync',
    GetFirstTransferStoreWorkshopByKeys: 'api/TransferStoreWorkshop/GetFirstTransferStoreWorkshopByKeysAsync',
    GetEmptyTransferStoreWorkshopPrint: 'api/TransferStoreWorkshop/GetEmptyTransferStoreWorkshopPrint',
    GetLastTransferStoreWorkshopByKeys: 'api/TransferStoreWorkshop/GetLastTransferStoreWorkshopByKeysAsync',
    GetNextTransferStoreWorkshopByKeys: 'api/TransferStoreWorkshop/GetNextTransferStoreWorkshopByKeysAsync',
    GetPermissionPrint: 'api/TransferStoreWorkshop/GetPermissionPrintAsync',
    GetPreviusTransferStoreWorkshopByKeys: 'api/TransferStoreWorkshop/GetPreviusTransferStoreWorkshopByKeysAsync',
    GetTransferStoreWorkshopByKeysByPrintAsync: 'api/TransferStoreWorkshop/GetTransferStoreWorkshopByKeysByPrintAsync',
    GetTransferStoreWorkshopByKeys: 'api/TransferStoreWorkshop/GetTransferStoreWorkshopByKeysAsync',
    HasExistingTransferStoreWorkshopAsync: 'api/TransferStoreWorkshop/HasExistingTransferStoreWorkshopAsync',
    UpdateAsync: 'api/TransferStoreWorkshop/UpdateAsync',
  },
  transferStoreWorkshopDetail: {
    CreateAsync: 'api/TransferStoreWorkshopDetail/CreateAsync',
    CreateDetailsAsync: 'api/TransferStoreWorkshopDetail/CreateDetailsAsync',
    DeleteAsync: 'api/TransferStoreWorkshopDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/TransferStoreWorkshopDetail/DeleteSomeDetailsAsync',
    DownloadGuideImport: 'api/TransferStoreWorkshopDetail/DownloadGuideImport',
    DownloadGuideImportTransferStoreWorkshop: 'api/TransferStoreWorkshopDetail/DownloadGuideImportTransferStoreWorkshop',
    ExportImportErrors: 'api/TransferStoreWorkshopDetail/ExportImportErrors',
    ExportDetailConsultation: 'api/TransferStoreWorkshopDetail/ExportDetailConsultation',
    GetAllTransferStoreWorkshopDetailsWithPaginationAsync: 'api/TransferStoreWorkshopDetail/GetAllTransferStoreWorkshopDetailsWithPaginationAsync',
    GetDetailsForCaptureAsync: 'api/TransferStoreWorkshopDetail/GetDetailsForCaptureAsync',
    GetByIdAsync: 'api/TransferStoreWorkshopDetail/GetByIdAsync',
    GetColumnsForDetailConsultationAsync: 'api/TransferStoreWorkshopDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForCaptureAsync: 'api/TransferStoreWorkshopDetail/GetColumnsForCaptureAsync',
    GetColumnsForShopStockAsync: 'api/TransferStoreWorkshopDetail/GetColumnsForShopStockAsync',
    GetDetailsByTransferStoreWorkshopIdAsync: 'api/TransferStoreWorkshopDetail/GetDetailsByTransferStoreWorkshopIdAsync',
    GetListStocksInCostCenter: 'api/TransferStoreWorkshopDetail/GetListStocksInCostCenterAsync',
    GetStocksInCostCenterWithPaginationAsync: 'api/TransferStoreWorkshopDetail/GetStocksInCostCenterWithPaginationAsync',
    GetStocksByArticleIdStoreId: 'api/TransferStoreWorkshopDetail/GetStocksByArticleIdStoreIdAsync',
    GetTransferStoreWorkshopDetailByKeysAsync: 'api/TransferStoreWorkshopDetail/GetTransferStoreWorkshopDetailByKeysAsync',
    ImportTransferDetailsAsync: 'api/TransferStoreWorkshopDetail/ImportTransferDetailsAsync',
    ImportStoreBalancesAsync: 'api/TransferStoreWorkshopDetail/ImportStoreBalanceAsync',
    UpdateAsync: 'api/TransferStoreWorkshopDetail/UpdateAsync',
  },
  transferWorkshopStore: {
    AnnulAsync: 'api/TransferWorkshopStore/AnnulAsync',
    BlockAsync: 'api/TransferWorkshopStore/BlockAsync',
    ChangeStateAsync: 'api/TransferWorkshopStore/ChangeStateAsync',
    CreateAsync: 'api/TransferWorkshopStore/CreateAsync',
    DeleteAsync: 'api/TransferWorkshopStore/DeleteAsync',
    ExportGeneralConsultation: 'api/TransferWorkshopStore/ExportGeneralConsultation',
    GetAllTransferWorkshopStoresWithPaginationAsync: 'api/TransferWorkshopStore/GetAllTransferWorkshopStoresWithPaginationAsync',
    GetByIdAsync: 'api/TransferWorkshopStore/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/TransferWorkshopStore/GetColumnsForGeneralConsultationAsync',
    GetFirstTransferWorkshopStoreByKeysAsync: 'api/TransferWorkshopStore/GetFirstTransferWorkshopStoreByKeysAsync',
    GetEmptyTransferWorkshopStorePrint: 'api/TransferWorkshopStore/GetEmptyTransferWorkshopStorePrint',
    GetLastTransferWorkshopStoreByKeysAsync: 'api/TransferWorkshopStore/GetLastTransferWorkshopStoreByKeysAsync',
    GetNextTransferWorkshopStoreByKeysAsync: 'api/TransferWorkshopStore/GetNextTransferWorkshopStoreByKeysAsync',
    GetPermissionPrintAsync: 'api/TransferWorkshopStore/GetPermissionPrintAsync',
    GetPreviusTransferWorkshopStoreByKeysAsync: 'api/TransferWorkshopStore/GetPreviusTransferWorkshopStoreByKeysAsync',
    GetTransferWorkshopStoreByKeysAsync: 'api/TransferWorkshopStore/GetTransferWorkshopStoreByKeysAsync',
    GetTransferWorkshopStoreByKeysByPrintAsync: 'api/TransferWorkshopStore/GetTransferWorkshopStoreByKeysByPrintAsync',
    HasExistingTransferWorkshopStoreAsync: 'api/TransferWorkshopStore/HasExistingTransferWorkshopStoreAsync',
    UpdateAsync: 'api/TransferWorkshopStore/UpdateAsync',
  },
  transferWorkshopStoreDetail: {
    CreateAsync: 'api/TransferWorkshopStoreDetail/CreateAsync',
    CreateDetailsAsync: 'api/TransferWorkshopStoreDetail/CreateDetailsAsync',
    DeleteAsync: 'api/TransferWorkshopStoreDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/TransferWorkshopStoreDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/TransferWorkshopStoreDetail/ExportDetailConsultation',
    GetAllTransferWorkshopStoreDetailsWithPaginationAsync: 'api/TransferWorkshopStoreDetail/GetAllTransferWorkshopStoreDetailsWithPaginationAsync',
    GetDetailsForCaptureAsync: 'api/TransferWorkshopStoreDetail/GetDetailsForCaptureAsync',
    GetByIdAsync: 'api/TransferWorkshopStoreDetail/GetByIdAsync',
    GetColumnsForDetailConsultationAsync: 'api/TransferWorkshopStoreDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForCaptureAsync: 'api/TransferWorkshopStoreDetail/GetColumnsForCaptureAsync',
    GetColumnsForShopStockAsync: 'api/TransferWorkshopStoreDetail/GetColumnsForShopStockAsync',
    GetDetailsByTransferWorkshopStoreIdAsync: 'api/TransferWorkshopStoreDetail/GetDetailsByTransferWorkshopStoreIdAsync',
    GetListStocksInCostCenterAsync: 'api/TransferWorkshopStoreDetail/GetListStocksInCostCenterAsync',
    GetStocksInCostCenterWithPaginationAsync: 'api/TransferWorkshopStoreDetail/GetStocksInCostCenterWithPaginationAsync',
    GetStocksByArticleIdStoreIdAsync: 'api/TransferWorkshopStoreDetail/GetStocksByArticleIdStoreIdAsync',
    GetTransferWorkshopStoreDetailByKeysAsync: 'api/TransferWorkshopStoreDetail/GetTransferWorkshopStoreDetailByKeysAsync',
    UpdateAsync: 'api/TransferWorkshopStoreDetail/UpdateAsync',
  },
  transporter: {
    CreateTransporter: 'api/transporter/CreateAsync',
    DeleteTransporter: 'api/transporter/DeleteAsync',
    DownloadGuideImport: 'api/transporter/DownloadGuideImport',
    ExportGeneralConsultation: 'api/transporter/ExportGeneralConsultation',
    ExportImportErrors: 'api/transporter/ExportImportErrors',
    GetAllTransportersForSelectAsync: 'api/transporter/GetAllTransportersForSelectAsync',
    GetAllTransportersWithPaginationAsync: 'api/transporter/GetAllTransportersWithPaginationAsync',
    GetAllTypeDocumentsForSelectAsync: 'api/transporter/GetAllTypeDocumentsForSelectAsync',
    GetDigitVerification: 'api/transporter/GetDigitVerificationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/transporter/GetColumnsForGeneralConsultationAsync',
    GetTransporterByDocumentAsync: 'api/transporter/GetTransporterByDocumentAsync',
    GetTransporterByBranchId: 'api/transporter/GetTransporterByBranchIdAsync',
    GetTransporterById: 'api/transporter/GetByIdAsync',
    GetTransporterByName: 'api/transporter/GetTransporterByNameAsync',
    SetActiveTransporter: 'api/transporter/SetActive',
    ImportTransporter: 'api/transporter/ImportTransportersAsync',
    UpdateTransporter: 'api/transporter/UpdateAsync',
    UpdateTransporterDocument: 'api/transporter/UpdateTransporterDocumentAsync',
  },
  transportInvoice: {
    CreateTransportInvoice: 'api/TransportInvoice/CreateAsync',
    DeleteTransportInvoice: 'api/TransportInvoice/DeleteAsync',
    ExportGeneralConsultation: 'api/TransportInvoice/ExportGeneralConsultation',
    GetAllTransportInvoicesWithPaginationAsync: 'api/TransportInvoice/GetAllTransportInvoicesWithPaginationAsync',
    GetTransportInvoiceById: 'api/TransportInvoice/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/TransportInvoice/GetColumnsForGeneralConsultationAsync',
    GetDigitVerificationAsync: 'api/TransportInvoice/GetDigitVerificationAsync',
    GetTransportInvoiceByKeysAsync: 'api/TransportInvoice/GetTransportInvoicByKeysAsync',
    GetFirstTransportInvoiceByKeys: 'api/TransportInvoice/GetFirstTransportInvoiceByKeysAsync',
    GetLastTransportInvoiceByKeys: 'api/TransportInvoice/GetLastTransportInvoiceByKeysAsync',
    GetNextTransportInvoiceByKeys: 'api/TransportInvoice/GetNextTransportInvoiceByKeysAsync',
    GetPreviusTransportInvoiceByKeys: 'api/TransportInvoice/GetPreviusTransportInvoiceByKeysAsync',
    SetActiveTransportInvoice: 'api/TransportInvoice/SetActive',
    UpdateTransportInvoice: 'api/TransportInvoice/UpdateAsync',
  },
  transportInvoiceDetail: {
    GetColumnsForDetailAsync: 'api/TransportInvoiceDetail/GetColumnsForDetailAsync',
    GetColumnsForSelectionAsync: 'api/TransportInvoiceDetail/GetColumnsForSelectionAsync',
    GetColumnsForDetailConsultationAsync: 'api/TransportInvoiceDetail/GetColumnsForDetailConsultationAsync',
    GetDocumentsSelectionWithPaginationAsync: 'api/TransportInvoiceDetail/GetDocumentsSelectionWithPaginationAsync',
    GetTransportInvoicesDetailWithPaginationAsync: 'api/TransportInvoiceDetail/GetTransportInvoicesDetailWithPaginationAsync',
    GetTransportInvoicesDetailsForDetailConsultation: 'api/TransportInvoiceDetail/GetTransportInvoicesDetailsForDetailConsultation',
    AddDocumentsToTransporInvoiceAsync: 'api/TransportInvoiceDetail/AddDocumentsToTransporInvoiceAsync',
    DeleteSomeDetailsAsync: 'api/TransportInvoiceDetail/DeleteSomeDetailsAsync',
    ExportDetailConsultation: 'api/TransportInvoiceDetail/ExportDetailConsultation',
    UpdateAsync: 'api/TransportInvoiceDetail/UpdateAsync',
  },
  transferConstructionSite: {
    ConfirmTransferConstructionSite: 'api/TransferConstructionSite/ConfirmTransferConstructionSite',
    GetColumnsForGeneralConsultation: 'api/TransferConstructionSite/GetColumnsForGeneralConsultationAsync',
    GetAlltransferConstructionSitesWithPagination: 'api/TransferConstructionSite/GetAllTransferConstructionsSitesWithPaginationAsync',
    ExportGeneralConsultation: 'api/TransferConstructionSite/ExportGeneralConsultation',
    GetTransferConstructionSiteById: 'api/TransferConstructionSite/GetByIdAsync',
    CreateTransferConstructionSite: 'api/TransferConstructionSite/CreateAsync',
    UpdateTransferConstructionSite: 'api/TransferConstructionSite/UpdateAsync',
    DeleteTransferConstructionSite: 'api/TransferConstructionSite/DeleteAsync',
    SetTransferConstructionSiteState: 'api/TransferConstructionSite/SetTransferConstructionSiteStateAsync',
    GetTransferConstructionSiteByKeys: 'api/TransferConstructionSite/GetTransferConstructionSiteByKeysAsync',
    GetFirstTransferConstructionSiteByKeys: 'api/TransferConstructionSite/GetFirstTransferConstructionSiteByKeysAsync',
    GetNextTransferConstructionSiteByKeys: 'api/TransferConstructionSite/GetNextTransferConstructionSiteByKeysAsync',
    GetLastTransferConstructionSiteByKeys: 'api/TransferConstructionSite/GetLastTransferConstructionSiteByKeysAsync',
    GetPreviusTransferConstructionSiteByKeys: 'api/TransferConstructionSite/GetPreviusTransferConstructionSiteByKeysAsync',
    AnnulTransferConstructionSite: 'api/TransferConstructionSite/AnnulTransferConstructionSiteAsync',
    GetAllCostCenterForOriginSelectAsync: 'api/TransferConstructionSite/GetAllCostCenterForOriginSelectAsync',
    GetAllCostCenterForDestinitySelectAsync: 'api/TransferConstructionSite/GetAllCostCenterForDestinitySelectAsync',
    GetAllTransporterForSelectAsync: 'api/TransferConstructionSite/GetAllTransporterForSelectAsync',
    GetAllBranchesForSelectAsync: 'api/TransferConstructionSite/GetAllBranchesForSelectAsync',
    GetAllVehicleForSelectAsync: 'api/TransferConstructionSite/GetAllVehicleForSelectAsync',
    GetClientsForSelectAsync: 'api/TransferConstructionSite/GetClientsForSelectAsync',
    GetPermission: 'api/TransferConstructionSite/GetPermissionAsync',
    GetClientByCostCenterIdAsync: 'api/TransferConstructionSite/GetClientByCostCenterIdAsync',
    GetRentalPeriodByIdForRegisterInvoiceAsync: 'api/TransferConstructionSite/GetRentalPeriodByIdForRegisterInvoiceAsync',
    GetPermissionPrint: 'api/TransferConstructionSite/GetPermissionPrintAsync',
    HowManyTranfersInTransitByUserAuthenticated: 'api/TransferConstructionSite/HowManyTranfersInTransitByUserAuthenticated',
    PrintTransferConstructionSite: 'api/TransferConstructionSite/PrintTransferConstructionSite',
  },
  transferConstructionSiteDetail: {
    CreateDetailsAsync: 'api/transferConstructionSiteDetail/CreateDetailsAsync',
    CreateCostCenterPriceDestinyByOrigin: 'api/transferConstructionSiteDetail/CreateCostCenterPriceDestinyByOrigin',
    CreateTransferConstructionSiteDetail: 'api/transferConstructionSiteDetail/CreateAsync',
    DeleteSomeDetails: 'api/transferConstructionSiteDetail/DeleteSomeDetailsAsync',
    DeleteTransferConstructionSiteDetail: 'api/transferConstructionSiteDetail/DeleteAsync',
    ExportDetailConsultation: 'api/transferConstructionSiteDetail/ExportDetailConsultation',
    GetAllTransferConstructionSiteDetailsWithPagination: 'api/transferConstructionSiteDetail/GetAllTransferConstructionsSitesDetailsWithPaginationAsync',
    GetArticlesForDetailsAsync: 'api/transferConstructionSiteDetail/GetArticlesForDetailsAsync',
    GetColumnsForArticles: 'api/transferConstructionSiteDetail/GetColumnsForArticlesAsync',
    GetColumnsForDetailConsultation: 'api/transferConstructionSiteDetail/GetColumnsForDetailConsultationAsync',
    GetColumnsForDetailsTransferConstructionSiteAsync: 'api/transferConstructionSiteDetail/GetColumnsForDetailsTransferConstructionSiteAsync',
    GetTransferConstructionSiteDetailById: 'api/transferConstructionSiteDetail/GetByIdAsync',
    GetTransferConstructionSiteDetailByKeys: 'api/transferConstructionSiteDetail/GetTransferConstructionSiteDetailByKeysAsync',
    GetStocksByArticleIdStoreId: 'api/transferConstructionSiteDetail/GetStocksByArticleIdStoreIdAsync',
    GetTransferDetailsByTransferIdWithPagination: 'api/transferConstructionSiteDetail/GetTransferDetailsByTransferIdWithPagination',
    GetListStocksInCostCenter: 'api/transferConstructionSiteDetail/GetListStocksInCostCenterAsync',
    GetListStocksInCostCenterByArticle: 'api/transferConstructionSiteDetail/GetListStocksInCostCenterByArticleAsync',
    UpdateTransferConstructionSiteDetail: 'api/transferConstructionSiteDetail/UpdateAsync',
  },
  typeArticle: {
    GetTypeInventory: 'api/TypeArticle/GetTypeInventory',
  },
  typeConcept: {
    CreateTypeConcept: 'api/TypeConcept/CreateAsync',
    DeleteTypeConcept: 'api/TypeConcept/DeleteAsync',
    GetAllTypeConcept: 'api/TypeConcept/GetAllTypeConceptAsync',
    GetColumnsForConsultation: 'api/TypeConcept/GetColumnsForConsultation',
    GetTypeConceptpById: 'api/TypeConcept/GetByIdAsync',
    GetTypeConceptByCode: 'api/TypeConcept/GetTypeConceptByCodeAsync',
    GetTypeConceptsForConsultation: 'api/TypeConcept/GetTypeConceptsForConsultation',
    UpdateTypeConcept: 'api/TypeConcept/UpdateAsync',
  },
  typeInventory: {
    GetAllTypeInventory: 'api/TypeInventory/GetAllTypesInventoryAsync',
    CreateTypeInventory: 'api/TypeInventory/CreateAsync',
    UpdateTypeInventory: 'api/TypeInventory/UpdateAsync',
    DeleteTypeInventory: 'api/TypeInventory/DeleteAsync',
    GetByIdAsync: 'api/TypeInventory/GetByIdAsync',
    GetTypeInventoryByCode: 'api/TypeInventory/GetTypeInventoryByCodeAsync',
    GetColumnsForConsultation: 'api/TypeInventory/GetColumnsForConsultation',
    GetTypeInventoriesForConsultation: 'api/TypeInventory/GetTypeInventoriesForConsultation',
  },
  updateCostCenterPrice: {
    CreateAsync: 'api/UpdateCostCenterPrice/CreateAsync',
    DeleteAsync: 'api/UpdateCostCenterPrice/DeleteAsync',
    GetByIdAsync: 'api/UpdateCostCenterPrice/GetByIdAsync',
    GetUpdateCostCenterPriceByKeysAsync: 'api/UpdateCostCenterPrice/GetUpdateCostCenterPriceByKeysAsync',
    GetFirstUpdateCostCenterPriceByKeysAsync: 'api/UpdateCostCenterPrice/GetFirstUpdateCostCenterPriceByKeysAsync',
    GetLastUpdateCostCenterPriceByKeysAsync: 'api/UpdateCostCenterPrice/GetLastUpdateCostCenterPriceByKeysAsync',
    GetNextUpdateCostCenterPriceByKeysAsync: 'api/UpdateCostCenterPrice/GetNextUpdateCostCenterPriceByKeysAsync',
    GetPreviusUpdateCostCenterPriceByKeysAsync: 'api/UpdateCostCenterPrice/GetPreviusUpdateCostCenterPriceByKeysAsync',
    ProcessUpdateCostCenterPrice: 'api/UpdateCostCenterPrice/ProcessUpdateCostCenterPrice',
    UpdateAsync: 'api/UpdateCostCenterPrice/UpdateAsync',
  },
  updateCostCenterPriceDetail: {
    CreateAsync: 'api/UpdateCostCenterPriceDetail/CreateAsync',
    CreateDetailsAsync: 'api/UpdateCostCenterPriceDetail/CreateDetailsAsync',
    DeleteAsync: 'api/UpdateCostCenterPriceDetail/DeleteAsync',
    DeleteSomeDetailsAsync: 'api/UpdateCostCenterPriceDetail/DeleteSomeDetailsAsync',
    GetAllCostCentersAsync: 'api/UpdateCostCenterPriceDetail/GetAllCostCentersAsync',
    GetByIdAsync: 'api/UpdateCostCenterPriceDetail/GetByIdAsync',
    GetColumnsForCaptureTableAsync: 'api/UpdateCostCenterPriceDetail/GetColumnsForCaptureTableAsync',
    GetColumnsForCostCentersTableAsync: 'api/UpdateCostCenterPriceDetail/GetColumnsForCostCentersTableAsync',
    GetUpdateCostCenterPriceDetailsForCaptureTableAsync: 'api/UpdateCostCenterPriceDetail/GetUpdateCostCenterPriceDetailsForCaptureTableAsync',
    GetUpdateCostCenterPriceDetailByKeysAsync: 'api/UpdateCostCenterPriceDetail/GetUpdateCostCenterPriceDetailByKeysAsync',
    UpdateAsync: 'api/UpdateCostCenterPriceDetail/UpdateAsync',
  },
  unit: {
    CreateUnit: 'api/Unit/CreateAsync',
    DeleteUnit: 'api/Unit/DeleteAsync',
    ExportGeneralConsultation: 'api/Unit/ExportGeneralConsultation',
    GetAllUnitsWithPaginationAsync: 'api/Unit/GetAllUnitsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Unit/GetColumnsForGeneralConsultationAsync',
    GetInventoryUnits: 'api/Unit/GetInventoryUnitsAsync',
    GetRentalUnits: 'api/Unit/GetRentalUnitsAsync',
    GetUnitByCode: 'api/Unit/GetUnitByCodeAsync',
    GetUnitById: 'api/Unit/GetByIdAsync',
    UpdateUnit: 'api/Unit/UpdateAsync',
  },
  user: {
    GetAllProfilesForSelectAsync: 'api/User/GetAllProfilesForSelectAsync',
    GetUserById: 'api/User/GetByIdAsync',
    CreateUser: 'api/User/CreateAsync',
    UpdateUser: 'api/User/UpdateAsync',
    SetActiveUser: 'api/User/SetActive',
    DeleteUser: 'api/User/DeleteAsync',
    GetUserByUserName: 'api/User/GetUserByUserNameAsync',
    UpdateUserPassword: 'api/User/UpdateUserPasswordAsync',
    UpdateUserAuthenticatedPassword: 'api/User/UpdateUserAuthenticatedPasswordAsync',
    UserAuthenticatedIsADMIN: 'api/User/UserAuthenticatedIsADMINAsync',
    UserAuthenticatedIsASADMIN: 'api/User/UserAuthenticatedIsASADMINAsync',
    UserAuthenticatedIsPrincipalCompany: 'api/User/UserAuthenticatedIsPrincipalCompanyAsync',
    GetUserByBranchId: 'api/User/GetUserByBranchIdAsync',
    GetUserAutheticated: 'api/User/GetUserAutheticated',
    ExportConsultation: 'api/User/ExportConsultation',
    GetColumnsForConsultationAsync: 'api/User/GetColumnsForConsultationAsync',
    GetAllUsersWithPaginationAsync: 'api/User/GetAllUsersWithPaginationAsync',
  },
  vehicle: {
    CreateVehicle: 'api/vehicle/CreateAsync',
    DeleteVehicle: 'api/vehicle/DeleteAsync',
    DownloadGuideImport: 'api/vehicle/DownloadGuideImport',
    ExportGeneralConsultation: 'api/vehicle/ExportGeneralConsultation',
    ExportImportErrors: 'api/vehicle/ExportImportErrors',
    GetAllVehiclesWithPaginationAsync: 'api/vehicle/GetAllVehiclesWithPaginationAsync',
    GetAllConceptsForSelectAsync: 'api/vehicle/GetAllConceptsForSelectAsync',
    GetAllStoresForSelectAsync: 'api/vehicle/GetAllStoresForSelectAsync',
    GetCityDepartmentAsync: 'api/vehicle/GetCityDepartmentAsync',
    GetCitiesForSelectionAsync: 'api/vehicle/GetCitiesForSelectionAsync',
    GetColumnsForCitiesSelectionAsync: 'api/vehicle/GetColumnsForCitiesSelectionAsync',
    GetAllVehiclesForSelectAsync: 'api/vehicle/GetAllVehiclesForSelectAsync',
    GetColumnsForGeneralConsultationAsync: 'api/vehicle/GetColumnsForGeneralConsultationAsync',
    GetFirstVehicleByKeysAsync: 'api/vehicle/GetFirstVehicleByKeysAsync',
    GetLastVehicleByKeysAsync: 'api/vehicle/GetLastVehicleByKeysAsync',
    GetNextVehicleByKeysAsync: 'api/vehicle/GetNextVehicleByKeysAsync',
    GetPreviusVehicleByKeysAsync: 'api/vehicle/GetPreviusVehicleByKeysAsync',
    GetVehicleByCodeAsync: 'api/vehicle/GetVehicleByCodeAsync',
    GetVehicleByBranchId: 'api/vehicle/GetVehicleByBranchIdAsync',
    GetVehicleById: 'api/vehicle/GetByIdAsync',
    ImportVehicles: 'api/vehicle/ImportVehiclesAsync',
    SetActiveVehicle: 'api/vehicle/SetActiveAsync',
    UpdateVehicle: 'api/vehicle/UpdateAsync',
  },
  visit: {
    BlockVisitAsync: 'api/Visit/BlockVisitAsync',
    ChangeStateAsync: 'api/Visit/ChangeStateAsync',
    CreateAsync: 'api/Visit/CreateAsync',
    DeleteAsync: 'api/Visit/DeleteAsync',
    ExportGeneralConsultation: 'api/Visit/ExportGeneralConsultation',
    GetAllConcepsForSelectAsync: 'api/Visit/GetAllConcepsForSelectAsync',
    GetAllPendingVisitsWithPaginationAsync: 'api/Visit/GetAllPendingVisitsWithPaginationAsync',
    GetAllVisitsWithPaginationAsync: 'api/Visit/GetAllVisitsWithPaginationAsync',
    GetByIdAsync: 'api/Visit/GetByIdAsync',
    GetVisitByKeysAsync: 'api/Visit/GetVisitByKeysAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Visit/GetColumnsForGeneralConsultationAsync',
    GetColumnsForPendingVisitsAsync: 'api/Visit/GetColumnsForPendingVisitsAsync',
    GetFirstVisitByKeys: 'api/Visit/GetFirstVisitByKeysAsync',
    GetLastVisitByKeys: 'api/Visit/GetLastVisitByKeysAsync',
    GetNextVisitByKeys: 'api/Visit/GetNextVisitByKeysAsync',
    GetPermissionAsync: 'api/Visit/GetPermissionAsync',
    GetPreviusVisitByKeys: 'api/Visit/GetPreviusVisitByKeysAsync',
    UpdateAsync: 'api/Visit/UpdateAsync',
  },
  voucher: {
    GetVouchersByAccountingInterface: 'api/Voucher/GetVouchersByAccountingInterfaceAsync',
    GetVouchersByAccountingInterfaceId: 'api/Voucher/GetVouchersByAccountingInterfaceIdAsync',
    Recalculate: 'api/Voucher/RecalculateAsync',
  },
  walletBalance: {
    ProcessWalletBalance: 'api/WalletBalance/ProcessWalletBalanceAsync',
  },
  walletManagement: {
    CreateAsync: 'api/WalletManagement/CreateAsync',
    DeleteAsync: 'api/WalletManagement/DeleteAsync',
    ExportGeneralConsultation: 'api/WalletManagement/ExportGeneralConsultation',
    GetAllClientsForSelectAsync: 'api/WalletManagement/GetAllClientsForSelectAsync',
    GetAllWalletManagementsWithPaginationAsync: 'api/WalletManagement/GetAllWalletManagementsWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/WalletManagement/GetColumnsForGeneralConsultationAsync',
    GetByIdAsync: 'api/WalletManagement/GetByIdAsync',
    GetFirstWalletManagementByKeysAsync: 'api/WalletManagement/GetFirstWalletManagementByKeysAsync',
    GetLastWalletManagementByKeysAsync: 'api/WalletManagement/GetLastWalletManagementByKeysAsync',
    GetNextWalletManagementByKeysAsync: 'api/WalletManagement/GetNextWalletManagementByKeysAsync',
    GetPreviusWalletManagementByKeysAsync: 'api/WalletManagement/GetPreviusWalletManagementByKeysAsync',
    GetWalletManagementByConsecutiveAsync: 'api/WalletManagement/GetWalletManagementByConsecutiveAsync',
    SetStateWalletManagement: 'api/WalletManagement/SetWalletManagementStateAsync',
    UpdateAsync: 'api/WalletManagement/UpdateAsync',
  },
  walletManagementDetail: {
    CreateAsync: 'api/WalletManagementDetail/CreateAsync',
    DeleteAsync: 'api/WalletManagementDetail/DeleteAsync',
    GetAllWalletManagementDetailsAsync: 'api/WalletManagementDetail/GetAllWalletManagementDetailsAsync',
    GetByIdAsync: 'api/WalletManagementDetail/GetByIdAsync',
    GetByWalletManagementIdAsync: 'api/WalletManagementDetail/GetByWalletManagementIdAsync',
    GetColumnsForDetailCaptureAsync: 'api/WalletManagementDetail/GetColumnsForDetailCaptureAsync',
    GetWalletManagementDetailsForCaptureTableAsync: 'api/WalletManagementDetail/GetWalletManagementDetailsForCaptureTableAsync',
  },
  walletReport: {
    ExportWalletReportCollectionBySeller: 'api/WalletReport/ExportWalletReportCollectionBySeller',
    ExportWalletReportDetailedAccountStatement: 'api/WalletReport/ExportWalletReportDetailedAccountStatement',
    ExportWalletReportGeneratedReceipts: 'api/WalletReport/ExportWalletReportGeneratedReceipts',
    ExportWalletReportPaymentsByClient: 'api/WalletReport/ExportWalletReportPaymentsByClient',
    ExportWalletReportSummaryAccountStatement: 'api/WalletReport/ExportWalletReportSummaryAccountStatement',
    ExportWalletReportTotalIncomePerMonth: 'api/WalletReport/ExportWalletReportTotalIncomePerMonth',
    ExportWalletReportWallet: 'api/WalletReport/ExportWalletReportWallet',
    ExportWalletReportWalletBalance: 'api/WalletReport/ExportWalletReportWalletBalance',
    GetAllIncomeConceptsByBranchForSelectAsync: 'api/WalletReport/GetAllIncomeConceptsByBranchForSelectAsync',
    GetAllInvoiceWalletTypesForSelectAsync: 'api/WalletReport/GetAllInvoiceWalletTypesForSelectAsync',
    WalletReportCollectionBySeller: 'api/WalletReport/WalletReportCollectionBySeller',
    WalletReportDetailedAccountStatement: 'api/WalletReport/WalletReportDetailedAccountStatement',
    WalletReportGeneratedReceipts: 'api/WalletReport/WalletReportGeneratedReceipts',
    WalletReportPaymentsByClient: 'api/WalletReport/WalletReportPaymentsByClient',
    WalletReportSummaryAccountStatement: 'api/WalletReport/WalletReportSummaryAccountStatement',
    WalletReportTotalIncomePerMonth: 'api/WalletReport/WalletReportTotalIncomePerMonth',
    WalletReportWallet: 'api/WalletReport/WalletReportWallet',
    WalletReportWalletBalance: 'api/WalletReport/WalletReportWalletBalance',
  },
  wayToPay: {
    CreateWayToPay: 'api/WayToPay/CreateAsync',
    DeleteWayToPay: 'api/WayToPay/DeleteAsync',
    ExportGeneralConsultation: 'api/WayToPay/ExportGeneralConsultation',
    GetAllWayToPay: 'api/WayToPay/GetAllWayToPayAsync',
    GetAllWayToPaysWithPaginationAsync: 'api/WayToPay/GetAllWayToPaysWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/WayToPay/GetColumnsForGeneralConsultationAsync',
    GetFirstWayToPayByKeysAsync: 'api/WayToPay/GetFirstWayToPayByKeysAsync',
    GetLastWayToPayByKeysAsync: 'api/WayToPay/GetLastWayToPayByKeysAsync',
    GetNextWayToPayByKeysAsync: 'api/WayToPay/GetNextWayToPayByKeysAsync',
    GetPreviusWayToPayByKeysAsync: 'api/WayToPay/GetPreviusWayToPayByKeysAsync',
    GetWayToPayByCode: 'api/WayToPay/GetWayToPayByCodeAsync',
    GetWayToPayById: 'api/WayToPay/GetByIdAsync',
    UpdateWayToPay: 'api/WayToPay/UpdateAsync',
  },
  window: {
    GetAllWindow: 'api/Window/GetAllWindowsAsync',
    CreateWindow: 'api/Window/CreateAsync',
    GetWindowsByCompany: 'api/Window/GetWindowsByCompanyAsync',
    GetWindowsByCompanyAuthenticated: 'api/Window/GetWindowsByCompanyAuthenticatedAsync',
    GetWindowsByProfileUser: 'api/Window/GetWindowsByProfileUserAsync',
    GetWindowsByUserAuthenticated: 'api/Window/GetWindowsByUserAuthenticatedAsync',
    SaveWindowsByCompany: 'api/Window/SaveWindowsByCompanyAsync',
    SaveWindowsByProfileUser: 'api/Window/SaveWindowsByProfileUserAsync',
    GetPermissionProfileUserByUrl: 'api/Window/GetPermissionProfileUserByUrlAsync',
  },
  workshopEquipment: {
    GetAllWorkshopEquipmentWithPaginationAsync: 'api/WorkshopEquipment/GetAllWorkshopEquipmentWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/WorkshopEquipment/GetColumnsForGeneralConsultationAsync',
    ExportGeneralConsultation: 'api/WorkshopEquipment/ExportGeneralConsultation',
  },
  equipmentAvailability: {
    GetAllEquipmentAvailabilityWithPaginationAsync: 'api/EquipmentAvailability/GetAllEquipmentAvailabilityWithPaginationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/EquipmentAvailability/GetColumnsForGeneralConsultationAsync',
    ExportGeneralConsultation: 'api/EquipmentAvailability/ExportGeneralConsultation',
  },
  consolidatedEquipmentAvailability: {
    GetConsolidatedEquipmentAvailabilityAsync: 'api/ConsolidatedEquipmentAvailability/GetConsolidatedEquipmentAvailabilityAsync',
    GetColumnsForGeneralConsultationAsync: 'api/ConsolidatedEquipmentAvailability/GetColumnsForGeneralConsultationAsync',
    ExportGeneralConsultation: 'api/ConsolidatedEquipmentAvailability/ExportGeneralConsultation',
    GetConsolidatedEquipmentAvailabilityReportAsync: 'api/ConsolidatedEquipmentAvailability/GetConsolidatedEquipmentAvailabilityReportAsync',
  },
  consolidatedReservation: {
    GetConsolidatedReservationAsync: 'api/ConsolidatedReservation/GetConsolidatedReservationAsync',
    GetColumnsForGeneralConsultationAsync: 'api/ConsolidatedReservation/GetColumnsForGeneralConsultationAsync',
    ExportGeneralConsultation: 'api/ConsolidatedReservation/ExportGeneralConsultation',
  },
  zone: {
    CreateZone: 'api/Zone/CreateAsync',
    DeleteZone: 'api/Zone/DeleteAsync',
    DownloadGuideImport: 'api/Zone/DownloadGuideImport',
    ExportGeneralConsultation: 'api/Zone/ExportGeneralConsultation',
    ExportImportErrors: 'api/Zone/ExportImportErrors',
    GetAllSellersForSelect: 'api/Zone/GetAllSellersForSelectAsync',
    GetAllZonesForSelectAsync: 'api/Zone/GetAllZonesForSelectAsync',
    GetAllZonesWithPaginationAsync: 'api/Zone/GetAllZonesWithPaginationAsync',
    GetByIdAsync: 'api/Zone/GetByIdAsync',
    GetColumnsForGeneralConsultationAsync: 'api/Zone/GetColumnsForGeneralConsultationAsync',
    GetFirstZoneByKeysAsync: 'api/Zone/GetFirstZoneByKeysAsync',
    GetLastZoneByKeysAsync: 'api/Zone/GetLastZoneByKeysAsync',
    GetNextZoneByKeysAsync: 'api/Zone/GetNextZoneByKeysAsync',
    GetPreviusZoneByKeysAsync: 'api/Zone/GetPreviusZoneByKeysAsync',
    GetZoneByBranchId: 'api/Zone/GetZoneByBranchIdAsync',
    GetZoneByCode: 'api/Zone/GetZoneByCodeAsync',
    ImportZones: 'api/Zone/ImportZonesAsync',
    UpdateAsync: 'api/Zone/UpdateAsync',
  },
};
